const hitmanRanges = [
    [4045240644369, 4045240694369], // 50000
    [4074788088830, 4074788992678], // 903848
    [4122486178672, 4122604086984], // 117908312
    [9820648928473, 9820648978473], // 50000
    [9820663262865, 9820663312865], // 50000
    [12113915690990, 12114325495909], // 409804919
    [14327929525667, 14327929575667], // 50000
    [14966620169529, 14966620953573], // 784044
    [15871329299331, 15871330278908], // 979577
    [19643788298704, 19643788948704], // 650000
    [21194793243648, 21194793293648], // 50000
    [23122759252787, 23122759575766], // 322979
    [23123185205612, 23123185255612], // 50000
    [24324546771882, 24324546971882], // 200000
    [24324651271883, 24324651789406], // 517523
    [27299868524892, 27299869420972], // 896080
    [28864182592589, 28864199626572], // 17033983
    [30923060551965, 30923061459523], // 907558
    [31842458732042, 31842464346400], // 5614358
    [36160614575587, 36160670575587], // 56000000
    [36897208010266, 36897208060266], // 50000
    [41529661344898, 41530000000000], // 338655102
    [42977769492517, 42977769536262], // 43745
    [43238899075949, 43238899100561], // 24612
    [43238899275949, 43238899325949], // 50000
    [43238899325949, 43238899375949], // 50000
    [43238900325949, 43238900375949], // 50000
    [47016392131216, 47016461186467], // 69055251
    [47782971219203, 47782971269203], // 50000
    [48179588228891, 48179588278891], // 50000
    [49162013535651, 49162474507445], // 460971794
    [49172029809140, 49172029859140], // 50000
    [49172029859140, 49172029909140], // 50000
    [49481527148916, 49481527878730], // 729814
    [49481877225238, 49481878175237], // 949999
    [49523068950000, 49523315201500], // 246251500
    [49916590917991, 49916590967991], // 50000
    [49916590967991, 49916591017991], // 50000
    [49916591601733, 49916591651733], // 50000
    [49916591651733, 49916591701733], // 50000
    [51369103964165, 51369104730161], // 765996
    [52765729289328, 52765729339328], // 50000
    [52768637946367, 52768637996367], // 50000
    [52769655638519, 52769657349932], // 1711413
    [55278845364993, 55278894817648], // 49452655
    [59191827666010, 59191827716010], // 50000
    [65031811737850, 65031811765811], // 27961
    [65031811765811, 65031811815811], // 50000
    [71413126570378, 71413126600430], // 30052
    [71413126750691, 71413126800691], // 50000
    [71413126800691, 71413127050430], // 249739
    [71413223213740, 71413223266240], // 52500
    [71413629434893, 71413632434893], // 3000000
    [72750984489043, 72750984531540], // 42497
    [81627495482169, 81627497264104], // 1781935
    [82710791606145, 82710792053645], // 447500
    [82710854689800, 82710854747130], // 57330
    [82711686244961, 82711686996137], // 751176
    [83796567850000, 83796568800000], // 950000
    [85092468060447, 85092468318373], // 257926
    [85093469186497, 85093469236497], // 50000
    [85094282279603, 85094282329603], // 50000
    [85094720225804, 85094720275804], // 50000
    [91808566500000, 91808567500000], // 1000000
    [96570983411332, 96571386981332], // 403570000
    [96940549924179, 96940549934179], // 10000
    [96941055702055, 96941055752055], // 50000
    [97626629642488, 97626629692488], // 50000
    [101820990636478, 101820991636478], // 1000000
    [103035191009729, 103035191049451], // 39722
    [104919657581542, 104919717532242], // 59950700
    [105227769246184, 105227769438763], // 192579
    [106171745850943, 106171745950943], // 100000
    [106299215176133, 106299216172798], // 996665
    [109589894722227, 109589894772226], // 49999
    [110170401119047, 110170401119048], // 1
    [110172389772809, 110172390016379], // 243570
    [110172860214457, 110172861617342], // 1402885
    [110172861819843, 110172864520354], // 2700511
    [110483954884580, 110483954987412], // 102832
    [111068099947132, 111068100024531], // 77399
    [112360753392862, 112360753405362], // 12500
    [112360815791929, 112360815841929], // 50000
    [113070775547234, 113070775597234], // 50000
    [114592060566700, 114592065566699], // 4999999
    [114592457041558, 114592459796558], // 2755000
    [116133334923962, 116133335008091], // 84129
    [116133403230138, 116133403909176], // 679038
    [116133726470939, 116133733843829], // 7372890
    [117043464708326, 117043465410232], // 701906
    [119587464782146, 119587465656774], // 874628
    [119587850617358, 119588519736990], // 669119632
    [121800476349000, 121800477349000], // 1000000
    [125350334014833, 125350334176047], // 161214
    [126023861785220, 126023861843651], // 58431
    [126031389068907, 126031399168907], // 10100000
    [126031399168907, 126031440068907], // 40900000
    [127174102961658, 127174102967250], // 5592
    [127265301803850, 127265301807816], // 3966
    [127267802089216, 127267802139216], // 50000
    [128768101169133, 128768101219133], // 50000
    [129673642781639, 129673642831639], // 50000
    [129975000000000, 129975541219898], // 541219898
    [135046552612731, 135046562878088], // 10265357
    [135046623886882, 135046623934080], // 47198
    [135046674012466, 135046674161701], // 149235
    [135370202043762, 135370202543762], // 500000
    [136218247583320, 136219076440501], // 828857181
    [136816282982623, 136816283482623], // 500000
    [138100952668983, 138100952728983], // 60000
    [138819573888811, 138819573938811], // 50000
    [138887514110031, 138887514160031], // 50000
    [139019370323523, 139019370431992], // 108469
    [140485644515554, 140485644515555], // 1
    [142105074714017, 142105075214017], // 500000
    [142346013106237, 142346013527034], // 420797
    [143484718257970, 143484718657969], // 399999
    [145171193933999, 145171223933999], // 30000000
    [145808786410000, 145809683000000], // 896590000
    [146214311452872, 146214311502872], // 50000
    [146422030840071, 146422030890071], // 50000
    [147752974011239, 147752974225243], // 214004
    [148388385879113, 148388386879113], // 1000000
    [149334778400000, 149334778450000], // 50000
    [150627815313168, 150627824408168], // 9095000
    [150628293632439, 150628299834508], // 6202069
    [150628990680678, 150628990858178], // 177500
    [152182722388777, 152182722411792], // 23015
    [152182740579500, 152182740629500], // 50000
    [152182752600278, 152182752650278], // 50000
    [152184111282715, 152184111332715], // 50000
    [153125552879881, 153125552990098], // 110217
    [154049501431536, 154049501431537], // 1
    [154390113162190, 154390113212190], // 50000
    [154390114162190, 154390114212190], // 50000
    [155318977124702, 155318977261315], // 136613
    [156486596402891, 156489996402891], // 3400000000
    [156706742000000, 156706993050000], // 251050000
    [156767710827890, 156767710843890], // 16000
    [156767725659890, 156767725683890], // 24000
    [156767736395890, 156767736419890], // 24000
    [156767738819890, 156767738835890], // 16000
    [156767740211890, 156767740227890], // 16000
    [156767744307890, 156767744315890], // 8000
    [156767766051890, 156767766062185], // 10295
    [156931135829741, 156931145779740], // 9949999
    [156931630501641, 156931634501641], // 4000000
    [157987872940317, 157987872990317], // 50000
    [160708370083567, 160708370425086], // 341519
    [160746627868918, 160746685892500], // 58023582
    [161401450502933, 161402656590669], // 1206087736
    [161951501135953, 161951504966737], // 3830784
    [162413003024841, 162413059965441], // 56940600
    [162702767999473, 162702768049473], // 50000
    [164064819460624, 164064822255624], // 2795000
    [164091351963221, 164091359560470], // 7597249
    [164731114853254, 164731114903254], // 50000
    [166205319664618, 166205319664619], // 1
    [166296230077689, 166296230297003], // 219314
    [167682932002701, 167682932052701], // 50000
    [167829210899875, 167829210949875], // 50000
    [168889009995190, 168889010995190], // 1000000
    [168889076172065, 168889076269565], // 97500
    [169643626694427, 169643626703259], // 8832
    [169987912488036, 169988007871136], // 95383100
    [170218349153472, 170218349203472], // 50000
    [171729082837400, 171729084489225], // 1651825
    [171924356022219, 171924356072219], // 50000
    [171924420515440, 171924420565440], // 50000
    [172050248310046, 172050248399527], // 89481
    [173437812734268, 173437813827279], // 1093011
    [173685288102184, 173685691623831], // 403521647
    [174140283022824, 174140283072824], // 50000
    [174140474023152, 174140474073152], // 50000
    [174687233003976, 174687300000000], // 66996024
    [177580978206820, 177580979041529], // 834709
    [177581753006545, 177581753075936], // 69391
    [177582152967834, 177582153017834], // 50000
    [177582153017834, 177582153067834], // 50000
    [177760749242526, 177760750082306], // 839780
    [179293158326351, 179293158376351], // 50000
    [179622040077409, 179622044193695], // 4116286
    [179668638222620, 179668638222621], // 1
    [179668643222620, 179668643222621], // 1
    [179668649237102, 179668649237103], // 1
    [181056616749554, 181056616799554], // 50000
    [181167590827194, 181168016426137], // 425598943
    [181387554386951, 181387555386951], // 1000000
    [182930827475406, 182930828429254], // 953848
    [182930993492159, 182930996593844], // 3101685
    [182931001543844, 182931001593844], // 50000
    [184327145329182, 184327145379182], // 50000
    [184327150763862, 184327150813862], // 50000
    [186182117863958, 186182118245616], // 381658
    [186182935072471, 186182936446360], // 1373889
    [188441062775325, 188441062825325], // 50000
    [188575173559724, 188575174509721], // 949997
    [188575179333825, 188575179383825], // 50000
    [188575179383825, 188575179411413], // 27588
    [189487766135054, 189487766166575], // 31521
    [189526427276466, 189526428720120], // 1443654
    [189945169297865, 189945169347865], // 50000
    [189945274264321, 189945274280363], // 16042
    [189946494498542, 189946494544576], // 46034
    [189947009524498, 189947009685802], // 161304
    [189947444683414, 189947444733414], // 50000
    [190183830189430, 190183830526305], // 336875
    [190184072766131, 190184076024196], // 3258065
    [190184415638320, 190184415638321], // 1
    [190184416138320, 190184416160731], // 22411
    [190184726397921, 190184726919625], // 521704
    [190184963426178, 190184963444857], // 18679
    [190428554070862, 190428554120862], // 50000
    [190708276632702, 190708276797931], // 165229
    [191847457151074, 191847488360277], // 31209203
    [192117946543704, 192117977488453], // 30944749
    [192286563328480, 192286563378480], // 50000
    [193570132000000, 193570133000000], // 1000000
    [195461479877646, 195461480609650], // 732004
    [195461491823721, 195461493572113], // 1748392
    [195461542628208, 195461542815003], // 186795
    [195461571301052, 195461572304438], // 1003386
    [195461602497017, 195461605191413], // 2694396
    [196117020675944, 196117020746863], // 70919
    [197103754681204, 197103755131204], // 450000
    [197103952744787, 197103955937289], // 3192502
    [197104136769971, 197104136769972], // 1
    [197104149769968, 197104150719967], // 949999
    [197336079425915, 197336080427930], // 1002015
    [199427045623712, 199427046073712], // 450000
    [199427050073712, 199427050523712], // 450000
    [200661599034593, 200661612354593], // 13320000
    [200850637717220, 200850637767220], // 50000
    [201330095809297, 201330095859297], // 50000
    [201564621407321, 201564621479321], // 72000
    [202505491396486, 202505492396486], // 1000000
    [205748579004394, 205748601245319], // 22240925
    [205901445891832, 205901450558705], // 4666873
    [205901457648468, 205901457648469], // 1
    [205901462648468, 205901463148468], // 500000
    [206121235778739, 206121235828739], // 50000
    [206955893909180, 206955895496175], // 1586995
    [207503071597543, 207503071647543], // 50000
    [208997275956645, 208997337931632], // 61974987
    [208997938609923, 208997939153133], // 543210
    [208997941538099, 208997945538099], // 4000000
    [208999233677163, 208999234492238], // 815075
    [208999571350104, 208999573514230], // 2164126
    [208999657958099, 208999674526985], // 16568886
    [210316524943642, 210316525035946], // 92304
    [211219052798176, 211219052832176], // 34000
    [211493111649828, 211493111699828], // 50000
    [211943204412355, 211943251369058], // 46956703
    [213303531176270, 213303531226270], // 50000
    [213363758436863, 213363759546482], // 1109619
    [213435155459146, 213435155509146], // 50000
    [213438444552953, 213438444961966], // 409013
    [214521311959444, 214521338653707], // 26694263
    [214683446648585, 214683446891820], // 243235
    [216066293040883, 216066293178312], // 137429
    [216066294696395, 216066295806981], // 1110586
    [216067286852502, 216067287471234], // 618732
    [217232718575286, 217233168246735], // 449671449
    [217273792167680, 217273792217680], // 50000
    [217483047467196, 217483047517196], // 50000
    [217669398653985, 217669400697910], // 2043925
    [218185298901905, 218185298941905], // 40000
    [218231832000000, 218231837000000], // 5000000
    [218295029502854, 218295029752854], // 250000
    [218295035809321, 218295036062448], // 253127
    [218295411631094, 218295426606094], // 14975000
    [218295426656094, 218295441656094], // 15000000
    [218295441706094, 218295441806094], // 100000
    [218295449396094, 218295449421094], // 25000
    [218295451596094, 218295451621094], // 25000
    [218318663322667, 218318925105817], // 261783150
    [219346349630553, 219346351050328], // 1419775
    [219775207979392, 219775208029354], // 49962
    [221657281138878, 221657281188878], // 50000
    [222097532826368, 222097532876368], // 50000
    [222097800959034, 222097801009034], // 50000
    [222097801009034, 222097801059034], // 50000
    [223109324213292, 223109324263292], // 50000
    [223109388186650, 223109388236380], // 49730
    [223109388336380, 223109388386380], // 50000
    [223109397337055, 223109397387055], // 50000
    [223109421336428, 223109421386428], // 50000
    [224762257373571, 224762780373571], // 523000000
    [224953777914034, 224953778012618], // 98584
    [224953808793674, 224953809177630], // 383956
    [226223386132825, 226223386182825], // 50000
    [226536157855301, 226536159291718], // 1436417
    [227504137997906, 227504344026062], // 206028156
    [227813792142182, 227813792192182], // 50000
    [232970241133648, 232970241182444], // 48796
    [234412781673957, 234414954991770], // 2173317813
    [235478060409388, 235478060459388], // 50000
    [239137443839780, 239137443889780], // 50000
    [241410448296085, 241410448346085], // 50000
    [241410454296085, 241410454346085], // 50000
    [241410454346085, 241410454396085], // 50000
    [241410458346085, 241410458396085], // 50000
    [241410458396085, 241410458446085], // 50000
    [242919354337250, 242919429337250], // 75000000
    [243295310628625, 243295310678625], // 50000
    [243297027530624, 243297027580624], // 50000
    [243297894706394, 243297894756394], // 50000
    [243297964889596, 243297964939596], // 50000
    [244011847091288, 244011847141288], // 50000
    [244141900651229, 244141900654283], // 3054
    [244379202342996, 244379202542996], // 200000
    [244733134381361, 244733134431361], // 50000
    [244733616425774, 244733616475774], // 50000
    [244733628755347, 244733628805347], // 50000
    [245410555875779, 245410556875779], // 1000000
    [246514343425662, 246514347222062], // 3796400
    [249134451086893, 249134452073293], // 986400
    [249134851502724, 249134851952722], // 449998
    [250231939587217, 250231939637217], // 50000
    [250232158061649, 250232158111649], // 50000
    [250301425308267, 250301425360767], // 52500
    [250302548680565, 250302549740265], // 1059700
    [251746505671282, 251746505971543], // 300261
    [251746517366555, 251746518186330], // 819775
    [251888450406003, 251888450456003], // 50000
    [252804378108393, 252804378158393], // 50000
    [253232754187458, 253232754237458], // 50000
    [258319400204105, 258319400254105], // 50000
    [258703252751000, 258703254077773], // 1326773
    [259210322226464, 259210322276464], // 50000
    [259214906581863, 259214920790110], // 14208247
    [259443216608156, 259443435526603], // 218918447
    [262174078982617, 262174079232504], // 249887
    [263915252705913, 263915252755913], // 50000
    [264288341673536, 264288341948882], // 275346
    [264607127800672, 264607128800672], // 1000000
    [264875690595957, 264875690976495], // 380538
    [265615422821948, 265615422871948], // 50000
    [266098502255388, 266098502798598], // 543210
    [266404484539065, 266404484549065], // 10000
    [266772619071470, 266772619121470], // 50000
    [266772619121470, 266772619171470], // 50000
    [266772619900273, 266772619934839], // 34566
    [266772712827158, 266772712877158], // 50000
    [268541385475412, 268541385875412], // 400000
    [268541554225412, 268541554275412], // 50000
    [268543795575412, 268543796075412], // 500000
    [268543800425412, 268543800925412], // 500000
    [268770875296407, 268770875396407], // 100000
    [268864485824907, 268864485874907], // 50000
    [269407319456717, 269407319506717], // 50000
    [269680776940784, 269680776990784], // 50000
    [269682006744321, 269682006794321], // 50000
    [271796949631141, 271796954096174], // 4465033
    [274330459408763, 274330459458763], // 50000
    [274333280812376, 274333281812376], // 1000000
    [274333281812376, 274333282812376], // 1000000
    [274524454792729, 274524458452340], // 3659611
    [274904244635505, 274904244685505], // 50000
    [275468906769240, 275468906869240], // 100000
    [275469271391857, 275469271441857], // 50000
    [275782792011992, 275782792034030], // 22038
    [275783141137920, 275783141187920], // 50000
    [275783142777806, 275783142822327], // 44521
    [275783142822327, 275783142872327], // 50000
    [276551011452350, 276551011502350], // 50000
    [277229110334720, 277229110335074], // 354
    [278245220304921, 278245221196430], // 891509
    [278992845550000, 278992845600000], // 50000
    [279020775736182, 279020775786182], // 50000
    [280766502062658, 280766504156260], // 2093602
    [280766582141484, 280766583844587], // 1703103
    [280768808187574, 280768808730784], // 543210
    [280768808734685, 280768809844506], // 1109821
    [280768822530666, 280768827920665], // 5389999
    [280768861471281, 280768861581281], // 110000
    [280768997154710, 280768997654709], // 499999
    [280769052443049, 280769055481435], // 3038386
    [280769065120844, 280769065314451], // 193607
    [280769237173456, 280769245409439], // 8235983
    [280769269356928, 280769275598203], // 6241275
    [281280709675412, 281280709725412], // 50000
    [281280709775412, 281280709825412], // 50000
    [281280801825412, 281280802325412], // 500000
    [281759311264087, 281759311314087], // 50000
    [281759312124087, 281759312174087], // 50000
    [281942351953928, 281942352003928], // 50000
    [282255746567259, 282255748701867], // 2134608
    [282256333759309, 282256333759310], // 1
    [283194742706143, 283194775876188], // 33170045
    [283403648123867, 283403648173867], // 50000
    [283403779774646, 283403779824646], // 50000
    [283403981181040, 283403981231040], // 50000
    [284389971429705, 284389973167332], // 1737627
    [284602769950000, 284602770000000], // 50000
    [284602770100000, 284602770150000], // 50000
    [284602770250000, 284602770300000], // 50000
    [284602770400000, 284602770450000], // 50000
    [284602770650000, 284602770700000], // 50000
    [284602770800000, 284602770850000], // 50000
    [284602770950000, 284602771000000], // 50000
    [284602771100000, 284602771150000], // 50000
    [284602771250000, 284602771300000], // 50000
    [285292037005923, 285292037055923], // 50000
    [285292193845923, 285292193875923], // 30000
    [285530234459830, 285530234599830], // 140000
    [285530883277743, 285530883406232], // 128489
    [285532203045364, 285532203095364], // 50000
    [285533147688258, 285533147738258], // 50000
    [285783195183783, 285783228512758], // 33328975
    [285783228612758, 285783229678242], // 1065484
    [285783229678242, 285783229964757], // 286515
    [286661746402009, 286661746591658], // 189649
    [287172122159510, 287172124173833], // 2014323
    [287442969749340, 287442970186560], // 437220
    [287875118509002, 287875119920616], // 1411614
    [287875120070616, 287875120509002], // 438386
    [288133849730682, 288133851594988], // 1864306
    [288718668820108, 288718668870108], // 50000
    [289339419243610, 289339419293610], // 50000
    [289431280122653, 289431281122653], // 1000000
    [289948910233335, 289948910753240], // 519905
    [290153211559647, 290153211609647], // 50000
    [290153245041215, 290153245295156], // 253941
    [290153491007873, 290153491057873], // 50000
    [291208886257540, 291208886307540], // 50000
    [291228932582532, 291228932744051], // 161519
    [291228937575439, 291228937625439], // 50000
    [291229128492741, 291229128572741], // 80000
    [291563724596635, 291563724646635], // 50000
    [291563724646635, 291563724696635], // 50000
    [291592663090078, 291592665172078], // 2082000
    [291816784699444, 291816784699445], // 1
    [291816788699444, 291816873545593], // 84846149
    [293414433613177, 293414433663177], // 50000
    [294565364015280, 294565364065280], // 50000
    [294565835316694, 294565836012239], // 695545
    [294565838789511, 294565838936568], // 147057
    [295133813574980, 295133813574981], // 1
    [296001903631766, 296002145649815], // 242018049
    [296196238901622, 296196238951622], // 50000
    [296405453565842, 296405454565842], // 1000000
    [296452305450624, 296452305821962], // 371338
    [296743960660540, 296743960710540], // 50000
    [296743960760540, 296743960810540], // 50000
    [296744945492522, 296744945542522], // 50000
    [296988080960351, 296988090760350], // 9799999
    [298567416150000, 298567416200000], // 50000
    [298567426200000, 298567426250000], // 50000
    [298567436250000, 298567436300000], // 50000
    [298890138580831, 298890138726431], // 145600
    [298890611183177, 298890611233177], // 50000
    [298890611991397, 298890612041397], // 50000
    [299127488916988, 299127489316987], // 399999
    [300445185984782, 300445186082873], // 98091
    [300445569020846, 300445570074844], // 1053998
    [300541282194138, 300541282304038], // 109900
    [303185149500129, 303185150842970], // 1342841
    [305543077925645, 305543081433645], // 3508000
    [305544474605664, 305544474655664], // 50000
    [305544874545053, 305544874595053], // 50000
    [305544972635674, 305544972685674], // 50000
    [306091979309967, 306092089089967], // 109780000
    [306188090518741, 306188119110000], // 28591259
    [306818258399784, 306818258487600], // 87816
    [307649918639007, 307649918941006], // 301999
    [307991732407706, 307991732507706], // 100000
    [308732564486508, 308732564695674], // 209166
    [309064062732965, 309064064231514], // 1498549
    [309064661958189, 309064662008189], // 50000
    [309268201618030, 309268201668030], // 50000
    [309268201668030, 309268201718030], // 50000
    [309326649736100, 309326649786100], // 50000
    [309885478481795, 309885478531795], // 50000
    [311073947183398, 311073947233398], // 50000
    [311666909494688, 311666910471874], // 977186
    [311666915486256, 311666916239798], // 753542
    [313839057898947, 313839057948947], // 50000
    [313839335095449, 313839335165762], // 70313
    [314054956747977, 314054956791403], // 43426
    [314364080965634, 314364081415633], // 449999
    [314364381041505, 314364381091505], // 50000
    [314364398665190, 314364398715190], // 50000
    [314364400865196, 314364400949214], // 84018
    [315882449041119, 315882449214159], // 173040
    [316543659085602, 316543659135602], // 50000
    [316543659135602, 316543659185602], // 50000
    [316760701827810, 316760705827810], // 4000000
    [316760709925610, 316760712575610], // 2650000
    [316760738537081, 316760739525620], // 988539
    [316824399811164, 316824409749644], // 9938480
    [317079338934271, 317079339034271], // 100000
    [318257177677604, 318257177727604], // 50000
    [320253803898447, 320253804524133], // 625686
    [321213173932901, 321213174844312], // 911411
    [321213175148873, 321213175525568], // 376695
    [321213225178515, 321213232082900], // 6904385
    [321213329229210, 321213333406860], // 4177650
    [321589518668644, 321589518718644], // 50000
    [322227718989990, 322227718990000], // 10
    [322269433007722, 322269434007722], // 1000000
    [322750258058518, 322750258200923], // 142405
    [322750267542572, 322750267542573], // 1
    [322984452567836, 322984454226215], // 1658379
    [323112115767365, 323112137839797], // 22072432
    [324343166800000, 324343175022600], // 8222600
    [324394862697065, 324394862697066], // 1
    [327768777143158, 327768797143158], // 20000000
    [329279483728160, 329279484324493], // 596333
    [329283516590877, 329283516690877], // 100000
    [330879312794461, 330879312844461], // 50000
    [330906106323308, 330906107773308], // 1450000
    [331209837445974, 331209837495974], // 50000
    [331621451114756, 331621451164756], // 50000
    [332078578982523, 332078636014430], // 57031907
    [334495297204533, 334495299951613], // 2747080
    [336247734561547, 336247734611547], // 50000
    [338643007587613, 338643010137613], // 2550000
    [338643011172871, 338643011901167], // 728296
    [338643332382060, 338643332432060], // 50000
    [338643956534701, 338643957305541], // 770840
    [340291937874855, 340291937877151], // 2296
    [340932145271142, 340932235623158], // 90352016
    [341489094755800, 341489098167683], // 3411883
    [341754067899990, 341754114675519], // 46775529
    [342025939623906, 342025939822476], // 198570
    [342441343216464, 342441344272464], // 1056000
    [343045672898896, 343045672898897], // 1
    [343070265255534, 343070269135840], // 3880306
    [344079098614088, 344079422077477], // 323463389
    [344375233011364, 344375233061364], // 50000
    [344375235011364, 344375235061364], // 50000
    [344375236011364, 344375236061364], // 50000
    [344375237011364, 344375237061364], // 50000
    [344582181017802, 344582331623228], // 150605426
    [345437565805655, 345437565855655], // 50000
    [346532425713501, 346532425713502], // 1
    [346810506984522, 346810507084522], // 100000
    [347107928608345, 347107928658345], // 50000
    [348126329812339, 348126329950619], // 138280
    [348126538707528, 348126539093208], // 385680
    [348433258844507, 348433258894507], // 50000
    [348715950499181, 348715950549181], // 50000
    [348715990526141, 348715990576141], // 50000
    [348889754567461, 348889756473370], // 1905909
    [348931000000000, 348931295089411], // 295089411
    [349792940291864, 349792940341864], // 50000
    [349792994696098, 349792994746098], // 50000
    [351489430081945, 351489430241703], // 159758
    [353250297621531, 353250300474450], // 2852919
    [353737579402412, 353737579452412], // 50000
    [354762082259466, 354762082427892], // 168426
    [354763606962336, 354763607012336], // 50000
    [354763865694319, 354763865863420], // 169101
    [354914684632429, 354914685092802], // 460373
    [354964564425398, 354965000000000], // 435574602
    [355624179159875, 355624179209875], // 50000
    [356045949091693, 356045949141693], // 50000
    [357158729534192, 357158731534192], // 2000000
    [357158731534192, 357158731678549], // 144357
    [357291577013994, 357291577152389], // 138395
    [357622349344586, 357622349394586], // 50000
    [359458921147415, 359458921197415], // 50000
    [360736320810179, 360736322889581], // 2079402
    [361794590126194, 361794590176194], // 50000
    [362315479860161, 362315479910161], // 50000
    [362315587410161, 362315587460161], // 50000
    [365712193307895, 365712193357895], // 50000
    [367559999000000, 367560000000000], // 1000000
    [367664308006854, 367665000000000], // 691993146
    [370281045677349, 370281045727349], // 50000
    [370461625495202, 370461625545202], // 50000
    [370461625545202, 370461626545202], // 1000000
    [372775000000000, 372777527006854], // 2527006854
    [373096116134198, 373096121654601], // 5520403
    [373096291754602, 373096296084198], // 4329596
    [373172425796962, 373172425846962], // 50000
    [373172596380517, 373172603972565], // 7592048
    [373614917271494, 373614917374994], // 103500
    [374727706685942, 374729167453004], // 1460767062
    [374998210062266, 374998210112266], // 50000
    [376685872857140, 376685872977140], // 120000
    [378827412809619, 378827412926285], // 116666
    [378827521790216, 378827521840215], // 49999
    [378827537863316, 378827538010185], // 146869
    [378827567484264, 378827567570627], // 86363
    [379143006767975, 379143006817975], // 50000
    [379315575442003, 379315576053244], // 611241
    [379440086826368, 379440087426148], // 599780
    [379907495384593, 379907495434593], // 50000
    [379907758039582, 379907758089582], // 50000
    [379908035994722, 379908036044722], // 50000
    [380147390698879, 380147390714245], // 15366
    [383837576795127, 383837576805127], // 10000
    [383838018080513, 383838018080514], // 1
    [383840186217482, 383840186267482], // 50000
    [383841500939914, 383841501634962], // 695048
    [383842120080647, 383842121658974], // 1578327
    [383842150539254, 383842151489252], // 949998
    [383842152539253, 383842153489252], // 949999
    [383842989492414, 383842989542414], // 50000
    [383844410904290, 383844410954290], // 50000
    [383866441885900, 383866441885901], // 1
    [383867987649196, 383867989606892], // 1957696
    [383868169932547, 383868169982547], // 50000
    [384003187824207, 384003187874207], // 50000
    [385313830067831, 385313850715948], // 20648117
    [385522638416446, 385524524740015], // 1886323569
    [385690545399472, 385690601109453], // 55709981
    [385963007957705, 385963008007705], // 50000
    [386048760944074, 386048804354674], // 43410600
    [386702250050000, 386702250100000], // 50000
    [386757136882222, 386757137116829], // 234607
    [387461057132873, 387461057182873], // 50000
    [387461057182873, 387461057185193], // 2320
    [388005967850343, 388005967863147], // 12804
    [390400353465653, 390400353515653], // 50000
    [390492757215123, 390492757225123], // 10000
    [390494295065653, 390494295115653], // 50000
    [390530654801416, 390530654851416], // 50000
    [391161631544469, 391161631594469], // 50000
    [391692171654617, 391692171704617], // 50000
    [397621302017649, 397621302802649], // 785000
    [397622926227378, 397622926770588], // 543210
    [397624221365461, 397624225055461], // 3690000
    [397760033832895, 397760033895577], // 62682
    [397760479201440, 397760481197339], // 1995899
    [398811794543718, 398811799493717], // 4949999
    [398842023474928, 398842023814929], // 340001
    [398842083171659, 398842087090891], // 3919232
    [399567390445056, 399567390692716], // 247660
    [400337391331440, 400337391381440], // 50000
    [402875904082850, 402875904180856], // 98006
    [404091125099797, 404091125102837], // 3040
    [404092125162357, 404092125194357], // 32000
    [404092170082357, 404092170242357], // 160000
    [404705839577274, 404705849527273], // 9949999
    [404705949310739, 404705949360739], // 50000
    [405634525900938, 405634525950938], // 50000
    [405879703572994, 405879708522993], // 4949999
    [406571516066944, 406571516300075], // 233131
    [407706268903939, 407706529220939], // 260317000
    [410520308965545, 410520308985545], // 20000
    [411534932021982, 411534933021982], // 1000000
    [411812664052500, 411813016052500], // 352000000
    [411904535650880, 411904535700880], // 50000
    [411904535873913, 411904535910933], // 37020
    [411904535910933, 411904535960933], // 50000
    [411904535960933, 411904536060933], // 100000
    [411904536060933, 411904536110933], // 50000
    [411904536110933, 411904536160933], // 50000
    [413259472398479, 413259473528477], // 1129998
    [413331749369684, 413331749369685], // 1
    [413331749469684, 413331749503440], // 33756
    [413331749569684, 413331749569685], // 1
    [413331749669684, 413331749693439], // 23755
    [413331749709683, 413331749719684], // 10001
    [413634443448265, 413634453887466], // 10439201
    [414350464590203, 414350464608930], // 18727
    [414853305178403, 414853305228403], // 50000
    [414853305228403, 414853305278403], // 50000
    [414853676843174, 414853676853174], // 10000
    [414853931108898, 414853931158898], // 50000
    [414853931158898, 414853931208898], // 50000
    [414854540282847, 414854540732847], // 450000
    [415135537950279, 415135549400000], // 11449721
    [415323772469852, 415323772482095], // 12243
    [415323805108670, 415323806008671], // 900001
    [415324541753367, 415324541906426], // 153059
    [415516963827856, 415516966277856], // 2450000
    [415517463827856, 415517952986745], // 489158889
    [416819316716102, 416819316766102], // 50000
    [417850501000000, 417850501995995], // 995995
    [418071316352509, 418071316402509], // 50000
    [419543903050000, 419543903800000], // 750000
    [420204400284152, 420204400777362], // 493210
    [420204400827363, 420204400977779], // 150416
    [420347580672890, 420347580701958], // 29068
    [420347597505484, 420347597632500], // 127016
    [420800867776532, 420800867776533], // 1
    [420934516530618, 420935000000000], // 483469382
    [421025073229720, 421025078619719], // 5389999
    [421025078619719, 421025085939009], // 7319290
    [421025432195507, 421025452672180], // 20476673
    [421125000000000, 421125909421518], // 909421518
    [422814232538087, 422814232538473], // 386
    [423289621914679, 423289622024356], // 109677
    [424348369086676, 424348372107901], // 3021225
    [424694269193212, 424694270143211], // 949999
    [425116128283727, 425116128333727], // 50000
    [426343422463447, 426343422590241], // 126794
    [427335687545991, 427335687580991], // 35000
    [427335704015658, 427335704065658], // 50000
    [428147176443443, 428147176463443], // 20000
    [428363360246106, 428363361166105], // 919999
    [436353745778352, 436353745838955], // 60603
    [437101184524100, 437101185400662], // 876562
    [437101190790668, 437101191717228], // 926560
    [441364855610548, 441364855725547], // 114999
    [442073473880671, 442073493780670], // 19899999
    [442388768755869, 442388768805869], // 50000
    [442388963470143, 442388963520143], // 50000
    [442583501973131, 442583866228475], // 364255344
    [444506012014107, 444506012064107], // 50000
    [444506015014107, 444506015064107], // 50000
    [446245487023730, 446245487073730], // 50000
    [446830400624710, 446830415653296], // 15028586
    [446892019264767, 446892019314767], // 50000
    [446892020314767, 446892020364767], // 50000
    [446892023289274, 446892023339274], // 50000
    [446892127313611, 446892127334561], // 20950
    [448294882482954, 448294882832954], // 350000
    [448631147959901, 448631148009901], // 50000
    [448942508217206, 448942514202099], // 5984893
    [449142692461603, 449142692511603], // 50000
    [449468456779247, 449468494184373], // 37405126
    [449699051526710, 449699070096608], // 18569898
    [451349987023730, 451349987073730], // 50000
    [451576042655127, 451576042744052], // 88925
    [451576113313777, 451576113954804], // 641027
    [451579385156363, 451579386106361], // 949998
    [451579896070749, 451579896158937], // 88188
    [453395142311420, 453395142361420], // 50000
    [454280106695289, 454280107182289], // 487000
    [454281293231005, 454281293930744], // 699739
    [454568530136828, 454568530146828], // 10000
    [454729518072367, 454729519075843], // 1003476
    [455636904082367, 455637124652780], // 220570413
    [456398094472197, 456398094572197], // 100000
    [456398094572197, 456398094622197], // 50000
    [456942739094170, 456942739144170], // 50000
    [456943006474843, 456943006524843], // 50000
    [456943793857293, 456943794041899], // 184606
    [456945228621515, 456945230140976], // 1519461
    [456945617499241, 456945621449241], // 3950000
    [456946621767085, 456946621819585], // 52500
    [456946994067504, 456946994117504], // 50000
    [457155143589231, 457155143639231], // 50000
    [457157698073467, 457157698073468], // 1
    [457167462543108, 457167462593108], // 50000
    [457493236163019, 457493237442987], // 1279968
    [457493286641629, 457493286716629], // 75000
    [457668683212764, 457668683262764], // 50000
    [458302472595071, 458302472645071], // 50000
    [458471491514112, 458471495664112], // 4150000
    [458845464658975, 458846193511675], // 728852700
    [460358324156222, 460358324244185], // 87963
    [460563867208211, 460563867408211], // 200000
    [460722274837457, 460722274887457], // 50000
    [460722304549248, 460722304599248], // 50000
    [460722374549248, 460722374599248], // 50000
    [461379315479484, 461379315529484], // 50000
    [461379467919522, 461379467969522], // 50000
    [461379934329116, 461379934379116], // 50000
    [461582083085383, 461582083185383], // 100000
    [462030329976329, 462030330026329], // 50000
    [462031563373548, 462031563373549], // 1
    [462034602576123, 462034602626123], // 50000
    [462138052948723, 462138053070236], // 121513
    [462265524118586, 462265524168586], // 50000
    [462351076544515, 462351076594515], // 50000
    [462351131281266, 462351131331266], // 50000
    [462351296490905, 462351296519439], // 28534
    [462351769057179, 462351769107179], // 50000
    [462353767065374, 462353767115374], // 50000
    [462354017223182, 462354017273182], // 50000
    [462354553736635, 462354553786635], // 50000
    [464639677801325, 464639678124001], // 322676
    [464950010000000, 464950057290567], // 47290567
    [465167814766026, 465167815764529], // 998503
    [466037825473058, 466037828548057], // 3074999
    [467103223016425, 467103223066425], // 50000
    [467103223066425, 467103223116425], // 50000
    [467103223116425, 467103223166425], // 50000
    [467103223166425, 467103223216425], // 50000
    [467103223216425, 467103223266425], // 50000
    [467103223266425, 467103223316425], // 50000
    [467103223316425, 467103223366425], // 50000
    [467103223366425, 467103223416425], // 50000
    [467103223416425, 467103223466425], // 50000
    [467904120366754, 467904120416754], // 50000
    [468842148302123, 468842148323502], // 21379
    [469335688100000, 469335689100000], // 1000000
    [469488956874971, 469488956924971], // 50000
    [470120233800749, 470120233850749], // 50000
    [472594079518521, 472594079568521], // 50000
    [472594079568521, 472594079618521], // 50000
    [474882620487410, 474882620537410], // 50000
    [475018136564857, 475018136662357], // 97500
    [475251497908707, 475251497958707], // 50000
    [475251500908707, 475251500958707], // 50000
    [475251500958707, 475251501008707], // 50000
    [475251501958707, 475251502008707], // 50000
    [475251502008707, 475251502058707], // 50000
    [475251503058707, 475251503108707], // 50000
    [476257760000000, 476257761000000], // 1000000
    [476521714311736, 476521714361736], // 50000
    [478441208759505, 478441208809505], // 50000
    [478600592310713, 478600592360713], // 50000
    [478602169313710, 478602169500494], // 186784
    [478602638728668, 478602641208568], // 2479900
    [478602819185207, 478602819235207], // 50000
    [478602882951741, 478602882994442], // 42701
    [478603335859722, 478603335909722], // 50000
    [478604199545380, 478604201495379], // 1949999
    [478604205795879, 478604205845879], // 50000
    [479616365553760, 479616365633760], // 80000
    [479616476130172, 479616476135837], // 5665
    [479616476359757, 479616476409757], // 50000
    [479617569193740, 479617569243740], // 50000
    [479618200543017, 479618200553017], // 10000
    [479619542744882, 479619542794882], // 50000
    [480145256891393, 480147443619484], // 2186728091
    [480743235060065, 480743921703075], // 686643010
    [480962551780100, 480962551830100], // 50000
    [480962551830100, 480962551880100], // 50000
    [481065773000000, 481065791000000], // 18000000
    [481291115000000, 481291120000000], // 5000000
    [481291120000000, 481291123000000], // 3000000
    [481833554000000, 481833555000000], // 1000000
    [481894513619646, 481894526433126], // 12813480
    [482307071518938, 482307071533137], // 14199
    [482307297162660, 482307297783666], // 621006
    [482990107000000, 482990134000000], // 27000000
    [483448871056052, 483448871106050], // 49998
    [483530672188407, 483530674038406], // 1849999
    [483620180637462, 483620185465135], // 4827673
    [484971615606609, 484971615656609], // 50000
    [485995304668160, 485995305180160], // 512000
    [487020002513340, 487020002563340], // 50000
    [487783593153235, 487783593203235], // 50000
    [492497820015246, 492497820850971], // 835725
    [492498553352091, 492498565672492], // 12320401
    [492498565772492, 492498565997401], // 224909
    [492498565997401, 492498567347401], // 1350000
    [492498567347401, 492498576953692], // 9606291
    [493467006077872, 493467006277872], // 200000
    [493520296462655, 493520296512655], // 50000
    [493561829138522, 493561959638522], // 130500000
    [493829610225304, 493829612177609], // 1952305
    [493829970996733, 493829973561961], // 2565228
    [495345018783244, 495345019008244], // 225000
    [495711030329401, 495712786989682], // 1756660281
    [497468396468655, 497468396468656], // 1
    [497468396468656, 497468397550253], // 1081597
    [498399343534381, 498399343584381], // 50000
    [500386281922808, 500386283174072], // 1251264
    [500438093191798, 500439591191798], // 1498000000
    [501553943087188, 501553987683836], // 44596648
    [502809420974035, 502809735874035], // 314900000
    [503337439253301, 503337439303301], // 50000
    [503426987938006, 503426988845702], // 907696
    [503429131359047, 503429131359048], // 1
    [505872246207975, 505872246257975], // 50000
    [506294421805166, 506294443174456], // 21369290
    [506409479879167, 506409479929167], // 50000
    [507306891797379, 507306892016630], // 219251
    [507931320234362, 507931320684362], // 450000
    [508167099199902, 508168316871419], // 1217671517
    [508343697771714, 508343697771715], // 1
    [508489875609088, 508489875653552], // 44464
    [508581661613217, 508581661693217], // 80000
    [509081711348127, 509081711391123], // 42996
    [509229307206559, 509229319190066], // 11983507
    [509877214437246, 509877214454505], // 17259
    [509877214504505, 509877215048997], // 544492
    [509877983320328, 509877984105328], // 785000
    [509878086291694, 509878087656364], // 1364670
    [509878106341696, 509878116291694], // 9949998
    [509878117652893, 509878127652893], // 10000000
    [510597341335300, 510597341385300], // 50000
    [511974590828428, 511974590828429], // 1
    [512791086390415, 512791086494335], // 103920
    [513304402402075, 513304968780000], // 566377925
    [515932481285109, 515932491635446], // 10350337
    [516029009901968, 516029010901968], // 1000000
    [516104642751722, 516104999000000], // 356248278
    [518061876726090, 518061876776090], // 50000
    [519083430702338, 519083436609160], // 5906822
    [519786334230100, 519786561726069], // 227495969
    [521869639203103, 521869751084842], // 111881739
    [522065956345255, 522065959008685], // 2663430
    [522069061365588, 522069061415588], // 50000
    [522069327112669, 522069327400234], // 287565
    [523572145874194, 523572155824194], // 9950000
    [523699488686203, 523699488686213], // 10
    [523909603983273, 523909603988273], // 5000
    [524767740629949, 524767740679949], // 50000
    [524768221990311, 524768222040311], // 50000
    [524768624912798, 524768624962798], // 50000
    [524768650368673, 524768650418673], // 50000
    [524769034317044, 524769034366690], // 49646
    [525381377958797, 525381378077040], // 118243
    [525556832525737, 525556832530791], // 5054
    [526665433945016, 526665433995016], // 50000
    [528123834471808, 528123836724439], // 2252631
    [528123836724439, 528123841033099], // 4308660
    [528123845472998, 528123849784895], // 4311897
    [528158936137606, 528158936882606], // 745000
    [528538300398085, 528538300448085], // 50000
    [529400002010307, 529400005791901], // 3781594
    [529673919101963, 529673927743391], // 8641428
    [529673927793391, 529673928358824], // 565433
    [529749424408262, 529749424458262], // 50000
    [529749768048475, 529749768098475], // 50000
    [529792566164568, 529792619071949], // 52907381
    [529919994845872, 529919994895872], // 50000
    [529919995084119, 529919995134119], // 50000
    [529919995134119, 529919995184119], // 50000
    [529919995341290, 529919995391290], // 50000
    [529919995391290, 529919995416079], // 24789
    [530074943269723, 530074943319723], // 50000
    [530074943319723, 530074943369723], // 50000
    [530164230246554, 530164230296554], // 50000
    [531325150193684, 531325151000000], // 806316
    [531690520400504, 531690520410504], // 10000
    [531694269620504, 531694269874819], // 254315
    [531694342460504, 531694342510504], // 50000
    [531736409491244, 531736409526268], // 35024
    [533109306551303, 533109308659754], // 2108451
    [533181364780766, 533181954080766], // 589300000
    [533661020457295, 533661024957193], // 4499898
    [533661406405435, 533661415366939], // 8961504
    [533813190771065, 533813190821065], // 50000
    [533813591341789, 533813591560674], // 218885
    [533813622924525, 533813622974525], // 50000
    [534362195770790, 534362196088582], // 317792
    [534364266210438, 534364266260438], // 50000
    [534558173406696, 534558173456696], // 50000
    [535035057327109, 535035058561726], // 1234617
    [535036677522938, 535036677670726], // 147788
    [535331352051859, 535331352101859], // 50000
    [536340608180810, 536340611940810], // 3760000
    [536340622362492, 536340622822492], // 460000
    [536660373645539, 536660380000765], // 6355226
    [536988683121314, 536988683606734], // 485420
    [538597375423357, 538597375642537], // 219180
    [538597593410767, 538597601004114], // 7593347
    [538597671482358, 538597673560767], // 2078409
    [538597925490071, 538597925518622], // 28551
    [539813695275132, 539813695325132], // 50000
    [540168874083040, 540168874133040], // 50000
    [541369559011969, 541369559061969], // 50000
    [541552617455007, 541552628153641], // 10698634
    [541784478814037, 541784478973146], // 159109
    [541784484985008, 541784485108829], // 123821
    [542355025042053, 542355025092053], // 50000
    [542782935361097, 542782935477451], // 116354
    [545402574605037, 545402575455037], // 850000
    [546188155055028, 546188599915028], // 444860000
    [547468319358894, 547468319450522], // 91628
    [547607474463000, 547607474513000], // 50000
    [547923988203037, 547923988322118], // 119081
    [548024781226672, 548024781276672], // 50000
    [548435203689016, 548435204044770], // 355754
    [548435549758676, 548435550356707], // 598031
    [548538692984629, 548538702199222], // 9214593
    [548618744874854, 548618744949854], // 75000
    [549223647886004, 549223647936004], // 50000
    [549223647936004, 549223647986004], // 50000
    [550299813534782, 550299813704347], // 169565
    [550925368518449, 550925430977737], // 62459288
    [550925430977737, 550925751877737], // 320900000
    [551774804657770, 551774804707770], // 50000
    [553752154632538, 553752154662851], // 30313
    [554123853610557, 554123854160557], // 550000
    [554124322639488, 554124323050147], // 410659
    [555552134171840, 555552134596526], // 424686
    [555565837053184, 555565837103184], // 50000
    [556203695095162, 556203695129590], // 34428
    [556516788244499, 556516798244499], // 10000000
    [557303073379324, 557303170084991], // 96705667
    [557469789804718, 557469789854718], // 50000
    [557520153096812, 557520153239116], // 142304
    [558166739041487, 558166740991486], // 1949999
    [558167217714428, 558167218181377], // 466949
    [558167219406275, 558167240858475], // 21452200
    [558167352929505, 558167357553913], // 4624408
    [558167362553913, 558167362838675], // 284762
    [558167463619140, 558167464299138], // 679998
    [558167578277014, 558167578924021], // 647007
    [558167580927146, 558167581213566], // 286420
    [558484527079346, 558484527086350], // 7004
    [558655476079377, 558655476089377], // 10000
    [558655488079377, 558655488553355], // 473978
    [558723532711033, 558723532811033], // 100000
    [560156792107235, 560156792737994], // 630759
    [561353715896105, 561353715946105], // 50000
    [561425346075217, 561425346521536], // 446319
    [561425866398977, 561425866508985], // 110008
    [561426426836557, 561426426886557], // 50000
    [561466200007309, 561466200932308], // 924999
    [562621617991079, 562621618180314], // 189235
    [562802216649216, 562802217649216], // 1000000
    [562997880273975, 562997880323975], // 50000
    [562997880773975, 562997880823975], // 50000
    [562997881469370, 562997881519370], // 50000
    [562997881969370, 562997882019370], // 50000
    [562997882469370, 562997882519370], // 50000
    [563054967242883, 563054967292883], // 50000
    [563796151891185, 563796152339313], // 448128
    [564098165146129, 564098167188488], // 2042359
    [564098175666073, 564098175718677], // 52604
    [564320567148575, 564320568148575], // 1000000
    [564884009817365, 564884029276019], // 19458654
    [564884029376020, 564884039226019], // 9849999
    [565084898511325, 565084902684018], // 4172693
    [565084902784018, 565085000000000], // 97215982
    [565428262987816, 565428263037816], // 50000
    [565428725004437, 565428725600154], // 595717
    [565428741825626, 565428741868542], // 42916
    [565639054393948, 565639055521532], // 1127584
    [565982407692883, 565982408654434], // 961551
    [566520972572510, 566520980550557], // 7978047
    [566781590196835, 566781590246835], // 50000
    [566809535825893, 566809537729017], // 1903124
    [567018953666723, 567018954311149], // 644426
    [567723377428073, 567723377478073], // 50000
    [568905545633673, 568905545683673], // 50000
    [569114789081648, 569114789131648], // 50000
    [569114861394265, 569114861397067], // 2802
    [569127866059239, 569127867342101], // 1282862
    [569793295025214, 569793295418852], // 393638
    [570338879107807, 570338879607807], // 500000
    [570366489419569, 570366489614568], // 194999
    [570688889360126, 570688890110125], // 749999
    [571784300556382, 571784300598079], // 41697
    [571806692319861, 571806692369861], // 50000
    [571813001816712, 571813001866712], // 50000
    [571813086616712, 571813086666712], // 50000
    [571813090916712, 571813090966712], // 50000
    [571836075704368, 571836076031352], // 326984
    [572552309000000, 572552345000000], // 36000000
    [572553831000000, 572553835000000], // 4000000
    [573564951176965, 573564952178946], // 1001981
    [573769688602327, 573769689052327], // 450000
    [574282334703783, 574282334849935], // 146152
    [574714599226079, 574714599276079], // 50000
    [575026188413588, 575026188463588], // 50000
    [575235001000000, 575235082000000], // 81000000
    [575235082000000, 575235281000000], // 199000000
    [575235281000000, 575235298000000], // 17000000
    [575235298000000, 575235968000000], // 670000000
    [575601892108182, 575601892158182], // 50000
    [575611782219044, 575611782455552], // 236508
    [575612220614054, 575612222014783], // 1400729
    [575613588363939, 575613589279654], // 915715
    [575819965509845, 575819965559845], // 50000
    [576587450958011, 576587577854866], // 126896855
    [577743774000000, 577743881000000], // 107000000
    [578027786453353, 578027786553110], // 99757
    [578370847000000, 578370848082120], // 1082120
    [578409798548990, 578409798598989], // 49999
    [579840000000000, 579840414082062], // 414082062
    [580560842076454, 580560842126454], // 50000
    [580561470045898, 580561470404269], // 358371
    [580563379420498, 580563379470498], // 50000
    [580563607160055, 580563608055948], // 895893
    [580564430870781, 580564430874223], // 3442
    [580564492925201, 580564493325200], // 399999
    [580834311285066, 580834311485066], // 200000
    [580916448162392, 580916452140863], // 3978471
    [580947318200599, 580947318250599], // 50000
    [581042215330286, 581042262000000], // 46669714
    [581213331421877, 581213590611078], // 259189201
    [581250557397619, 581251017754043], // 460356424
    [581554525177815, 581554525227815], // 50000
    [582208695507933, 582208695781479], // 273546
    [582289320666402, 582289320666403], // 1
    [582380546539296, 582380575607361], // 29068065
    [583040000000000, 583040041550000], // 41550000
    [583748235863401, 583748235865732], // 2331
    [584074907769349, 584074907819349], // 50000
    [584214351000000, 584214453000000], // 102000000
    [584435139950000, 584435225000000], // 85050000
    [584500323195547, 584500323379661], // 184114
    [584504499655570, 584504499705570], // 50000
    [584504717879034, 584504718327678], // 448644
    [584609618562792, 584609773111319], // 154548527
    [584740202056628, 584740202106628], // 50000
    [584756420292868, 584756421192867], // 899999
    [585060281000000, 585060361000000], // 80000000
    [585209640283662, 585209702283662], // 62000000
    [585561554406415, 585561554456415], // 50000
    [585590691006953, 585590693956952], // 2949999
    [585811262454934, 585811262542735], // 87801
    [585844942600000, 585845000000000], // 57400000
    [586405598581029, 586405598826953], // 245924
    [587893786809242, 587893786834444], // 25202
    [588195872048305, 588195872092055], // 43750
    [588905756018872, 588905756022938], // 4066
    [589055100434107, 589055100834144], // 400037
    [589055100984145, 589055101419908], // 435763
    [589055548596155, 589055553221155], // 4625000
    [589055591477470, 589055591677470], // 200000
    [589147740000000, 589147828596379], // 88596379
    [589207404000000, 589207508000000], // 104000000
    [589516550616019, 589516630766019], // 80150000
    [589943655904243, 589943655988851], // 84608
    [590316270462903, 590316270497279], // 34376
    [590997810000000, 590997915000000], // 105000000
    [592604798876751, 592604798897322], // 20571
    [592696254988571, 592696255758866], // 770295
    [593352455090959, 593352455140959], // 50000
    [593353441292174, 593353443815773], // 2523599
    [593353920005523, 593353925158059], // 5152536
    [593590293468022, 593590293518022], // 50000
    [593922853701406, 593922853726406], // 25000
    [594049639162077, 594049639631108], // 469031
    [594049888232629, 594049888592686], // 360057
    [594710677848222, 594710678298221], // 449999
    [595160371780439, 595160374843883], // 3063444
    [595445362494023, 595445364495514], // 2001491
    [596406372891266, 596406374341327], // 1450061
    [596897256000000, 596897357000000], // 101000000
    [597047537845053, 597047537881870], // 36817
    [597427618317103, 597427618367103], // 50000
    [597567236165732, 597567236883139], // 717407
    [598088713940458, 598088713983354], // 42896
    [598520303469186, 598520303523684], // 54498
    [598520490249332, 598520492365734], // 2116402
    [598520493331613, 598520500147664], // 6816051
    [598520531789303, 598520531977098], // 187795
    [598622119364031, 598622119434951], // 70920
    [598981989148266, 598981989194652], // 46386
    [599225982000000, 599225983000000], // 1000000
    [599503072616144, 599503073207548], // 591404
    [599503528006225, 599503765019825], // 237013600
    [599666461864455, 599666461914455], // 50000
    [599666461914455, 599666462064455], // 150000
    [599668042634616, 599668042684616], // 50000
    [599668966060633, 599668966110633], // 50000
    [599890246238181, 599890246288181], // 50000
    [600409520495886, 600409520545886], // 50000
    [600475401153672, 600475499213672], // 98060000
    [600733290870200, 600733291155522], // 285322
    [600745865200277, 600745887074001], // 21873724
    [601126513031617, 601126513131117], // 99500
    [601397424536217, 601397424888179], // 351962
    [601635792536023, 601635797876022], // 5339999
    [601737819423278, 601737876055705], // 56632427
    [602108157527261, 602108161442653], // 3915392
    [602479548121206, 602479548171206], // 50000
    [602616750771175, 602616754929809], // 4158634
    [602938290195075, 602938325000000], // 34804925
    [602938325000000, 602938385091028], // 60091028
    [602949211866484, 602949365121404], // 153254920
    [603054344926976, 603054345504245], // 577269
    [603054345554245, 603054346732312], // 1178067
    [603332390048363, 603332390169876], // 121513
    [603452992126501, 603452992481967], // 355466
    [603956914921973, 603956914971973], // 50000
    [604041057822678, 604041062772677], // 4949999
    [604068500000000, 604068500205145], // 205145
    [604081995430000, 604081995480000], // 50000
    [604173730834266, 604173731836132], // 1001866
    [604560530917066, 604560531384546], // 467480
    [604560531484546, 604560535944546], // 4460000
    [604691484288189, 604691484488189], // 200000
    [605309060775167, 605309181339781], // 120564614
    [605772606296586, 605772617440093], // 11143507
    [605803441302917, 605803441352917], // 50000
    [605836389043516, 605836389783516], // 740000
    [606444571450906, 606444571539946], // 89040
    [606541756006711, 606541756056711], // 50000
    [606544249157098, 606544381659835], // 132502737
    [606608732775353, 606608733068379], // 293026
    [606860383445731, 606860403295731], // 19850000
    [606861155978064, 606861255878064], // 99900000
    [606861365018064, 606861365468064], // 450000
    [606861930274388, 606861930674388], // 400000
    [606916540850459, 606917070051552], // 529201093
    [606922934507766, 606922934803440], // 295674
    [607181244960738, 607181249431552], // 4470814
    [607239593806004, 607239593856004], // 50000
    [607239776316477, 607239776366477], // 50000
    [607718090193852, 607718090274443], // 80591
    [607745531643626, 607745549415703], // 17772077
    [607973350540626, 607973350858927], // 318301
    [608052018531920, 608052018531921], // 1
    [608127296884320, 608127306720309], // 9835989
    [608127336770309, 608127338004399], // 1234090
    [608164722991748, 608164724004025], // 1012277
    [608192107369558, 608192107419558], // 50000
    [608192107999272, 608192108049272], // 50000
    [608259397260053, 608259402160052], // 4899999
    [608305057860408, 608305057960000], // 99592
    [608340256525095, 608340364551925], // 108026830
    [608723256459823, 608723256659823], // 200000
    [608930356803640, 608930356853640], // 50000
    [609026292165158, 609026292215158], // 50000
    [609066674627512, 609066674627513], // 1
    [609066674827512, 609066674827513], // 1
    [609210774037218, 609210774087218], // 50000
    [610240064305190, 610240065000000], // 694810
    [610679744769249, 610679790000000], // 45230751
    [610940382617014, 610940653866321], // 271249307
    [611330000000000, 611330166225190], // 166225190
    [611521452406743, 611521452583128], // 176385
    [612827606617267, 612827607567267], // 950000
    [613762748506889, 613762748556889], // 50000
    [614338655761581, 614338655861580], // 99999
    [614960326062521, 614960329940055], // 3877534
    [615798780720990, 615798782239073], // 1518083
    [615798782239073, 615798782685394], // 446321
    [616006863141748, 616006863191748], // 50000
    [616118667897094, 616118667947094], // 50000
    [616118667947094, 616118667997094], // 50000
    [616192411635381, 616192411685381], // 50000
    [616192412135381, 616192412171322], // 35941
    [616193255853365, 616193256503365], // 650000
    [616737792423725, 616737792473725], // 50000
    [616738842291211, 616738846224201], // 3932990
    [616738926424204, 616738928874201], // 2449997
    [616754820629340, 616754820679340], // 50000
    [617026338732754, 617026338783470], // 50716
    [617272492117464, 617272500630018], // 8512554
    [617960670534332, 617960670689332], // 155000
    [618135246080029, 618135248080029], // 2000000
    [618135248080029, 618135248619636], // 539607
    [618137041209700, 618137041259700], // 50000
    [618140270332065, 618140270727769], // 395704
    [618140423423948, 618140423603948], // 180000
    [618140423607072, 618140424150282], // 543210
    [618140504517704, 618140509102882], // 4585178
    [618333725633116, 618333726583114], // 949998
    [618615528463420, 618615529874911], // 1411491
    [618995667114927, 618995668794927], // 1680000
    [619411464556501, 619411467473817], // 2917316
    [619412475362691, 619412475458842], // 96151
    [619579340614393, 619579340664393], // 50000
    [619579419352763, 619579419566774], // 214011
    [619594178109099, 619594603703099], // 425594000
    [620025793982273, 620025794700271], // 717998
    [620025797315271, 620025802678555], // 5363284
    [620025803046055, 620025803834564], // 788509
    [620503464212583, 620503465180987], // 968404
    [620503465180987, 620503465394500], // 213513
    [620697685318423, 620697685727358], // 408935
    [620932354314655, 620932354364655], // 50000
    [621200255096510, 621200255146510], // 50000
    [621641325167731, 621641325186411], // 18680
    [621835128492037, 621835212000000], // 83507963
    [622067074000000, 622067075000000], // 1000000
    [622150560000000, 622150753390072], // 193390072
    [622208800006415, 622209300566415], // 500560000
    [622375695076531, 622375695932504], // 855973
    [622376442031813, 622376443195261], // 1163448
    [622450557750108, 622450561440108], // 3690000
    [624367332961300, 624367334389000], // 1427700
    [624658103026028, 624658104003611], // 977583
    [625032648390369, 625032648440369], // 50000
    [625975281717574, 625975282445468], // 727894
    [626412798000000, 626412899000000], // 101000000
    [626681229953050, 626681230003050], // 50000
    [626686480503164, 626686481097428], // 594264
    [626949285634239, 626949551574239], // 265940000
    [626988028947213, 626988028997213], // 50000
    [627629124464305, 627629127296285], // 2831980
    [627852849940806, 627852856448106], // 6507300
    [628573750750514, 628573751440591], // 690077
    [628978520829172, 628978520880322], // 51150
    [628978531072641, 628978531660322], // 587681
    [629015978814618, 629015978864618], // 50000
    [629460046891452, 629460056788451], // 9896999
    [629634368635216, 629634369128426], // 493210
    [629850835248021, 629850835298020], // 49999
    [630672512618493, 630672513950000], // 1331507
    [630794920273204, 630794920288204], // 15000
    [630956076000000, 630956077002846], // 1002846
    [631046605100081, 631046605101177], // 1096
    [631046742954513, 631046742964513], // 10000
    [631760229338084, 631760242621350], // 13283266
    [632240559608363, 632240707382363], // 147774000
    [632877746538199, 632877746962955], // 424756
    [633744473335855, 633744473520915], // 185060
    [634487104399223, 634487115028256], // 10629033
    [634571182053296, 634571182103296], // 50000
    [634571182103296, 634571182153296], // 50000
    [635315502100000, 635315546100000], // 44000000
    [635675673447492, 635675674799871], // 1352379
    [635675689944904, 635675691022231], // 1077327
    [635684561094874, 635684561144874], // 50000
    [635891161038538, 635891161898533], // 859995
    [636347047100000, 636347059100000], // 12000000
    [636800241565478, 636800242568188], // 1002710
    [637254038000000, 637254045000000], // 7000000
    [637337211055446, 637337220082639], // 9027193
    [637725000000000, 637725004384749], // 4384749
    [637725373748070, 637725374903464], // 1155394
    [637725648959773, 637725665832839], // 16873066
    [637726256010556, 637726257431379], // 1420823
    [637726269500565, 637726300992866], // 31492301
    [637726715021224, 637726724951369], // 9930145
    [637726818196210, 637726851919256], // 33723046
    [637993806457901, 637993806750010], // 292109
    [638069047992746, 638069048042746], // 50000
    [638838610000465, 638838610249770], // 249305
    [638866520150000, 638866570150000], // 50000000
    [639126777708021, 639126781708023], // 4000002
    [639126844508228, 639126844803624], // 295396
    [639126877608022, 639126878558021], // 949999
    [639181084812233, 639181084822233], // 10000
    [639218138674642, 639218138724642], // 50000
    [639526916065462, 639526916115462], // 50000
    [639732227175136, 639732227253030], // 77894
    [639806117838075, 639806180098867], // 62260792
    [639899312726268, 639899517516484], // 204790216
    [640800153848293, 640800201649020], // 47800727
    [640964590002601, 640964590052601], // 50000
    [641045213667062, 641045213717062], // 50000
    [641159660550184, 641159660664426], // 114242
    [641250288788016, 641250290356623], // 1568607
    [641250290899833, 641250293998016], // 3098183
    [641250295000368, 641250295998016], // 997648
    [641250297635753, 641250297906123], // 270370
    [641277909304882, 641278432548664], // 523243782
    [641291752286700, 641291752339200], // 52500
    [641291757431068, 641291757481068], // 50000
    [641464979197154, 641464981277387], // 2080233
    [641476530792681, 641476530842681], // 50000
    [641476741647065, 641476741697065], // 50000
    [642489218204821, 642489233217727], // 15012906
    [642849983150000, 642849983569678], // 419678
    [643694693938832, 643694695150000], // 1211168
    [644139552926124, 644139562826123], // 9899999
    [644146027050000, 644146044475843], // 17425843
    [644186030440182, 644186030490182], // 50000
    [644585544619569, 644585544669569], // 50000
    [644585544681984, 644585544731984], // 50000
    [644782276340380, 644782319192448], // 42852068
    [645534422696593, 645534422709573], // 12980
    [645534422709573, 645534422759573], // 50000
    [645585119098420, 645585119548420], // 450000
    [646510361112050, 646510362014637], // 902587
    [646733707648722, 646733707698722], // 50000
    [646767441632164, 646767573120371], // 131488207
    [647025854910816, 647025854960816], // 50000
    [647174673817642, 647174707817642], // 34000000
    [647184966802474, 647184966852474], // 50000
    [647254527841438, 647254527891438], // 50000
    [647309768592587, 647309768642587], // 50000
    [647566241000000, 647566291000000], // 50000000
    [647775677337629, 647775677387629], // 50000
    [648035207710022, 648035208710022], // 1000000
    [648190806103146, 648190806153146], // 50000
    [648190816153146, 648190816203146], // 50000
    [648418648585385, 648418649153864], // 568479
    [648622227202102, 648622227252102], // 50000
    [648622227252102, 648622227302102], // 50000
    [648622227302102, 648622227352102], // 50000
    [648622424043252, 648622424093252], // 50000
    [648768042431749, 648768042888903], // 457154
    [648930215198729, 648930215234597], // 35868
    [649010357761027, 649010357811027], // 50000
    [649078201995827, 649078268748513], // 66752686
    [649594825349221, 649594825449221], // 100000
    [649770590291238, 649770591291238], // 1000000
    [649805776160086, 649805776428509], // 268423
    [649852128338311, 649852128524420], // 186109
    [649991498834352, 649991499834352], // 1000000
    [650266291250000, 650266291300000], // 50000
    [650445564569134, 650445565569134], // 1000000
    [650517184669412, 650517185831084], // 1161672
    [650731820184388, 650731825211397], // 5027009
    [650815180869836, 650815181869836], // 1000000
    [651057553381134, 651057554381134], // 1000000
    [651097609000000, 651097610000000], // 1000000
    [651165725911198, 651165725961198], // 50000
    [651527505050000, 651527506050000], // 1000000
    [651582963000000, 651582964000000], // 1000000
    [651720130111645, 651720130177889], // 66244
    [652073790316152, 652073790366152], // 50000
    [652135654972402, 652135997972402], // 343000000
    [652283491472437, 652283497472437], // 6000000
    [652368083301621, 652368096697321], // 13395700
    [652544930000000, 652544931000000], // 1000000
    [652551668487123, 652551668537123], // 50000
    [652551668537123, 652551668587123], // 50000
    [652561001712676, 652561002162676], // 450000
    [652561003543876, 652561004700081], // 1156205
    [652565015493638, 652565023493638], // 8000000
    [652583160651252, 652583160701252], // 50000
    [652583170651252, 652583170701252], // 50000
    [652583187651252, 652583187701252], // 50000
    [652583197651252, 652583197701252], // 50000
    [652583207651252, 652583207701252], // 50000
    [652583217651252, 652583217701252], // 50000
    [652598514241224, 652598539076290], // 24835066
    [652850620394482, 652850622233083], // 1838601
    [652947981200000, 652947983200000], // 2000000
    [653008632426996, 653008721476996], // 89050000
    [653049812934377, 653049812984377], // 50000
    [653292335684606, 653292335734606], // 50000
    [653391045886488, 653391046835951], // 949463
    [653394562835951, 653394563835951], // 1000000
    [653559692692201, 653559692696655], // 4454
    [653559736094895, 653559736144895], // 50000
    [653559736144895, 653559736194895], // 50000
    [653689748033911, 653690000000000], // 251966089
    [653764973336983, 653764973386983], // 50000
    [653924226454705, 653924226504705], // 50000
    [654080000000000, 654080089973911], // 89973911
    [654372310000547, 654372332000547], // 22000000
    [654482935189223, 654482975891179], // 40701956
    [654704400420767, 654704417750767], // 17330000
    [654915579038838, 654915579048838], // 10000
    [654933433976294, 654933546560000], // 112583706
    [654945195299180, 654945296274981], // 100975801
    [655189783884467, 655189833515634], // 49631167
    [655197839697776, 655197843982682], // 4284906
    [655457246050000, 655457259050000], // 13000000
    [655685318077382, 655685318127382], // 50000
    [655854281422111, 655854281472111], // 50000
    [655854364977029, 655854382400644], // 17423615
    [655869645932046, 655869645982046], // 50000
    [655986125239895, 655986125289895], // 50000
    [656012342231143, 656012342329346], // 98203
    [656405456391329, 656405459186000], // 2794671
    [656729456739999, 656729456789999], // 50000
    [656875902513452, 656875902531200], // 17748
    [656903499704096, 656903501704096], // 2000000
    [656978179359234, 656978190359234], // 11000000
    [656990935975711, 656990936025711], // 50000
    [657036674424102, 657036674474102], // 50000
    [657073307900000, 657073309998400], // 2098400
    [657119503901295, 657119507684576], // 3783281
    [657236546222447, 657236546222448], // 1
    [657564887396020, 657564887613336], // 217316
    [657751361731041, 657751460200000], // 98468959
    [657955256318041, 657955256368041], // 50000
    [657982246171689, 657982246221689], // 50000
    [658237299069480, 658237299119480], // 50000
    [658248668393030, 658248695196023], // 26802993
    [658734298000000, 658734315000000], // 17000000
    [658874489750000, 658874525050000], // 35300000
    [659218171647459, 659218171697459], // 50000
    [659409596204141, 659409699204141], // 103000000
    [659556680000000, 659556700000000], // 20000000
    [659633104488667, 659633284488667], // 180000000
    [659837133000000, 659837233000000], // 100000000
    [659905294520354, 659905321520354], // 27000000
    [660060148100000, 660060248000000], // 99900000
    [660228228107847, 660228228154066], // 46219
    [660280554907242, 660280555654170], // 746928
    [660461945713740, 660461945763740], // 50000
    [660565040200000, 660565050200000], // 10000000
    [660784915653826, 660784945244929], // 29591103
    [660851007000000, 660851015000000], // 8000000
    [661151407178348, 661151407228348], // 50000
    [661174845121110, 661174852121110], // 7000000
    [661319213000000, 661319300700000], // 87700000
    [661619019201093, 661619023201093], // 4000000
    [661713516600000, 661713517550000], // 950000
    [661720149750000, 661720171750000], // 22000000
    [661796379000000, 661796405000000], // 26000000
    [661850097799382, 661850098799382], // 1000000
    [661945387083194, 661945393600000], // 6516806
    [662162929550000, 662162930550000], // 1000000
    [662351611247484, 662351621656381], // 10408897
    [662524611055000, 662524713055000], // 102000000
    [662555007049547, 662555014981190], // 7931643
    [662611368380000, 662611377900000], // 9520000
    [662654630050000, 662654632050000], // 2000000
    [662696616800000, 662696617800000], // 1000000
    [662735587619805, 662735587669805], // 50000
    [662735587982149, 662735588032149], // 50000
    [662735588032149, 662735588082149], // 50000
    [662964093750000, 662964101156077], // 7406077
    [663004682759396, 663004682809396], // 50000
    [663057605343594, 663057647376594], // 42033000
    [663111712955722, 663111713020198], // 64476
    [663256283526421, 663256288372450], // 4846029
    [663326967000000, 663326968000000], // 1000000
    [663451187050000, 663451273050000], // 86000000
    [663497315298688, 663497328000000], // 12701312
    [663600890631305, 663600891682418], // 1051113
    [664188761178234, 664188761228234], // 50000
    [664192667782274, 664192667832274], // 50000
    [664347131703283, 664347133961282], // 2257999
    [664347133961282, 664347134911282], // 950000
    [664366647861481, 664366647911481], // 50000
    [664366895286279, 664366895336279], // 50000
    [664453666000000, 664453767000000], // 101000000
    [664639169352820, 664639169402820], // 50000
    [664766058872241, 664766058922241], // 50000
    [664827632678259, 664827632728259], // 50000
    [664858671265515, 664858671315515], // 50000
    [665116211700000, 665116223700000], // 12000000
    [665155450240000, 665155450250000], // 10000
    [665337335387702, 665337335437702], // 50000
    [665589181781626, 665589181831626], // 50000
    [665619633343245, 665619633343246], // 1
    [665619635343245, 665619635343246], // 1
    [665619636343245, 665619636343246], // 1
    [665667316103794, 665667332167715], // 16063921
    [665667362881824, 665667363017715], // 135891
    [665667363017715, 665667363890660], // 872945
    [665968689546741, 665968690091375], // 544634
    [665968853152204, 665968862898575], // 9746371
    [666557470344598, 666557470394598], // 50000
    [666668948146618, 666668948196618], // 50000
    [666697233357836, 666697428357836], // 195000000
    [666703379267973, 666703379317973], // 50000
    [666912162600000, 666912179600000], // 17000000
    [667339586050000, 667339620950000], // 34900000
    [667362440821656, 667362440871656], // 50000
    [667362440871656, 667362441871656], // 1000000
    [667500559458883, 667500559508883], // 50000
    [667518406880280, 667518406930280], // 50000
    [667608696500000, 667608697500000], // 1000000
    [667630623800000, 667630631950000], // 8150000
    [667870013229989, 667870013279989], // 50000
    [667964805922317, 667964810872317], // 4950000
    [668109476345242, 668109476395242], // 50000
    [668128825600001, 668128878921795], // 53321794
    [668324726354859, 668324726404859], // 50000
    [668336035050000, 668336056050000], // 21000000
    [668446294353610, 668446294378610], // 25000
    [668609907010000, 668610000000000], // 92990000
    [668782212753142, 668782212803142], // 50000
    [668891730350000, 668891830350000], // 100000000
    [669055819062288, 669055823012288], // 3950000
    [669211301497863, 669211400397863], // 98900000
    [669238034598498, 669238035264715], // 666217
    [669644606000000, 669644606115112], // 115112
    [669924613376296, 669924613476296], // 100000
    [670178265208913, 670178265258913], // 50000
    [670279808945311, 670279809145311], // 200000
    [670582034016888, 670582034266888], // 250000
    [670783151368305, 670783151418305], // 50000
    [670833554380105, 670833554430105], // 50000
    [670833554430105, 670833554480105], // 50000
    [670833554480105, 670833554530105], // 50000
    [670855138461260, 670855139465435], // 1004175
    [671014079600000, 671014084989241], // 5389241
    [671100056650000, 671100175650000], // 119000000
    [671293520700000, 671293530650000], // 9950000
    [671409911197975, 671409913089655], // 1891680
    [671605958757975, 671605958807975], // 50000
    [671884174800000, 671884176800000], // 2000000
    [672097909000000, 672098705000000], // 796000000
    [672640874884466, 672640874934466], // 50000
    [672814438755863, 672814438901101], // 145238
    [673222865737997, 673222865787997], // 50000
    [673224128809218, 673224128859218], // 50000
    [673578287450000, 673578287500000], // 50000
    [673587177180135, 673587277180135], // 100000000
    [673676593186413, 673676593326412], // 139999
    [673746153862884, 673746160006452], // 6143568
    [673965332000000, 673965432000000], // 100000000
    [674166349100000, 674166363100000], // 14000000
    [674302353987818, 674302354037818], // 50000
    [674380487300000, 674380501300000], // 14000000
    [674640437997568, 674640438997568], // 1000000
    [674692536187398, 674692577259670], // 41072272
    [675108061719665, 675108061744665], // 25000
    [675108061744665, 675108061794665], // 50000
    [675118024876320, 675118036876320], // 12000000
    [675232704001842, 675232704047991], // 46149
    [675320047377700, 675320047427700], // 50000
    [675357990450000, 675358001450000], // 11000000
    [675392141282425, 675392141382425], // 100000
    [675455908155548, 675455919155548], // 11000000
    [675570683860173, 675570683953873], // 93700
    [675764655320444, 675764657135838], // 1815394
    [675775633675612, 675775635301928], // 1626316
    [675833007324423, 675833008724063], // 1399640
    [675833034972375, 675833035437086], // 464711
    [675833247520888, 675833247570888], // 50000
    [676015710140759, 676015725140759], // 15000000
    [676169368476925, 676169398787916], // 30310991
    [676360228652819, 676360236410078], // 7757259
    [676719714663895, 676719714713895], // 50000
    [676841520919568, 676841521088881], // 169313
    [677247694381513, 677247694431513], // 50000
    [677317777129056, 677317794279142], // 17150086
    [677341324516036, 677341324522273], // 6237
    [677349068354106, 677349068404106], // 50000
    [677372197039911, 677372197089911], // 50000
    [677725851283534, 677725853453184], // 2169650
    [677899443678869, 677899444128868], // 449999
    [677923565228002, 677923565278002], // 50000
    [678317437151570, 678317485739455], // 48587885
    [678426927478210, 678426993809917], // 66331707
    [678573741314931, 678573749742211], // 8427280
    [678691957221132, 678691960380505], // 3159373
    [678783189700000, 678783205700000], // 16000000
    [678830545863657, 678830545895103], // 31446
    [679010539214779, 679010540214779], // 1000000
    [679095852758131, 679095866758131], // 14000000
    [679199782314319, 679199782364319], // 50000
    [679647461834210, 679647550831936], // 88997726
    [679683407260000, 679683427333634], // 20073634
    [679776321001000, 679776330001000], // 9000000
    [679832481206086, 679832482156086], // 950000
    [679918231750000, 679918247750000], // 16000000
    [679963575548981, 679963579281516], // 3732535
    [679963678832419, 679963682596423], // 3764004
    [680170198855204, 680170198905204], // 50000
    [680257069901986, 680257069930372], // 28386
    [680257123038137, 680257125628138], // 2590001
    [680257125678138, 680257125908138], // 230000
    [680361488469769, 680361488522269], // 52500
    [680618258360000, 680618258410000], // 50000
    [680735279325767, 680735335465767], // 56140000
    [680735335465767, 680735379325767], // 43860000
    [680853951300000, 680853966300000], // 15000000
    [680985663325675, 680985663375675], // 50000
    [680987990794920, 680987990844920], // 50000
    [681319533820647, 681319533824497], // 3850
    [681319533824497, 681319533874497], // 50000
    [681319533874497, 681319533924497], // 50000
    [681319533924497, 681319533974497], // 50000
    [681319533974497, 681319534023340], // 48843
    [681508358838413, 681508358888413], // 50000
    [681512248047699, 681512249867699], // 1820000
    [681519124024175, 681519124560711], // 536536
    [681519300416784, 681519301295864], // 879080
    [681756186194706, 681756186244706], // 50000
    [681819511600000, 681819511650000], // 50000
    [681837282184533, 681837293184533], // 11000000
    [682276143154860, 682276147869007], // 4714147
    [682382087884797, 682382088298428], // 413631
    [682407480061233, 682407496061233], // 16000000
    [682726667655095, 682726706368692], // 38713597
    [682808183509595, 682808183559595], // 50000
    [682949897926567, 682949898136567], // 210000
    [682958516908985, 682958516958985], // 50000
    [682970062343587, 682970062393587], // 50000
    [682989056853616, 682989056853617], // 1
    [682989057853616, 682989063298389], // 5444773
    [683053796796745, 683053796846745], // 50000
    [683053796846745, 683053796946745], // 100000
    [683054137146745, 683054137346745], // 200000
    [683237559652055, 683237560094855], // 442800
    [683389992399885, 683389992519884], // 119999
    [683643503450000, 683643519450000], // 16000000
    [684315334060000, 684315354060000], // 20000000
    [684437200634364, 684437200734364], // 100000
    [684476747009684, 684476748459684], // 1450000
    [684682413146663, 684682413246663], // 100000
    [684713392384285, 684713392434285], // 50000
    [684759725110064, 684759725416064], // 306000
    [684804857968306, 684804858018306], // 50000
    [685089628530706, 685089953847274], // 325316568
    [685318282150088, 685318282650088], // 500000
    [685366290906961, 685366378220361], // 87313400
    [685410698287190, 685410699287190], // 1000000
    [685667523150000, 685667648150000], // 125000000
    [685668536150000, 685668602521922], // 66371922
    [685773778352815, 685773778402815], // 50000
    [685971103539737, 685971103876829], // 337092
    [685990108950000, 685990119950000], // 11000000
    [686418834470750, 686418834520750], // 50000
    [686456518854495, 686456518904495], // 50000
    [686482788194229, 686482788244229], // 50000
    [686705007669207, 686705019669207], // 12000000
    [686714997400000, 686714997450000], // 50000
    [686739627214736, 686739627708780], // 494044
    [686780893300000, 686780894300000], // 1000000
    [686793370450000, 686793382450000], // 12000000
    [686793382450000, 686793383450000], // 1000000
    [686873419802007, 686873421960472], // 2158465
    [686922549950010, 686922550000010], // 50000
    [687000948754717, 687000948764717], // 10000
    [687000976814717, 687000976824717], // 10000
    [687000978414717, 687000978424717], // 10000
    [687000981584717, 687000981594717], // 10000
    [687570365373079, 687570365758079], // 385000
    [687616030936010, 687616048690349], // 17754339
    [687669447731129, 687669447781129], // 50000
    [687692070923467, 687692070973467], // 50000
    [687741379927584, 687741476953138], // 97025554
    [687786342769374, 687786346292298], // 3522924
    [687786388648896, 687786388698896], // 50000
    [687786562032882, 687786562082882], // 50000
    [687891920519533, 687891920569533], // 50000
    [687913289300010, 687913303300010], // 14000000
    [688265240900000, 688265252900000], // 12000000
    [688290087016694, 688290099016694], // 12000000
    [688318075526399, 688318075576399], // 50000
    [688318084576399, 688318084626399], // 50000
    [688365023759376, 688365023809376], // 50000
    [688536459217290, 688536459267290], // 50000
    [688588109262577, 688588179126945], // 69864368
    [688599629721858, 688599635230653], // 5508795
    [688753277299925, 688753277349925], // 50000
    [688773399000000, 688773419000000], // 20000000
    [688894294397557, 688894297702070], // 3304513
    [688943772692100, 688943774540259], // 1848159
    [689222468585107, 689222470405107], // 1820000
    [689256578252242, 689256578302242], // 50000
    [689259490000000, 689259615000000], // 125000000
    [689348717400000, 689348725400000], // 8000000
    [689450955377846, 689450955427846], // 50000
    [689453364487743, 689453364537743], // 50000
    [689462784837408, 689462784887408], // 50000
    [689532860950933, 689532871950933], // 11000000
    [689832616050000, 689832617050000], // 1000000
    [689832638050000, 689832639050000], // 1000000
    [689832650050000, 689832651050000], // 1000000
    [689832704050000, 689832705050000], // 1000000
    [689832716050000, 689832717050000], // 1000000
    [689832728050000, 689832729050000], // 1000000
    [689832740050000, 689832741050000], // 1000000
    [689832752050000, 689832753050000], // 1000000
    [689832764050000, 689832765050000], // 1000000
    [689832776050000, 689832777050000], // 1000000
    [689832788050000, 689832789050000], // 1000000
    [689832810050000, 689832811050000], // 1000000
    [689832822050000, 689832823050000], // 1000000
    [689832844050000, 689832845050000], // 1000000
    [689832856050000, 689832857050000], // 1000000
    [689863612050000, 689863710050000], // 98000000
    [689925118090308, 689925122140308], // 4050000
    [689965105703599, 689965113653599], // 7950000
    [690074173036973, 690074174036973], // 1000000
    [690110000000000, 690110002000000], // 2000000
    [690260870479120, 690260870679119], // 199999
    [690265775993642, 690265776143642], // 150000
    [690265776893642, 690265776943642], // 50000
    [690265776943642, 690265776993642], // 50000
    [690365004677777, 690365004727777], // 50000
    [690365010750010, 690365010800010], // 50000
    [690380375572672, 690380375622672], // 50000
    [690380377681769, 690380377731769], // 50000
    [690531184444596, 690531415001106], // 230556510
    [690641693322732, 690641694322732], // 1000000
    [690673172950000, 690673184950000], // 12000000
    [690721905931636, 690721917362792], // 11431156
    [690731887101000, 690731926051000], // 38950000
    [690743628800000, 690743628850000], // 50000
    [690843385620311, 690843385620312], // 1
    [690917951350000, 690917964350000], // 13000000
    [691291185030610, 691291185080610], // 50000
    [691294360731436, 691294360831436], // 100000
    [691542531334222, 691542532334222], // 1000000
    [691592871153449, 691592871203449], // 50000
    [691633277496967, 691633277546967], // 50000
    [691762814501928, 691762814551928], // 50000
    [691763590219636, 691763590611806], // 392170
    [691796442962239, 691796443962239], // 1000000
    [691930078297403, 691930078347403], // 50000
    [691979079039021, 691979276395873], // 197356852
    [692041709831721, 692041709881721], // 50000
    [692064960817059, 692064960867059], // 50000
    [692161735482966, 692161735532966], // 50000
    [692390981203105, 692391156962367], // 175759262
    [692465479251453, 692465479451453], // 200000
    [692466593422971, 692466593622971], // 200000
    [692501490813356, 692501490863356], // 50000
    [692501490863356, 692501490913356], // 50000
    [692523608952180, 692523609002180], // 50000
    [692524011301388, 692524011401388], // 100000
    [692548312326146, 692548312376146], // 50000
    [692664419050089, 692664426306571], // 7256482
    [692667159599885, 692667159649885], // 50000
    [692674017942884, 692674024297658], // 6354774
    [692769005578065, 692769005628065], // 50000
    [692835126134395, 692835126184395], // 50000
    [692841836301297, 692841836351297], // 50000
    [692844699201297, 692844699251297], // 50000
    [692892783671860, 692892783721860], // 50000
    [692982632600000, 692982644600000], // 12000000
    [693018521159374, 693018521209374], // 50000
    [693025826997245, 693025911240185], // 84242940
    [693117765229229, 693117765781101], // 551872
    [693145629677923, 693145629727923], // 50000
    [693145848183582, 693145848233582], // 50000
    [693160005169172, 693160005219172], // 50000
    [693161745519172, 693161745569172], // 50000
    [693161877569172, 693161877619172], // 50000
    [693161878619172, 693161878669172], // 50000
    [693224529126257, 693224563184933], // 34058676
    [693233747506094, 693233749506094], // 2000000
    [693258584934492, 693258584984492], // 50000
    [693258907637566, 693258908731382], // 1093816
    [693302652750000, 693302664750000], // 12000000
    [693329820800000, 693329820850000], // 50000
    [693381604300000, 693381628601032], // 24301032
    [693395060238557, 693395060288557], // 50000
    [693395090288557, 693395090338557], // 50000
    [693395104338557, 693395104388557], // 50000
    [693406563321615, 693406563655398], // 333783
    [693415157702308, 693415157752308], // 50000
    [693417344153342, 693417344203342], // 50000
    [693439913980000, 693439914030000], // 50000
    [693440670650000, 693440670700000], // 50000
    [693440787850000, 693440787900000], // 50000
    [693544889636571, 693544889686571], // 50000
    [693566554923032, 693566554973032], // 50000
    [693637310583335, 693637310633335], // 50000
    [693698793648523, 693698794005123], // 356600
    [693755029491227, 693755029541227], // 50000
    [693791729296464, 693791729346464], // 50000
    [693791921467500, 693791922534861], // 1067361
    [693854608707902, 693854608757902], // 50000
    [693919038004784, 693919048004784], // 10000000
    [694150404511892, 694150404561892], // 50000
    [694278943886818, 694278943936818], // 50000
    [694316043872090, 694316043922090], // 50000
    [694334669538344, 694334669546085], // 7741
    [694345111130800, 694345127130800], // 16000000
    [694360064078019, 694360064128019], // 50000
    [694360194901066, 694360194951066], // 50000
    [694427195000000, 694427202000000], // 7000000
    [694732060745507, 694732060795507], // 50000
    [694871337582790, 694871337632790], // 50000
    [694930265812852, 694930283712852], // 17900000
    [695024347941196, 695024347991196], // 50000
    [695070772648052, 695071258431484], // 485783432
    [695089665027458, 695089667037458], // 2010000
    [695108260658558, 695108260779766], // 121208
    [695237662850514, 695237662900514], // 50000
    [695273124716592, 695273124717220], // 628
    [695283551503351, 695283551553351], // 50000
    [695329239689114, 695329245698299], // 6009185
    [695329418966858, 695329421763769], // 2796911
    [695335525959678, 695335526459678], // 500000
    [695340385506264, 695340386456263], // 949999
    [695448488685731, 695448488735731], // 50000
    [695448488735731, 695448488785731], // 50000
    [695448488785731, 695448488835731], // 50000
    [695465185350000, 695465185400000], // 50000
    [695530533050000, 695530533100000], // 50000
    [695553366150000, 695553367150000], // 1000000
    [695639816225379, 695639816275379], // 50000
    [695674157700000, 695674157750000], // 50000
    [695680521975650, 695680522125650], // 150000
    [695711512950000, 695711513000000], // 50000
    [695730541820741, 695730541870741], // 50000
    [695730620670741, 695730620720741], // 50000
    [695754219100000, 695754219150000], // 50000
    [695754886100000, 695754886150000], // 50000
    [695805648676433, 695805648726433], // 50000
    [695822109531366, 695822111439006], // 1907640
    [695825556143405, 695825581143405], // 25000000
    [695867073658622, 695867073671805], // 13183
    [695870994858749, 695870994908749], // 50000
    [695959610689210, 695959610739210], // 50000
    [695959610739210, 695959610789210], // 50000
    [695959610789211, 695959612089472], // 1300261
    [696004560905014, 696004560955014], // 50000
    [696029076921857, 696029077019270], // 97413
    [696344660493611, 696344722853354], // 62359743
    [696400325050000, 696400338050000], // 13000000
    [696439976434061, 696440000000000], // 23565939
    [696534751376650, 696534787165350], // 35788700
    [696560903786073, 696561005889533], // 102103460
    [696649976144444, 696650000000000], // 23855556
    [696759359960000, 696759404960000], // 45000000
    [697015000000000, 697015032759995], // 32759995
    [697041338603466, 697041338653466], // 50000
    [697207990289819, 697207990339819], // 50000
    [697277191209286, 697277242290839], // 51081553
    [697476142389729, 697476502126249], // 359736520
    [697808995923855, 697809004018255], // 8094400
    [697809008314590, 697809008821380], // 506790
    [697853995109292, 697853995159292], // 50000
    [697909139000000, 697909139201489], // 201489
    [697923630397739, 697923630447739], // 50000
    [697924497743425, 697924497743426], // 1
    [697924651261957, 697924651311957], // 50000
    [697924715348351, 697924715784309], // 435958
    [697924755664520, 697924756042501], // 377981
    [697927069598065, 697927070548065], // 950000
    [698323531940982, 698323537940982], // 6000000
    [698452091035588, 698452091085588], // 50000
    [698727073712437, 698727075713605], // 2001168
    [698975706615177, 698975778184040], // 71568863
    [698989624210404, 698989624260404], // 50000
    [698989626769839, 698989626769840], // 1
    [699260064617440, 699260065261365], // 643925
    [699381875272723, 699381875322723], // 50000
    [699381890272723, 699381890322723], // 50000
    [699381900272723, 699381900322723], // 50000
    [699636052570985, 699636066570985], // 14000000
    [699690636362838, 699690637362838], // 1000000
    [699690641262838, 699690641312838], // 50000
    [699873317890958, 699873318968158], // 1077200
    [699895113290416, 699895129290416], // 16000000
    [699948486145650, 699948486195650], // 50000
    [699977567134442, 699977567834181], // 699739
    [700025555604227, 700025581221713], // 25617486
    [700156541342741, 700156541492680], // 149939
    [700192794882201, 700192819188667], // 24306466
    [700351008236438, 700351008661464], // 425026
    [700470190006057, 700470203006057], // 13000000
    [700584727860360, 700584727910360], // 50000
    [700636246830173, 700636379938196], // 133108023
    [700652696980063, 700652697542004], // 561941
    [700675677449481, 700675741098586], // 63649105
    [700681697650000, 700681713650000], // 16000000
    [700952373283363, 700952375793546], // 2510183
    [701142170761251, 701142173373624], // 2612373
    [701204718165059, 701204719165059], // 1000000
    [701254020674808, 701254027033327], // 6358519
    [701348365189105, 701348366689105], // 1500000
    [701572168572782, 701572168622782], // 50000
    [701572168622782, 701572168672782], // 50000
    [701876594235206, 701876609235206], // 15000000
    [701964559507655, 701964700455710], // 140948055
    [702417501617546, 702417502460130], // 842584
    [702748890012724, 702748890112724], // 100000
    [702823841669895, 702823841719895], // 50000
    [703266675554246, 703266675604246], // 50000
    [703458728991065, 703458729051065], // 60000
    [703471154572585, 703471177135380], // 22562795
    [703497756828497, 703497756833632], // 5135
    [703521486766007, 703521511766007], // 25000000
    [703550615251532, 703550664250500], // 48998968
    [703612463623559, 703612925068571], // 461445012
    [704211434170443, 704211434269473], // 99030
    [704326484603102, 704326484613102], // 10000
    [704326488793102, 704326488803102], // 10000
    [704326547293102, 704326547303102], // 10000
    [704326565753102, 704326565763102], // 10000
    [704616326995699, 704616469174463], // 142178764
    [704618467279209, 704618468416236], // 1137027
    [704618475537616, 704618475587616], // 50000
    [704686876330759, 704686877280758], // 949999
    [704686877729226, 704686878229226], // 500000
    [704686878326630, 704686878400739], // 74109
    [704687371203079, 704687371310494], // 107415
    [704722428474715, 704722428524714], // 49999
    [704953656878537, 704953899053008], // 242174471
    [705017737174006, 705017740524006], // 3350000
    [705019176543118, 705019177543118], // 1000000
    [705359083317352, 705359084317352], // 1000000
    [705400417225598, 705400422291091], // 5065493
    [705413639393854, 705413639750087], // 356233
    [705446079200000, 705446080200000], // 1000000
    [705643142791703, 705643143850827], // 1059124
    [705819752850000, 705819760234283], // 7384283
    [705825400569381, 705825400619381], // 50000
    [705989592729976, 705989662150000], // 69420024
    [706038918685444, 706038919685444], // 1000000
    [706128372811828, 706128415844628], // 43032800
    [706191050135203, 706191100135203], // 50000000
    [706243363507773, 706243365360897], // 1853124
    [706518530063379, 706518530640329], // 576950
    [706518586190329, 706518591190329], // 5000000
    [706610154923350, 706610155223350], // 300000
    [706610155223350, 706610155673350], // 450000
    [706704809311944, 706704809361944], // 50000
    [706762648956228, 706762674152915], // 25196687
    [706816219961430, 706816238928630], // 18967200
    [706856565800830, 706856566350830], // 550000
    [707140262593920, 707140287147233], // 24553313
    [707606549126997, 707606549176997], // 50000
    [707680589515920, 707680589565920], // 50000
    [707794552064690, 707794552064691], // 1
    [707816563706430, 707816563756430], // 50000
    [707997388667221, 707997561057445], // 172390224
    [707998975663127, 707998975713127], // 50000
    [707998975713127, 707998975763127], // 50000
    [708054279001457, 708054384673351], // 105671894
    [708193798581602, 708193799404965], // 823363
    [708325289107714, 708325293232389], // 4124675
    [708352428343586, 708352429345585], // 1001999
    [708987150650490, 708987151242927], // 592437
    [708995328391190, 708995328441190], // 50000
    [709024840300000, 709024840350000], // 50000
    [709151303521152, 709151403021152], // 99500000
    [709151646572152, 709151653123152], // 6551000
    [709151746573152, 709151753124152], // 6551000
    [709541749896002, 709541749946002], // 50000
    [709542694240412, 709542737340412], // 43100000
    [709749038879298, 709749039079298], // 200000
    [709901733944039, 709901733994039], // 50000
    [709914092407549, 709914092507549], // 100000
    [709931676297653, 709931676347653], // 50000
    [709940094176067, 709940094226067], // 50000
    [709996426200000, 709996442200000], // 16000000
    [710095665382195, 710095780527466], // 115145271
    [710235384143734, 710235384193734], // 50000
    [710237638776326, 710237638777681], // 1355
    [710239828817756, 710239828867756], // 50000
    [710372246594805, 710372532669673], // 286074868
    [710533726275860, 710533738875860], // 12600000
    [710544182524343, 710544182638252], // 113909
    [710544185111843, 710544187322863], // 2211020
    [710599379083531, 710599379203531], // 120000
    [710599437514383, 710599439970198], // 2455815
    [710599722196944, 710599723391945], // 1195001
    [710599723391945, 710599724991946], // 1600001
    [710833845495599, 710833856043284], // 10547685
    [710931943668853, 710931950722858], // 7054005
    [711294766684691, 711294766694691], // 10000
    [711294911898748, 711294911908748], // 10000
    [711294955154691, 711294955164691], // 10000
    [711539312647293, 711539312697293], // 50000
    [711565062585252, 711565064685252], // 2100000
    [711591945059532, 711591945067532], // 8000
    [711591945175532, 711591945183532], // 8000
    [711591946547532, 711591946551363], // 3831
    [711591977483532, 711591977491532], // 8000
    [711591980761532, 711591980769532], // 8000
    [711693421202306, 711693421252306], // 50000
    [711859962047630, 711859989400000], // 27352370
    [711949920650000, 711950000000000], // 79350000
    [712117218837351, 712117354810372], // 135973021
    [712325517387731, 712325517434677], // 46946
    [712325613489733, 712325613737692], // 247959
    [712332633717797, 712332633717798], // 1
    [712332945440478, 712332948294656], // 2854178
    [712549618733982, 712549619683982], // 950000
    [712823199067757, 712823199117757], // 50000
    [712958548024383, 712958548050537], // 26154
    [713161171948241, 713161171998241], // 50000
    [713235010345546, 713235025345546], // 15000000
    [713240607057128, 713240634250416], // 27193288
    [713280557366171, 713280576366171], // 19000000
    [713592628013866, 713592921816001], // 293802135
    [713615296521400, 713615296808035], // 286635
    [713915134000000, 713915144000000], // 10000000
    [713970000240272, 713970001094431], // 854159
    [714117723234032, 714117766249275], // 43015243
    [714156430919249, 714156434471674], // 3552425
    [714345075157704, 714345075207704], // 50000
    [714345075207704, 714345075230361], // 22657
    [714400672447267, 714400673397267], // 950000
    [714500000000000, 714500000690973], // 690973
    [714515016300000, 714515027300000], // 11000000
    [714645102509397, 714645156177975], // 53668578
    [714673990244257, 714673990294257], // 50000
    [714673990294257, 714673990344257], // 50000
    [714852370104548, 714852420104548], // 50000000
    [714904587825659, 714904690715917], // 102890258
    [714962818610081, 714962826864468], // 8254387
    [714967221171991, 714967221196991], // 25000
    [715085754991273, 715085755306130], // 314857
    [715085756174002, 715085756549810], // 375808
    [715283024919012, 715283695819012], // 670900000
    [715430000136146, 715430000678110], // 541964
    [715596397472083, 715596481725163], // 84253080
    [715599678765684, 715599788765684], // 110000000
    [715758499050000, 715758517050000], // 18000000
    [715835000000000, 715835000484378], // 484378
    [716086865912812, 716086870237704], // 4324892
    [716545693651639, 716545693651641], // 2
    [716776806722661, 716776817529373], // 10806712
    [716796048708365, 716796063708365], // 15000000
    [716925723784422, 716925724784422], // 1000000
    [717320272574923, 717320273499115], // 924192
    [717320953167517, 717320953710727], // 543210
    [717321028066003, 717321028066004], // 1
    [717321033066003, 717321040116003], // 7050000
    [717321116213795, 717321121860974], // 5647179
    [717321372280173, 717321372630174], // 350001
    [717322497522281, 717322498472280], // 949999
    [717422703293241, 717422703343241], // 50000
    [717430346652038, 717430346662038], // 10000
    [717444492307974, 717444533724423], // 41416449
    [717444533724423, 717444580532656], // 46808233
    [717617438525091, 717617438575091], // 50000
    [717635039050603, 717635039100603], // 50000
    [717635154494880, 717635154544880], // 50000
    [717635584970864, 717635584973536], // 2672
    [717636517694290, 717636517712884], // 18594
    [717643128897091, 717643144897091], // 16000000
    [717658644312666, 717658656679585], // 12366919
    [717664977483220, 717664977533220], // 50000
    [717733449947995, 717733450223022], // 275027
    [717817519734850, 717817521692546], // 1957696
    [717916064548909, 717916701448909], // 636900000
    [717951032059845, 717951034869657], // 2809812
    [717984234392923, 717984234492923], // 100000
    [718003559727333, 718003559777333], // 50000
    [718193125457879, 718193125507879], // 50000
    [718210000000000, 718210000150778], // 150778
    [718298016474852, 718298031474852], // 15000000
    [718520968415267, 718520969415267], // 1000000
    [718550081780442, 718550134693498], // 52913056
    [718670749064280, 718671153153816], // 404089536
    [718990104224935, 718990111124935], // 6900000
    [719010284729062, 719010285851050], // 1121988
    [719040239255086, 719040239305086], // 50000
    [719060611087916, 719060611228276], // 140360
    [719276781468165, 719276781520665], // 52500
    [719399989424405, 719399993961801], // 4537396
    [719515550454915, 719515554029597], // 3574682
    [719587757838178, 719587757888178], // 50000
    [719588044037584, 719588044087584], // 50000
    [719673546989838, 719673547299938], // 310100
    [719814549174694, 719814549224694], // 50000
    [719814611951294, 719814612001294], // 50000
    [719820744594893, 719820744644893], // 50000
    [719922012692868, 719922012742868], // 50000
    [720030939812031, 720030954812031], // 15000000
    [720153034730676, 720153034780676], // 50000
    [720160010056167, 720160010106167], // 50000
    [720186913486113, 720186951028236], // 37542123
    [720238056670588, 720238056720588], // 50000
    [720269854840925, 720269854890925], // 50000
    [720324131046941, 720324133000066], // 1953125
    [720646263468203, 720646263492326], // 24123
    [720646263492326, 720646263672670], // 180344
    [720755001364393, 720755002254279], // 889886
    [720859710520451, 720859720290992], // 9770541
    [721050287286822, 721050302286822], // 15000000
    [721229040905409, 721229041668049], // 762640
    [721244596451084, 721244596501084], // 50000
    [721404914899564, 721404916214424], // 1314860
    [721462280550000, 721462280600000], // 50000
    [721462678933726, 721462682753228], // 3819502
    [721497273361410, 721497274118322], // 756912
    [721636838031182, 721636838081182], // 50000
    [721636880518364, 721636880568364], // 50000
    [721645816692748, 721645816742748], // 50000
    [721645865592748, 721645865642748], // 50000
    [721667575326975, 721667575376975], // 50000
    [721742887524903, 721742887574903], // 50000
    [721742887574903, 721742887624903], // 50000
    [721822957587404, 721822960378816], // 2791412
    [721941536602921, 721941536652921], // 50000
    [721959590015147, 721959646162915], // 56147768
    [722040067429480, 722040067479480], // 50000
    [722067874621727, 722067875821727], // 1200000
    [722104644808063, 722104669910281], // 25102218
    [722104669910281, 722104721458012], // 51547731
    [722368824721367, 722368825021628], // 300261
    [722368825021628, 722368825511746], // 490118
    [722475169781002, 722475170781002], // 1000000
    [722660912950000, 722660913000000], // 50000
    [722698061036575, 722698061086575], // 50000
    [722738235300045, 722738247014496], // 11714451
    [722741381664500, 722741392664500], // 11000000
    [723047512136056, 723047512253081], // 117025
    [723047539942882, 723047540048270], // 105388
    [723051422350000, 723051433350000], // 11000000
    [723069767829349, 723069767879349], // 50000
    [723116192041602, 723116192082385], // 40783
    [723116361887476, 723116362337476], // 450000
    [723278878316307, 723278878366307], // 50000
    [723278878366307, 723278878416307], // 50000
    [723280337912964, 723280340831747], // 2918783
    [723280396548019, 723280396626569], // 78550
    [723280396669532, 723280396674236], // 4704
    [723296147015088, 723296147065088], // 50000
    [723305087250000, 723305102250000], // 15000000
    [723340720107376, 723340720157376], // 50000
    [723923886367351, 723923888514459], // 2147108
    [723979870687786, 723979881466965], // 10779179
    [724015027773552, 724015042773552], // 15000000
    [724157585377882, 724157589284132], // 3906250
    [724199184757683, 724199184807683], // 50000
    [724225941482541, 724225941532541], // 50000
    [724348449751415, 724348449801415], // 50000
    [724456273983001, 724456274033001], // 50000
    [724481192316390, 724481192354836], // 38446
    [724551584250005, 724551584350005], // 100000
    [724599872734664, 724599872764525], // 29861
    [724875016878756, 724875016928756], // 50000
    [724926616249031, 724926626556480], // 10307449
    [724982149953311, 724982150003311], // 50000
    [724982150003311, 724982150053311], // 50000
    [725380948859868, 725380948909868], // 50000
    [725439863151928, 725439863214861], // 62933
    [725669951932060, 725670000000000], // 48067940
    [725722668810594, 725722668860594], // 50000
    [725796265997987, 725796266047987], // 50000
    [725798423206243, 725798425358823], // 2152580
    [725865327058417, 725865432750451], // 105692034
    [725958845781190, 725958845788062], // 6872
    [725965351909906, 725965389475438], // 37565532
    [726457863916032, 726457863966032], // 50000
    [726539986400000, 726540000000000], // 13600000
    [726687941000000, 726688103000000], // 162000000
    [726839981702427, 726839981752427], // 50000
    [727266934093982, 727266935098190], // 1004208
    [727280323435185, 727280323802513], // 367328
    [727474303932953, 727474304932953], // 1000000
    [728199595555818, 728199596505817], // 949999
    [728675561879390, 728675640719244], // 78839854
    [729018409755632, 729018409805632], // 50000
    [729235080032422, 729235080597972], // 565550
    [729235697154829, 729235697204829], // 50000
    [729443002738550, 729443011672560], // 8934010
    [729575802254683, 729575803161789], // 907106
    [729767457522643, 729767457572643], // 50000
    [729856440430333, 729856440547075], // 116742
    [729887649146151, 729887650407692], // 1261541
    [729987745498464, 729987746311105], // 812641
    [729993646064732, 729993646114732], // 50000
    [729993833887589, 729993836214105], // 2326516
    [730048850207914, 730048850211411], // 3497
    [730129505093834, 730129505143834], // 50000
    [730249078741409, 730249081191408], // 2449999
    [730460429596731, 730460450335969], // 20739238
    [730684596162098, 730684596212098], // 50000
    [730686237660703, 730686745593926], // 507933223
    [730771893467853, 730771899177853], // 5710000
    [730827219269726, 730827219319726], // 50000
    [730840270769766, 730840272244871], // 1475105
    [730985604745798, 730985604795798], // 50000
    [730985604795798, 730985604845798], // 50000
    [731098897470680, 731098958368124], // 60897444
    [731233087328175, 731233087378175], // 50000
    [731233087378175, 731233087428175], // 50000
    [731234685852188, 731234685902188], // 50000
    [731664680092504, 731664680142504], // 50000
    [731693884158285, 731693886168626], // 2010341
    [732067838790505, 732067839514483], // 723978
    [732114741700682, 732114791705390], // 50004708
    [732429468207388, 732429518833296], // 50625908
    [732602455261328, 732602455431327], // 169999
    [732688816461007, 732688817600856], // 1139849
    [732718919779434, 732718919857186], // 77752
    [732769556878432, 732769557103828], // 225396
    [732783888588163, 732783888746764], // 158601
    [732783890878509, 732783891638660], // 760151
    [733121009412749, 733121281820781], // 272408032
    [733465321083986, 733465324138320], // 3054334
    [733465643065398, 733465643115398], // 50000
    [733465643115398, 733465643165398], // 50000
    [733736642889702, 733736644688590], // 1798888
    [733736655879702, 733736655889702], // 10000
    [733945158783743, 733945158833743], // 50000
    [734303388117988, 734303388174208], // 56220
    [734303499554005, 734303499604005], // 50000
    [734303499604005, 734303499654005], // 50000
    [734340432823085, 734340432843085], // 20000
    [734340684403085, 734340684413085], // 10000
    [734340706323085, 734340706333085], // 10000
    [734340722343085, 734340722353085], // 10000
    [734382950835310, 734382950853697], // 18387
    [734426008929456, 734426315241547], // 306312091
    [734785080442038, 734785098689484], // 18247446
    [735009397328239, 735009461697833], // 64369594
    [735347152542046, 735347178075139], // 25533093
    [735417194685877, 735417747004052], // 552318175
    [736025751338134, 736025751388134], // 50000
    [736414653282406, 736414714550615], // 61268209
    [736749170833495, 736749171833495], // 1000000
    [736776467097580, 736776467247580], // 150000
    [736805027538556, 736805028563822], // 1025266
    [736919262685341, 736919345732096], // 83046755
    [736994729915373, 736994729965373], // 50000
    [736994754432120, 736994754482120], // 50000
    [737011220040941, 737011220090941], // 50000
    [737011254727093, 737011255782982], // 1055889
    [737011266568051, 737011266618051], // 50000
    [737021006972599, 737021006976498], // 3899
    [737123752978016, 737123753978016], // 1000000
    [737202559187891, 737202559383355], // 195464
    [737487465853517, 737487465903517], // 50000
    [737586002743401, 737586003177457], // 434056
    [737631753231884, 737631765231884], // 12000000
    [737670750900704, 737671557845372], // 806944668
    [737731745136935, 737731745186935], // 50000
    [737874157960946, 737874352589217], // 194628271
    [737904855800000, 737904905750000], // 49950000
    [737918950574489, 737918950624489], // 50000
    [737918953074489, 737918953124489], // 50000
    [737918953124489, 737918953174489], // 50000
    [737980590532726, 737980740781020], // 150248294
    [738045878967100, 738045879017100], // 50000
    [738102210428369, 738102270428369], // 60000000
    [738563994984905, 738564029967616], // 34982711
    [738632897893468, 738632897922987], // 29519
    [738769328816180, 738769328845230], // 29050
    [738838818588608, 738838820175855], // 1587247
    [738885458637522, 738885458653094], // 15572
    [739151796622877, 739151796672877], // 50000
    [739226441808350, 739226441858350], // 50000
    [739655175538464, 739655279486995], // 103948531
    [739823770956566, 739823771006566], // 50000
    [740046744764032, 740046744970032], // 206000
    [740153370605141, 740153383837846], // 13232705
    [740523309379763, 740523393474761], // 84094998
    [740722496410844, 740722499269345], // 2858501
    [740762058712819, 740762058762819], // 50000
    [741115689992868, 741115690488701], // 495833
    [741302347327612, 741302347354378], // 26766
    [741302506086174, 741302506136174], // 50000
    [741319124342148, 741319125292147], // 949999
    [741706681951720, 741706681976720], // 25000
    [742034418945283, 742034419345283], // 400000
    [742158889263905, 742158890188904], // 924999
    [742193046158389, 742193046208389], // 50000
    [742448606756732, 742448606806732], // 50000
    [742533585409304, 742533628421119], // 43011815
    [742569988690248, 742569997985356], // 9295108
    [742648218863955, 742648358863955], // 140000000
    [742729326432482, 742729326456486], // 24004
    [742775133383485, 742775133433485], // 50000
    [743020589867734, 743020639572431], // 49704697
    [743020639672431, 743021524996734], // 885324303
    [743145212964744, 743145255760775], // 42796031
    [743219781149749, 743219781316027], // 166278
    [743219855262134, 743219859227526], // 3965392
    [743230238640300, 743230242480677], // 3840377
    [743441537400702, 743441555756302], // 18355600
    [743462503007263, 743462504917449], // 1910186
    [743462509767886, 743462510717884], // 949998
    [743501291557776, 743501791557776], // 500000000
    [743895346558431, 743895464660645], // 118102214
    [743961242007032, 743961242988916], // 981884
    [743966220052084, 743966260300000], // 40247916
    [743970846200886, 743970846250886], // 50000
    [744520856947990, 744520856997990], // 50000
    [744563998692559, 744563998742559], // 50000
    [744645004823773, 744645009000000], // 4176227
    [744809494303909, 744809494353909], // 50000
    [744885997253904, 744886049511138], // 52257234
    [745138276772097, 745138276872097], // 100000
    [745144018164348, 745144053914776], // 35750428
    [745411985926920, 745411991229524], // 5302604
    [745427149088510, 745427149138510], // 50000
    [745453857635095, 745453861173712], // 3538617
    [745488326674809, 745488326690243], // 15434
    [745488326847414, 745488326897414], // 50000
    [745488326897414, 745488326947414], // 50000
    [745488327077563, 745488327127563], // 50000
    [745488327127563, 745488327177563], // 50000
    [745488327177563, 745488327227563], // 50000
    [745676236534036, 745676249839991], // 13305955
    [745747882450000, 745747896312963], // 13862963
    [746380429749272, 746380529778365], // 100029093
    [746411140200689, 746411234934480], // 94733791
    [746414225279599, 746414225329599], // 50000
    [746480182486338, 746480182536338], // 50000
    [746480213402385, 746480213420939], // 18554
    [746541760323790, 746541760334379], // 10589
    [746646611484808, 746646611534808], // 50000
    [746790001556847, 746790001606847], // 50000
    [746799387172182, 746799455069044], // 67896862
    [747064934750786, 747064934800786], // 50000
    [747091993411682, 747091993861682], // 450000
    [747091996411682, 747091996911682], // 500000
    [747369806034698, 747369811427520], // 5392822
    [747497592859720, 747497692859720], // 100000000
    [747629597742474, 747629597792474], // 50000
    [747796312983293, 747796313033293], // 50000
    [747817097036949, 747817097052543], // 15594
    [747844125010694, 747844125060694], // 50000
    [747962929249157, 747962929299157], // 50000
    [748274070007219, 748274105118619], // 35111400
    [748342550523671, 748342550533671], // 10000
    [748394210946965, 748394310946965], // 100000000
    [748486366587960, 748486366903376], // 315416
    [748871979580588, 748871979630588], // 50000
    [748908267236072, 748908267286865], // 50793
    [749026804576687, 749026854576687], // 50000000
    [749389426962973, 749389469740006], // 42777033
    [749534913894088, 749534930048267], // 16154179
    [749669638964604, 749669639014604], // 50000
    [749755381895524, 749755479979468], // 98083944
    [750047453086182, 750047453494841], // 408659
    [750172250542735, 750172250544105], // 1370
    [750265483802175, 750265483852175], // 50000
    [750361263652539, 750361263702539], // 50000
    [750494996405900, 750494998106718], // 1700818
    [750506418854973, 750506418904973], // 50000
    [750550397112844, 750550397162844], // 50000
    [750631950182068, 750631950232068], // 50000
    [750655658201207, 750655658251207], // 50000
    [750664895074339, 750664895124339], // 50000
    [750675874048081, 750675924048081], // 50000000
    [751109825250671, 751109825251671], // 1000
    [751133762822733, 751133762886575], // 63842
    [751133770119057, 751133770191353], // 72296
    [751181748473549, 751181748523549], // 50000
    [751310268757864, 751310268807864], // 50000
    [751338690076556, 751338789886430], // 99809874
    [751450775294102, 751450775344102], // 50000
    [751580176589434, 751580176639434], // 50000
    [751667984213857, 751667984289787], // 75930
    [751748188402599, 751748189402599], // 1000000
    [751754562927769, 751754563066878], // 139109
    [751788201050000, 751788201100000], // 50000
    [751793800706909, 751793915379019], // 114672110
    [751844284609402, 751844284659402], // 50000
    [751857042993188, 751857091290584], // 48297396
    [751954480497053, 751954541933231], // 61436178
    [752023872945390, 752023872949456], // 4066
    [752023917032584, 752023917099033], // 66449
    [752191224204087, 752191431154087], // 206950000
    [752246199380973, 752246227511520], // 28130547
    [752334639150000, 752334640150000], // 1000000
    [752360137881971, 752360137951909], // 69938
    [752360348255562, 752360349405562], // 1150000
    [752360359993982, 752360360043982], // 50000
    [752360928546138, 752360938546138], // 10000000
    [752361532165346, 752361533538008], // 1372662
    [752372938291374, 752373034162374], // 95871000
    [752449999900000, 752450000000000], // 100000
    [752572704241644, 752572803391644], // 99150000
    [752618900955195, 752618921121527], // 20166332
    [752687594314192, 752687594325465], // 11273
    [752690085554387, 752690114642655], // 29088268
    [752824525033150, 752824525283150], // 250000
    [753049992834669, 753050000000000], // 7165331
    [753081899802360, 753081900848182], // 1045822
    [753081900848182, 753081901298182], // 450000
    [753084899013859, 753085000000000], // 100986141
    [753109523490154, 753109524136652], // 646498
    [753214781038374, 753214781048374], // 10000
    [753281077550000, 753281149550000], // 72000000
    [753388920552844, 753388920602844], // 50000
    [753476810997821, 753476811497821], // 500000
    [753508314855049, 753508478335641], // 163480592
    [753510371135674, 753510371185674], // 50000
    [753804988396027, 753804988396815], // 788
    [753918222932957, 753918225454918], // 2521961
    [754054803984157, 754054806756965], // 2772808
    [754270486452546, 754270490883770], // 4431224
    [754300805259414, 754300805309414], // 50000
    [754303613143362, 754303615093361], // 1949999
    [754838519633158, 754838519709933], // 76775
    [754924716478499, 754924716528499], // 50000
    [754949088644896, 754949088694896], // 50000
    [754950434676590, 754951263676590], // 829000000
    [755361609237689, 755361611171240], // 1933551
    [755361618452692, 755361619206240], // 753548
    [755377933150000, 755377933250000], // 100000
    [755486046324684, 755486047043862], // 719178
    [755676242271211, 755676243471210], // 1199999
    [755723470401261, 755723520401261], // 50000000
    [756031180011543, 756031376703747], // 196692204
    [756058180769985, 756058194769985], // 14000000
    [756081824823996, 756081824873996], // 50000
    [756081842646924, 756081847062918], // 4415994
    [756086823269097, 756086840119097], // 16850000
    [756092609841220, 756092656823220], // 46982000
    [756160869287848, 756160869313743], // 25895
    [756160870232316, 756160870257527], // 25211
    [756160874231228, 756160874281228], // 50000
    [756160874281228, 756160874331228], // 50000
    [756160882878538, 756160882928538], // 50000
    [756160882928538, 756160882949696], // 21158
    [756164549551957, 756164549886250], // 334293
    [756273312286503, 756273312336503], // 50000
    [756371385971969, 756371391665549], // 5693580
    [756554392639542, 756554392864542], // 225000
    [756593467342462, 756593467417462], // 75000
    [756763070416156, 756763070466156], // 50000
    [756801896450000, 756802053450000], // 157000000
    [756838121590965, 756838260018099], // 138427134
    [757046934106318, 757046934156318], // 50000
    [757047158470111, 757047158520111], // 50000
    [757101493077844, 757101497845556], // 4767712
    [757102796937198, 757102796987198], // 50000
    [757189522501072, 757189549100000], // 26598928
    [757308627568792, 757308627618792], // 50000
    [757393391142909, 757393392146646], // 1003737
    [757455811194682, 757456047237750], // 236043068
    [757457100858426, 757457100950729], // 92303
    [757458309089246, 757458309126056], // 36810
    [757586553433801, 757586709433801], // 156000000
    [757810218408122, 757810218458122], // 50000
    [757814131753152, 757814183643399], // 51890247
    [757878901553036, 757878914329461], // 12776425
    [757915912147144, 757915912147145], // 1
    [757915912620745, 757915912620746], // 1
    [758191137703982, 758191137703983], // 1
    [758267687150000, 758267688150000], // 1000000
    [758284087003747, 758284087053747], // 50000
    [758453113800000, 758453146800000], // 33000000
    [758727344074799, 758727344099597], // 24798
    [758727344099597, 758727344149597], // 50000
    [758727344337844, 758727344387844], // 50000
    [758727344387844, 758727344437844], // 50000
    [758727344595015, 758727344645015], // 50000
    [758727344645015, 758727344695015], // 50000
    [758727344825164, 758727344875164], // 50000
    [758727344875164, 758727344925164], // 50000
    [758762907181248, 758762923134946], // 15953698
    [758831324302709, 758831325787983], // 1485274
    [758950634452599, 758950634502599], // 50000
    [759014398294514, 759014402523352], // 4228838
    [759034275030044, 759034275080044], // 50000
    [759068124131714, 759068131009102], // 6877388
    [759180558976346, 759180652976346], // 94000000
    [759411708153949, 759411866122162], // 157968213
    [759531421433591, 759531421483591], // 50000
    [759605310250941, 759605310300941], // 50000
    [759609382446951, 759609396948947], // 14501996
    [759609449368115, 759609449418114], // 49999
    [759632207786493, 759632207836493], // 50000
    [759649394523012, 759649404473011], // 9949999
    [759814377369941, 759814377419941], // 50000
    [760058046000000, 760058048839579], // 2839579
    [760085578964573, 760085579014573], // 50000
    [760341408825789, 760341408875789], // 50000
    [760853368848501, 760853368898501], // 50000
    [760936933908026, 760936933918026], // 10000
    [761088575251173, 761088575456240], // 205067
    [761391907831936, 761392419824677], // 511992741
    [761600547683106, 761600548653020], // 969914
    [761790198465956, 761790202364115], // 3898159
    [761895066784627, 761895066831486], // 46859
    [761899579250000, 761899588600000], // 9350000
    [761899608200000, 761899628200000], // 20000000
    [762010087434328, 762010087484328], // 50000
    [762111584509192, 762111584559192], // 50000
    [762665347788765, 762665347887641], // 98876
    [762666467278568, 762666467328568], // 50000
    [762700252859187, 762700252909187], // 50000
    [762700252909187, 762700252959187], // 50000
    [762700253388387, 762700253438387], // 50000
    [762700253438387, 762700253488387], // 50000
    [763134148622396, 763134148622397], // 1
    [763533729334996, 763533856268149], // 126933153
    [763761417484247, 763761417534247], // 50000
    [763815581320781, 763815840774333], // 259453552
    [763842518114228, 763842519126545], // 1012317
    [763842519126545, 763842519326545], // 200000
    [764176340539198, 764176418443393], // 77904195
    [764357732090426, 764357732170426], // 80000
    [764570802684895, 764570802734895], // 50000
    [764608408442634, 764608467937493], // 59494859
    [764613817694953, 764613817744953], // 50000
    [764640103368403, 764640103418403], // 50000
    [764640103418403, 764640103468403], // 50000
    [764640412468522, 764640412518522], // 50000
    [764658126191344, 764658126241344], // 50000
    [764699006178940, 764699006293349], // 114409
    [764967541545231, 764967612072519], // 70527288
    [764992486206866, 764992653206866], // 167000000
    [765260443837588, 765260443886597], // 49009
    [765521423818013, 765521626818013], // 203000000
    [765594774198841, 765594834198841], // 60000000
    [765623054098347, 765623059411963], // 5313616
    [765624151842246, 765624151957004], // 114758
    [765624337057575, 765624344820074], // 7762499
    [765624463780436, 765624464514932], // 734496
    [765678935136950, 765678989430272], // 54293322
    [765746189521535, 765746260984391], // 71462856
    [765809545306587, 765809545326587], // 20000
    [765907142877391, 765907142907020], // 29629
    [766034310206629, 766034310794757], // 588128
    [766188640790711, 766188677419666], // 36628955
    [766220041986637, 766220053727731], // 11741094
    [766223404108145, 766223465388524], // 61280379
    [766243542091713, 766243542237863], // 146150
    [766330348043422, 766330358794363], // 10750941
    [766356140943690, 766356141043690], // 100000
    [766380230000000, 766380230050000], // 50000
    [766547396356624, 766547399115699], // 2759075
    [766826159393232, 766826164468932], // 5075700
    [766853636646998, 766853641340612], // 4693614
    [766853805140849, 766853805190849], // 50000
    [767063943977593, 767063980933102], // 36955509
    [767074062828061, 767074062928061], // 100000
    [767074062948061, 767074063048061], // 100000
    [767074063068061, 767074063168061], // 100000
    [767074063188061, 767074063288061], // 100000
    [767074063348061, 767074063448061], // 100000
    [767074063468061, 767074063568061], // 100000
    [767074063588061, 767074063688061], // 100000
    [767074063728061, 767074063828061], // 100000
    [767074063848061, 767074063948061], // 100000
    [767074064008061, 767074064108061], // 100000
    [767074064148061, 767074064248061], // 100000
    [767074064268061, 767074064368061], // 100000
    [767074064388061, 767074064488061], // 100000
    [767170053384871, 767170218443959], // 165059088
    [767344015512377, 767344015562377], // 50000
    [767418245000000, 767418348000000], // 103000000
    [767419086417760, 767419086467760], // 50000
    [767585308310878, 767585316670878], // 8360000
    [767659639145165, 767659639545165], // 400000
    [767772944113483, 767772944163483], // 50000
    [768073856626196, 768073857154582], // 528386
    [768092175424878, 768092176348386], // 923508
    [768133579895093, 768133579945093], // 50000
    [768347303450000, 768347374450000], // 71000000
    [768579376150000, 768579505948834], // 129798834
    [768689213813246, 768689213820758], // 7512
    [768863271173909, 768863271248909], // 75000
    [768863296223909, 768863300911409], // 4687500
    [768863572557732, 768863572676412], // 118680
    [768880915317753, 768880929495111], // 14177358
    [768965471193901, 768965473623901], // 2430000
    [769095899991631, 769095900066631], // 75000
    [769097312435584, 769097312885584], // 450000
    [769240938162811, 769240938167816], // 5005
    [769240939911655, 769240939911656], // 1
    [769283666655000, 769283760655000], // 94000000
    [769398924039423, 769398924089423], // 50000
    [769428524330729, 769428935313729], // 410983000
    [769594820050000, 769594821050000], // 1000000
    [769643843487288, 769643909388827], // 65901539
    [769690462910676, 769690462960676], // 50000
    [769869598194041, 769869598244041], // 50000
    [769964128200000, 769964218200000], // 90000000
    [769985056178537, 769985056186299], // 7762
    [770155279950000, 770155299950000], // 20000000
    [770224823652732, 770224824461052], // 808320
    [770286961931643, 770286965001034], // 3069391
    [770287134987673, 770287135037673], // 50000
    [770287137987673, 770287138037673], // 50000
    [770287138037673, 770287138087673], // 50000
    [770569671141466, 770569697858498], // 26717032
    [770596960000000, 770596968600000], // 8600000
    [770603821928381, 770603936928381], // 115000000
    [770716069936806, 770716071886805], // 1949999
    [770838347633376, 770838348392335], // 758959
    [770908073792210, 770908111792210], // 38000000
    [770977500260453, 770977500310453], // 50000
    [771043062137586, 771043062187586], // 50000
    [771091161096412, 771091182194063], // 21097651
    [771205278451541, 771205290630896], // 12179355
    [771258586840525, 771258586890525], // 50000
    [771371985574565, 771372045574565], // 60000000
    [771458770927496, 771458770977496], // 50000
    [771567604811589, 771567604861589], // 50000
    [771589027730511, 771589087730511], // 60000000
    [771707190283043, 771707190333043], // 50000
    [771922504857916, 771922504907916], // 50000
    [772023019585976, 772023019635976], // 50000
    [772142356090134, 772142356140134], // 50000
    [772183896699045, 772183896771166], // 72121
    [772191503388773, 772191503411327], // 22554
    [772333027881870, 772333027931870], // 50000
    [772361040632295, 772361042600763], // 1968468
    [772465299700000, 772465365700000], // 66000000
    [772706096440962, 772706096490962], // 50000
    [772817856150000, 772817945150000], // 89000000
    [773015941506368, 773015941556368], // 50000
    [773070843768026, 773070843818026], // 50000
    [773160889356779, 773160891296326], // 1939547
    [773341292037680, 773341352037680], // 60000000
    [773527835277353, 773527836284284], // 1006931
    [773527874453597, 773527874503597], // 50000
    [773527874503597, 773527874553597], // 50000
    [773592480150000, 773592480174000], // 24000
    [773592480224000, 773592480256000], // 32000
    [773592500036000, 773592500086000], // 50000
    [773592500094000, 773592500144000], // 50000
    [773592500168000, 773592500218000], // 50000
    [773592500258000, 773592500308000], // 50000
    [773592500324000, 773592500374000], // 50000
    [773592500382000, 773592500432000], // 50000
    [773592500448000, 773592500498000], // 50000
    [773592500522000, 773592500572000], // 50000
    [773592500588000, 773592500638000], // 50000
    [773592500686000, 773592500736000], // 50000
    [773592500744000, 773592500794000], // 50000
    [773592500834000, 773592500884000], // 50000
    [773592500924000, 773592500974000], // 50000
    [773592501014000, 773592501064000], // 50000
    [773592501104000, 773592501154000], // 50000
    [773592501162000, 773592501212000], // 50000
    [773592501220000, 773592501270000], // 50000
    [773602055301988, 773602056177579], // 875591
    [773841483505306, 773841566911274], // 83405968
    [774022519393484, 774022520293483], // 899999
    [774053618375885, 774053618385885], // 10000
    [774053628375885, 774053628450885], // 75000
    [774119950652933, 774120000000000], // 49347067
    [774149017023820, 774149023323002], // 6299182
    [774161242445298, 774161242447976], // 2678
    [774250853978152, 774250853988152], // 10000
    [774344199885741, 774344199904863], // 19122
    [774344200892938, 774344201031526], // 138588
    [774374254170960, 774374254183926], // 12966
    [774456214992150, 774456215042150], // 50000
    [774575022618447, 774575022618448], // 1
    [774733427118797, 774733431701924], // 4583127
    [774764795327843, 774764796305235], // 977392
    [774771649428790, 774771651820522], // 2391732
    [774919202903847, 774919202953847], // 50000
    [775218790545500, 775218790595500], // 50000
    [775273025159735, 775273025209735], // 50000
    [775319978785179, 775319978835179], // 50000
    [775337611553499, 775337611603499], // 50000
    [775337611603499, 775337611653499], // 50000
    [775466795416361, 775466813545372], // 18129011
    [775472569906166, 775472569956166], // 50000
    [775560082450000, 775560144450000], // 62000000
    [775627467931449, 775627468931449], // 1000000
    [775908315129395, 775908316062353], // 932958
    [775940381704099, 775940381754099], // 50000
    [775967845507092, 775967845557092], // 50000
    [775972831185718, 775972832044465], // 858747
    [776141182499191, 776141182549191], // 50000
    [776141201941703, 776141202029827], // 88124
    [776608205980809, 776608206030809], // 50000
    [776653994985943, 776653995335943], // 350000
    [776979903561650, 776979904789190], // 1227540
    [777126778887549, 777126779800190], // 912641
    [777216078134647, 777216127323711], // 49189064
    [777301642810699, 777301642860699], // 50000
    [777371004304361, 777371004330067], // 25706
    [777371078774458, 777371079347142], // 572684
    [777559543659299, 777559544561139], // 901840
    [777575851564694, 777575851632941], // 68247
    [777683711702466, 777683711752466], // 50000
    [777683757340311, 777683757390311], // 50000
    [777706856840218, 777706856890218], // 50000
    [777788199815801, 777788199837249], // 21448
    [777930756305866, 777930758098170], // 1792304
    [778178641182022, 778178642400861], // 1218839
    [778260723228930, 778260723500041], // 271111
    [778439136508793, 778439136517089], // 8296
    [778439205806798, 778439205856798], // 50000
    [778506706170745, 778506706287707], // 116962
    [778612734698777, 778612734748777], // 50000
    [778943969752697, 778943969794807], // 42110
    [778944052924257, 778944052974257], // 50000
    [778944063024257, 778944063074257], // 50000
    [779110009183261, 779110010183261], // 1000000
    [779200399028464, 779200449028464], // 50000000
    [779229813948716, 779229813998716], // 50000
    [779229813998716, 779229814048716], // 50000
    [779359437588349, 779359437638349], // 50000
    [779414203042313, 779414208042313], // 5000000
    [779694564732701, 779694564782701], // 50000
    [779840873964319, 779840889588540], // 15624221
    [779840890088540, 779840891538540], // 1450000
    [779841025125346, 779841025200346], // 75000
    [779935073570823, 779935073620823], // 50000
    [780157863194898, 780157863244898], // 50000
    [780278388556612, 780278389759745], // 1203133
    [780278802456641, 780278802506641], // 50000
    [780744025226905, 780744060667061], // 35440156
    [780843739968500, 780843747968500], // 8000000
    [780956909310726, 780956909360726], // 50000
    [781309733493128, 781309793493128], // 60000000
    [781445506601804, 781445507642804], // 1041000
    [781536649916796, 781536650516097], // 599301
    [781616957142075, 781616960092074], // 2949999
    [781632415028015, 781632415478015], // 450000
    [781647757838094, 781647795838094], // 38000000
    [781662656008942, 781662656015308], // 6366
    [781662656018707, 781662656026808], // 8101
    [781703845200335, 781703925355010], // 80154675
    [781771642805631, 781771642905631], // 100000
    [781771663271652, 781771663309157], // 37505
    [781944020360855, 781944147149074], // 126788219
    [781945490835515, 781945490885515], // 50000
    [781951066855109, 781951066905109], // 50000
    [781956394022450, 781956394072450], // 50000
    [782029144394518, 782029786600010], // 642205492
    [782390408213708, 782390408263708], // 50000
    [782478757890239, 782478874890239], // 117000000
    [782537488284381, 782537488412561], // 128180
    [782720646876493, 782720647368796], // 492303
    [782772172652039, 782772172652040], // 1
    [783445700690502, 783445701157143], // 466641
    [783502150875932, 783503697956628], // 1547080696
    [783532511386249, 783532512255487], // 869238
    [783659286267640, 783659286984777], // 717137
    [783823838747487, 783823838757487], // 10000
    [783848196724857, 783848297674857], // 100950000
    [783905416513178, 783905416893546], // 380368
    [784060689342843, 784060719054730], // 29711887
    [784213495432981, 784213591950000], // 96517019
    [784406601683174, 784406661683174], // 60000000
    [784803920375039, 784803920425039], // 50000
    [784803990055239, 784803990105239], // 50000
    [785284594893539, 785284595693538], // 799999
    [785284894642951, 785284895393538], // 750587
    [785521021727492, 785521021777492], // 50000
    [785521037727534, 785521037777534], // 50000
    [785778967295791, 785778979223809], // 11928018
    [785808087303551, 785808087701678], // 398127
    [786007226384435, 786007226434435], // 50000
    [786037075300000, 786037109300000], // 34000000
    [786054024106760, 786054024196760], // 90000
    [786308613308694, 786308615784619], // 2475925
    [786516776981023, 786516776996531], // 15508
    [786516926318929, 786516929466174], // 3147245
    [786516929466174, 786516949566604], // 20100430
    [786517091558556, 786517092079670], // 521114
    [786517113807080, 786517113987889], // 180809
    [786577368562833, 786577369372833], // 810000
    [786582915087466, 786582917251031], // 2163565
    [786640486328037, 786640486378037], // 50000
    [786640486378037, 786640486428037], // 50000
    [786640488378037, 786640488428037], // 50000
    [786640488428037, 786640488478037], // 50000
    [786640490428037, 786640490478037], // 50000
    [786640490478037, 786640490528037], // 50000
    [786703400357774, 786703400407774], // 50000
    [786766434350000, 786766476271041], // 41921041
    [786932226897608, 786932226947608], // 50000
    [786982373044228, 786982397159106], // 24114878
    [787018044453204, 787018045288046], // 834842
    [787155200723313, 787155214376130], // 13652817
    [787163243629535, 787163243679535], // 50000
    [787417005890765, 787417182443374], // 176552609
    [787538195498966, 787538205003972], // 9505006
    [787559011083492, 787559011133492], // 50000
    [787877521662624, 787877581662624], // 60000000
    [788133965248937, 788133965298937], // 50000
    [788401328703202, 788401328753202], // 50000
    [788401334636092, 788401334686092], // 50000
    [788459221016000, 788459221066000], // 50000
    [788459221074000, 788459221124000], // 50000
    [788459221132000, 788459221182000], // 50000
    [788459221190000, 788459221240000], // 50000
    [788459221248000, 788459221298000], // 50000
    [788459221306000, 788459221356000], // 50000
    [788459221364000, 788459221414000], // 50000
    [788459221446000, 788459221496000], // 50000
    [788459221512000, 788459221562000], // 50000
    [788459221602000, 788459221652000], // 50000
    [788459221660000, 788459221710000], // 50000
    [788459221718000, 788459221768000], // 50000
    [788459221776000, 788459221826000], // 50000
    [788476783129985, 788476870445061], // 87315076
    [788571240929244, 788571240929245], // 1
    [788577712712395, 788577769712395], // 57000000
    [788805671940472, 788805671940473], // 1
    [788805869755381, 788805870305381], // 550000
    [788806151163621, 788806151213621], // 50000
    [788806151213621, 788806151913360], // 699739
    [788819131678261, 788819132682723], // 1004462
    [788922174940423, 788922178543294], // 3602871
    [789135234638579, 789135234688579], // 50000
    [789350619956084, 789350620956084], // 1000000
    [789396988200000, 789396989200000], // 1000000
    [789422645661124, 789422645661125], // 1
    [789520456931990, 789520456981990], // 50000
    [789520457069990, 789520457119990], // 50000
    [789520457231990, 789520457281990], // 50000
    [789520457329990, 789520457379990], // 50000
    [789600189163411, 789600198655617], // 9492206
    [789621551645139, 789621874287699], // 322642560
    [789714577597758, 789714577697759], // 100001
    [789795263795664, 789795763795664], // 500000000
    [789924728051856, 789924728053410], // 1554
    [789977855872833, 789977856942471], // 1069638
    [790197501469872, 790197501569872], // 100000
    [790247040466988, 790247040516988], // 50000
    [790247883227446, 790247883277446], // 50000
    [790248484371350, 790248485526249], // 1154899
    [790308306944893, 790308385750736], // 78805843
    [790471289613031, 790471289709183], // 96152
    [790472907902105, 790472907952105], // 50000
    [790472909832207, 790472909882207], // 50000
    [790480305361357, 790481135361357], // 830000000
    [790780807874511, 790780807924511], // 50000
    [790793317668145, 790793317718145], // 50000
    [790917127275071, 790917128537854], // 1262783
    [791020771177181, 791020771784499], // 607318
    [791020792444011, 791020792494011], // 50000
    [791152525176619, 791152527291045], // 2114426
    [791177711280451, 791177711330450], // 49999
    [791177761148116, 791177761198114], // 49998
    [791215186647108, 791215285739844], // 99092736
    [791397491477585, 791397493547490], // 2069905
    [791397507941543, 791397507991543], // 50000
    [791853773091211, 791853830091211], // 57000000
    [792139828952453, 792139829002453], // 50000
    [792139829002453, 792139829052453], // 50000
    [792139831002453, 792139831052453], // 50000
    [792139831052453, 792139831102453], // 50000
    [792139833052453, 792139833102453], // 50000
    [792139833102453, 792139833152453], // 50000
    [792139835102453, 792139835152453], // 50000
    [792139835152453, 792139835202453], // 50000
    [792139837152453, 792139837202453], // 50000
    [792139837202453, 792139837252453], // 50000
    [792139839202453, 792139839252453], // 50000
    [792139839252453, 792139839302453], // 50000
    [792139841252453, 792139841302453], // 50000
    [792139841302453, 792139841352453], // 50000
    [792139845762975, 792139845812975], // 50000
    [792139845812975, 792139845862975], // 50000
    [792139847812975, 792139847862975], // 50000
    [792139847862975, 792139847912975], // 50000
    [792237456931865, 792237457965374], // 1033509
    [792336769181066, 792336787865633], // 18684567
    [792464989050000, 792464990050000], // 1000000
    [792486224894026, 792486224944026], // 50000
    [792486225644026, 792486225694026], // 50000
    [792595993352824, 792595993970907], // 618083
    [792601819920719, 792601820079719], // 159000
    [792734955914562, 792734983744096], // 27829534
    [792882645813219, 792882646456272], // 643053
    [792986365578716, 792986367528714], // 1949998
    [793227398405990, 793227398497208], // 91218
    [793227457277887, 793227457327887], // 50000
    [793615717190161, 793615717340161], // 150000
    [793695692577906, 793695693585366], // 1007460
    [793695770177566, 793695771127565], // 949999
    [793764742937682, 793764742987682], // 50000
    [793852842910313, 793852844197672], // 1287359
    [793860320910891, 793860321896901], // 986010
    [793878465711420, 793878512972010], // 47260590
    [793903090120138, 793903090170138], // 50000
    [793933133712193, 793933133762193], // 50000
    [793933380386806, 793933390336804], // 9949998
    [793995020486547, 793995023070263], // 2583716
    [794208413972617, 794208414022617], // 50000
    [794330522021551, 794330522351191], // 329640
    [794443484028766, 794443500572573], // 16543807
    [794631117371364, 794631136371364], // 19000000
    [794695029797346, 794695032000346], // 2203000
    [794840949001336, 794840949123695], // 122359
    [794840949123695, 794840949323695], // 200000
    [795125822567272, 795125822659868], // 92596
    [795265465739490, 795265465778782], // 39292
    [795916903488001, 795916913338001], // 9850000
    [796155860600000, 796155881115163], // 20515163
    [796359272050000, 796359281050000], // 9000000
    [796425338768740, 796425338818740], // 50000
    [796457955478128, 796457955528127], // 49999
    [796457955678128, 796457955728127], // 49999
    [796799259547395, 796799259682302], // 134907
    [797071738640288, 797072122291136], // 383650848
    [797204426067405, 797204426117405], // 50000
    [797556525445055, 797556525471030], // 25975
    [797635869693075, 797635869693076], // 1
    [797769487689640, 797769489349586], // 1659946
    [797781313685872, 797781313885872], // 200000
    [797854741350295, 797854741400295], // 50000
    [797854741400295, 797854741437329], // 37034
    [797890088070470, 797890088075472], // 5002
    [798001820795965, 798001821819554], // 1023589
    [798038810141750, 798038810141751], // 1
    [798056107153237, 798056107259487], // 106250
    [798056113896384, 798056114622548], // 726164
    [798056476748105, 798056476948105], // 200000
    [798101020500446, 798101020514093], // 13647
    [798294273836853, 798294289608563], // 15771710
    [798340877765048, 798340878146965], // 381917
    [798341128818822, 798341129205051], // 386229
    [798371456664710, 798371456694456], // 29746
    [798541368745327, 798541385376037], // 16630710
    [798680108815524, 798680118765523], // 9949999
    [798680170429533, 798680170465523], // 35990
    [798680173700737, 798680173746670], // 45933
    [798680453513584, 798680454463583], // 949999
    [798681234887262, 798681234916104], // 28842
    [798681235072755, 798681235122755], // 50000
    [798681235208973, 798681235258973], // 50000
    [798681235258973, 798681235308973], // 50000
    [798681235377423, 798681235427423], // 50000
    [798681235427423, 798681235477423], // 50000
    [798681235530423, 798681235580423], // 50000
    [798681235580423, 798681235630423], // 50000
    [798815045200322, 798815045866228], // 665906
    [798943660870537, 798943660876792], // 6255
    [799060000000000, 799060001425938], // 1425938
    [799099894343208, 799099894694278], // 351070
    [799303926806036, 799303926856036], // 50000
    [799382297027290, 799382339876290], // 42849000
    [799443975050000, 799444013050000], // 38000000
    [799625504215306, 799625504265306], // 50000
    [799625510391506, 799625510441506], // 50000
    [799625520208006, 799625520258006], // 50000
    [799886499773678, 799886562208146], // 62434468
    [799995842384883, 799996167384883], // 325000000
    [800212006952456, 800212008632108], // 1679652
    [800212681031287, 800212688230775], // 7199488
    [800232382913018, 800232383913302], // 1000284
    [800280782156299, 800280793054976], // 10898677
    [800352586865691, 800352587495037], // 629346
    [800628305396238, 800628305396738], // 500
    [800797584489035, 800797584989035], // 500000
    [800938357962014, 800938357972014], // 10000
    [801020001731492, 801020096619950], // 94888458
    [801206984466372, 801206986165031], // 1698659
    [801287838236168, 801287895640336], // 57404168
    [801507909472454, 801507909694029], // 221575
    [801528310873011, 801528313100609], // 2227598
    [801923522834198, 801923522884198], // 50000
    [801982973772336, 801983129772336], // 156000000
    [802032579439018, 802032580439018], // 1000000
    [802110872098267, 802110872171403], // 73136
    [802134631321739, 802134634271738], // 2949999
    [802285624242461, 802285983202925], // 358960464
    [802411806795046, 802411866795046], // 60000000
    [802500741815763, 802500754597692], // 12781929
    [802557035734332, 802557035833175], // 98843
    [802557035833176, 802557036232518], // 399342
    [802736342154002, 802736342204002], // 50000
    [802829065640071, 802829065690071], // 50000
    [802852648387943, 802852648437943], // 50000
    [802852648887943, 802852648937943], // 50000
    [802886862793074, 802886864265113], // 1472039
    [803193559713154, 803193559763154], // 50000
    [803193559763154, 803193559813154], // 50000
    [803287493660033, 803287493710033], // 50000
    [803300537394884, 803300538861848], // 1466964
    [803359583329876, 803359583473480], // 143604
    [803368661113949, 803368661205638], // 91689
    [803524993150000, 803525000000000], // 6850000
    [803556067699536, 803556075686778], // 7987242
    [803731632432363, 803731633134362], // 701999
    [803732120076120, 803732120183909], // 107789
    [803767822907438, 803767869237438], // 46330000
    [803889652997849, 803889653047849], // 50000
    [804067704698007, 804067705098007], // 400000
    [804321957289092, 804321959659970], // 2370878
    [804690713241811, 804690713266811], // 25000
    [804767067812735, 804767067862735], // 50000
    [805080023022819, 805080023072819], // 50000
    [805081367869976, 805081367968787], // 98811
    [805081368558337, 805081369340789], // 782452
    [805104555505717, 805104555548466], // 42749
    [805225070518222, 805225070568222], // 50000
    [805504785106642, 805504796134741], // 11028099
    [805723473607548, 805724433244881], // 959637333
    [805747944923730, 805747947089890], // 2166160
    [805800015641222, 805800015691222], // 50000
    [805800015691222, 805800015741222], // 50000
    [806066339795410, 806066460197780], // 120402370
    [806196222714862, 806196223032489], // 317627
    [806353802871313, 806353974250000], // 171378687
    [806437111863142, 806437113633142], // 1770000
    [806470283611589, 806470308002023], // 24390434
    [806634667540390, 806634679418230], // 11877840
    [806634965707377, 806634965807377], // 100000
    [806839674867267, 806839681757212], // 6889945
    [806874681080390, 806874681569115], // 488725
    [806888777193887, 806888777212524], // 18637
    [807062344767550, 807062345367550], // 600000
    [807124198249171, 807124198295936], // 46765
    [807181001850306, 807181002470706], // 620400
    [807181026925657, 807181026975657], // 50000
    [807269858354029, 807269860168125], // 1814096
    [807328253496036, 807328264050000], // 10553964
    [807359784200000, 807359895710625], // 111510625
    [807642591121915, 807642591675763], // 553848
    [807887133050000, 807887261516441], // 128466441
    [807906057056915, 807906057056920], // 5
    [808026428399551, 808026428449551], // 50000
    [808036449220146, 808036449675276], // 455130
    [808072013762472, 808072013812472], // 50000
    [808077973157575, 808077973328189], // 170614
    [808078374557867, 808078374590512], // 32645
    [808290208465018, 808290264626018], // 56161000
    [808539615226947, 808539616252527], // 1025580
    [808563050888413, 808563053115587], // 2227174
    [808607593271019, 808607683957353], // 90686334
    [808623671463841, 808623684585747], // 13121906
    [808661409068845, 808661445018845], // 35950000
    [809274971200001, 809275000000000], // 28799999
    [809381220615102, 809381221239602], // 624500
    [809437296659499, 809437318504277], // 21844778
    [809438444841882, 809438483458242], // 38616360
    [809463170249802, 809463170299802], // 50000
    [809463170419802, 809463170469802], // 50000
    [809463170559802, 809463170609802], // 50000
    [809463170639802, 809463170689802], // 50000
    [809592466612688, 809592475267936], // 8655248
    [809685884346257, 809685884396257], // 50000
    [809900120162986, 809900120212986], // 50000
    [809900142453527, 809900142503527], // 50000
    [809900142503527, 809900142509466], // 5939
    [809900144145065, 809900144166514], // 21449
    [810011483454529, 810011510870529], // 27416000
    [810080511145646, 810080590959506], // 79813860
    [810088818891575, 810088818941543], // 49968
    [810097051053435, 810097051063780], // 10345
    [810108882130243, 810108882230243], // 100000
    [810183946964708, 810184057456438], // 110491730
    [810583946935759, 810584050885759], // 103950000
    [810684726991760, 810684747831736], // 20839976
    [810812283709020, 810812313709020], // 30000000
    [810928419983055, 810928439430565], // 19447510
    [811060054224517, 811060106185730], // 51961213
    [811323176552429, 811323176602429], // 50000
    [811334493852920, 811334493903148], // 50228
    [811334874976237, 811334875049274], // 73037
    [811334945628428, 811334945628429], // 1
    [811334950628428, 811334951780859], // 1152431
    [811551349469883, 811551406769883], // 57300000
    [811679413333641, 811679413363641], // 30000
    [811679429313641, 811679429363641], // 50000
    [811844111562848, 811844111612848], // 50000
    [811966952457062, 811966952507062], // 50000
    [811967585511021, 811967738620363], // 153109342
    [811973124667443, 811973143767013], // 19099570
    [812109634015117, 812109635100447], // 1085330
    [812222649357545, 812222649457545], // 100000
    [812339159699223, 812339159749223], // 50000
    [812454921881872, 812454921931872], // 50000
    [812467687230216, 812467687280216], // 50000
    [812503799114971, 812503799164971], // 50000
    [812521151115144, 812521151165144], // 50000
    [812597887844197, 812597888447724], // 603527
    [812625468038618, 812625486541767], // 18503149
    [812894257408835, 812894257458835], // 50000
    [812894266558835, 812894266608835], // 50000
    [812928203840333, 812929129851924], // 926011591
    [813007123453439, 813007123703439], // 250000
    [813007302358439, 813007302388439], // 30000
    [813028863163561, 813028866163561], // 3000000
    [813187902140165, 813187902230965], // 90800
    [813209567610655, 813209567660655], // 50000
    [813209579709789, 813209579724199], // 14410
    [813264979062531, 813264979110192], // 47661
    [813287799174895, 813287799224895], // 50000
    [813287799224895, 813287799274895], // 50000
    [813287799274895, 813287799324895], // 50000
    [813287799324895, 813287799374895], // 50000
    [813287799374895, 813287799424895], // 50000
    [813287799424895, 813287799474895], // 50000
    [813287799474895, 813287799524895], // 50000
    [813289361163737, 813289361213737], // 50000
    [813319665005510, 813319666170764], // 1165254
    [813319666170764, 813319669545829], // 3375065
    [813319669695829, 813319672656038], // 2960209
    [813381325855453, 813381327564399], // 1708946
    [813408407575865, 813408807525865], // 399950000
    [813572642305455, 813572642355455], // 50000
    [813668243004659, 813668243054659], // 50000
    [813724136700000, 813724136750000], // 50000
    [813754452150002, 813754634856147], // 182706145
    [813770735740441, 813771262248315], // 526507874
    [813895467934683, 813895467984683], // 50000
    [813947174826481, 813947175090428], // 263947
    [813949441870167, 813949442473601], // 603434
    [814017477772141, 814017478778397], // 1006256
    [814029553950077, 814029554000077], // 50000
    [814099725447702, 814099725710292], // 262590
    [814163981516883, 814163981682129], // 165246
    [814266036443204, 814266037443204], // 1000000
    [814577583940299, 814577614173027], // 30232728
    [814627774650595, 814627794224224], // 19573629
    [814760499066127, 814760499116127], // 50000
    [814761444606211, 814761445466211], // 860000
    [814774195378231, 814774295378231], // 100000000
    [814875390792223, 814875390802988], // 10765
    [814891047554775, 814891119279980], // 71725205
    [814918746923291, 814918770190600], // 23267309
    [815083610434351, 815083672201058], // 61766707
    [815141374270027, 815141383038024], // 8767997
    [815271699597539, 815271757497275], // 57899736
    [815438786036702, 815438786086701], // 49999
    [815488503480607, 815488506655736], // 3175129
    [815510535375013, 815510535425013], // 50000
    [815534927661917, 815534928084618], // 422701
    [815561542754738, 815561542763422], // 8684
    [815671871889686, 815671872628722], // 739036
    [815702127944461, 815702127994460], // 49999
    [815709439617196, 815709439667196], // 50000
    [815730390618546, 815730390618547], // 1
    [815974130254793, 815974205299203], // 75044410
    [816159255412801, 816159258329228], // 2916427
    [816503764108560, 816503764462079], // 353519
    [816736136834692, 816736137834692], // 1000000
    [816787620154214, 816787621154214], // 1000000
    [816898657079939, 816898661644774], // 4564835
    [817007594505762, 817007594555762], // 50000
    [817047904445414, 817047904597397], // 151983
    [817064365464512, 817064365914511], // 449999
    [817145102819247, 817145115156440], // 12337193
    [817589585408486, 817589585458258], // 49772
    [817589585508258, 817589585558258], // 50000
    [817658683573910, 817658683754658], // 180748
    [817959897778285, 817960000000000], // 102221715
    [818056197731628, 818056227731628], // 30000000
    [818129065321027, 818129065371027], // 50000
    [818241562183234, 818241852518234], // 290335000
    [818357051833820, 818357057431820], // 5598000
    [818443009000000, 818443033900000], // 24900000
    [818608369804830, 818608369897829], // 92999
    [818793324090354, 818793324358782], // 268428
    [818956222057520, 818956223007520], // 950000
    [818959219719717, 818959219769716], // 49999
    [819009798805926, 819009798855926], // 50000
    [819199590720767, 819199590770767], // 50000
    [819280826429916, 819280838655976], // 12226060
    [819353879871491, 819353881296491], // 1425000
    [819468388399542, 819468397093959], // 8694417
    [819468674385268, 819468674435268], // 50000
    [819468722492618, 819468722542618], // 50000
    [819468722542618, 819468722592618], // 50000
    [819468968042279, 819468968092279], // 50000
    [819469115158414, 819469115208414], // 50000
    [819469116158414, 819469116208414], // 50000
    [819469117152912, 819469117252912], // 100000
    [819725163764767, 819725163814767], // 50000
    [819779236950000, 819779248950000], // 12000000
    [819784827000000, 819784842000000], // 15000000
    [819803017597008, 819803077986226], // 60389218
    [820040769964290, 820040903298251], // 133333961
    [820270483323280, 820270483373280], // 50000
    [820540233085952, 820540240055843], // 6969891
    [820607432007471, 820607432057471], // 50000
    [820720003510812, 820720005230286], // 1719474
    [820792207689602, 820792209222934], // 1533332
    [821001770000000, 821001830000000], // 60000000
    [821064729394711, 821064730021950], // 627239
    [821096576398306, 821096576403469], // 5163
    [821096598747405, 821096598797405], // 50000
    [821368478723599, 821368479132496], // 408897
    [821370949336501, 821370949526501], // 190000
    [821702585807058, 821702585857058], // 50000
    [821952409478125, 821952409485485], // 7360
    [822132402631517, 822132402802451], // 170934
    [822154028438887, 822154028488887], // 50000
    [822164285386000, 822164287386000], // 2000000
    [822255028868282, 822255067158925], // 38290643
    [822415405117254, 822415405167254], // 50000
    [822460171077426, 822460171127426], // 50000
    [822508316786617, 822508317786617], // 1000000
    [822640451541235, 822640451591235], // 50000
    [822640470316813, 822640470366813], // 50000
    [822640496694523, 822640496744523], // 50000
    [822640527970032, 822640528020032], // 50000
    [822640544199650, 822640544249650], // 50000
    [822651787458542, 822651812119822], // 24661280
    [822651869346608, 822651869347812], // 1204
    [822698986918843, 822698986968843], // 50000
    [822762369107885, 822762369521568], // 413683
    [823089834616957, 823089834616958], // 1
    [823366397677162, 823366422677162], // 25000000
    [823440767612171, 823440768616918], // 1004747
    [823561781000000, 823561790000000], // 9000000
    [823581261326885, 823581261753307], // 426422
    [823739019783282, 823739325233273], // 305449991
    [823859334236244, 823859631236244], // 297000000
    [823887501130721, 823887552529323], // 51398602
    [823901852330674, 823901852580674], // 250000
    [823931264245303, 823931264295303], // 50000
    [824140011658924, 824140015608924], // 3950000
    [824569857151038, 824569857613367], // 462329
    [824706078606203, 824706078656203], // 50000
    [824819900437839, 824819904100000], // 3662161
    [824890310187351, 824890360784134], // 50596783
    [824997300000000, 824997305114360], // 5114360
    [825315000000000, 825315000509384], // 509384
    [825460000064375, 825460000554991], // 490616
    [825508128872329, 825508128981504], // 109175
    [825534011707408, 825534016626648], // 4919240
    [825590069299999, 825590070053679], // 753680
    [825600583803125, 825600583853125], // 50000
    [825600587303125, 825600587353125], // 50000
    [825603405407254, 825603405457254], // 50000
    [825707178795752, 825707178845752], // 50000
    [825707620772153, 825707625409920], // 4637767
    [825724400269604, 825724401226111], // 956507
    [825874095969505, 825874310425835], // 214456330
    [825920105771288, 825920107301754], // 1530466
    [825980509516572, 825980509530721], // 14149
    [826001393878096, 826001397193867], // 3315771
    [826002089900026, 826002092414790], // 2514764
    [826154697200000, 826154700200000], // 3000000
    [826283815029672, 826283815075547], // 45875
    [826329421851688, 826329430097028], // 8245340
    [826381791791152, 826381792291152], // 500000
    [826523880345828, 826523880582459], // 236631
    [826543058587649, 826543058751715], // 164066
    [826560592919808, 826560592969808], // 50000
    [826719624628669, 826719624678669], // 50000
    [826788936017526, 826788987792907], // 51775381
    [826821485891671, 826821487666715], // 1775044
    [826822231967411, 826822234032657], // 2065246
    [826829237874608, 826829237924608], // 50000
    [826861700172101, 826861700736654], // 564553
    [827010007203301, 827010012406401], // 5203100
    [827055417140000, 827055417190000], // 50000
    [827067183189689, 827067184024689], // 835000
    [827067184074689, 827067184524689], // 450000
    [827090400835324, 827090400885324], // 50000
    [827090412385324, 827090412435324], // 50000
    [827094680580367, 827094680581587], // 1220
    [827125828175919, 827125828178723], // 2804
    [827402263187553, 827402445247553], // 182060000
    [827421029828639, 827421030697937], // 869298
    [827435896395479, 827435909663813], // 13268334
    [827547067437750, 827547067725315], // 287565
    [827570546361013, 827570546411013], // 50000
    [827589949633259, 827589949651513], // 18254
    [827607960849371, 827608020849371], // 60000000
    [827653358457151, 827653358517151], // 60000
    [827811595793298, 827811595793299], // 1
    [827835009406050, 827835009412262], // 6212
    [827848632619523, 827848632669523], // 50000
    [827859516333532, 827859516343200], // 9668
    [827919535597790, 827919537251486], // 1653696
    [827935260416658, 827935260466658], // 50000
    [828043614210466, 828043614260466], // 50000
    [828080578389203, 828080593953363], // 15564160
    [828419284019928, 828419400400375], // 116380447
    [828438804156109, 828438804206109], // 50000
    [828438804206109, 828438804256109], // 50000
    [828495046615514, 828495046665514], // 50000
    [828608333027955, 828608333038475], // 10520
    [828675615198847, 828675615248847], // 50000
    [828688298076738, 828688303526796], // 5450058
    [828717049116877, 828717050297733], // 1180856
    [828830001049982, 828830019234578], // 18184596
    [828870169850000, 828870169900000], // 50000
    [829232681598759, 829232685034855], // 3436096
    [829232716174674, 829232728853757], // 12679083
    [829244210555722, 829244210605722], // 50000
    [829280525263600, 829280535203600], // 9940000
    [829371557799923, 829371620871439], // 63071516
    [829454438950000, 829454439000000], // 50000
    [829538020878576, 829538020928576], // 50000
    [829548471332460, 829548518431739], // 47099279
    [829590019195794, 829590019245794], // 50000
    [829713761963324, 829713771813324], // 9850000
    [830094929313908, 830094977000010], // 47686102
    [830095145249849, 830095145734130], // 484281
    [830160000936801, 830160001429940], // 493139
    [830395661484252, 830395661562917], // 78665
    [830397016454060, 830397016723453], // 269393
    [830397326517181, 830397326567181], // 50000
    [830400571682856, 830400597624893], // 25942037
    [830411803828516, 830411956465413], // 152636897
    [830468129935138, 830468130039399], // 104261
    [830623374688956, 830623488688956], // 114000000
    [830631873454148, 830631873554148], // 100000
    [830635539428122, 830635539478122], // 50000
    [830641762295293, 830641788323588], // 26028295
    [830714656978717, 830714658978717], // 2000000
    [830756199032936, 830756199082936], // 50000
    [830770097486997, 830770097536997], // 50000
    [830895781574745, 830895781576978], // 2233
    [830945111132060, 830945111282059], // 149999
    [831018048298746, 831018048348746], // 50000
    [831077105421324, 831077105471324], // 50000
    [831078042148369, 831078042198369], // 50000
    [831152723168623, 831152726278532], // 3109909
    [831269405805731, 831269405855731], // 50000
    [831296884751323, 831296884801323], // 50000
    [831325001869778, 831325001872931], // 3153
    [831340634509862, 831340634559862], // 50000
    [831340750447717, 831340750497717], // 50000
    [831340788006539, 831340788056539], // 50000
    [831340809731637, 831340809781637], // 50000
    [831340940442795, 831340940492795], // 50000
    [831341074171925, 831341074221925], // 50000
    [831342176053428, 831342176103428], // 50000
    [831342234922680, 831342234972680], // 50000
    [831342369459134, 831342369509134], // 50000
    [831342462741631, 831342462791631], // 50000
    [831368721521242, 831368721571242], // 50000
    [831372800157752, 831372800671772], // 514020
    [831456746910519, 831456746947645], // 37126
    [831464305656461, 831464305706461], // 50000
    [831500484850000, 831500484900000], // 50000
    [831579309095347, 831579309145347], // 50000
    [831623194579905, 831623194629905], // 50000
    [831704980380608, 831704980430608], // 50000
    [831721497186632, 831721497418392], // 231760
    [831721519531571, 831721519531572], // 1
    [831905360641936, 831905376453462], // 15811526
    [831919064455972, 831919065767295], // 1311323
    [831925555297045, 831925555347045], // 50000
    [831938814301000, 831939054601000], // 240300000
    [831981856907950, 831981856957950], // 50000
    [832180493379714, 832180493429714], // 50000
    [832180814943568, 832180815016406], // 72838
    [832192004922614, 832192005923114], // 1000500
    [832245811615412, 832245811665412], // 50000
    [832245851688115, 832245851723224], // 35109
    [832281876535331, 832281878631610], // 2096279
    [832284998501267, 832285000000000], // 1498733
    [832650672642412, 832650676240972], // 3598560
    [832803999505716, 832803999555716], // 50000
    [832903833488001, 832903878468182], // 44980181
    [832939292378782, 832939292578782], // 200000
    [832993153355403, 832993692140571], // 538785168
    [833160880242789, 833160910785789], // 30543000
    [833224260750577, 833224278257868], // 17507291
    [833239596669530, 833239596719530], // 50000
    [833239601319470, 833239601369470], // 50000
    [833265716610906, 833265717560906], // 950000
    [833432964899303, 833432964949303], // 50000
    [833432974849303, 833432974899303], // 50000
    [833705464120151, 833705464120152], // 1
    [833852975279350, 833852975324215], // 44865
    [833884111149522, 833884111192548], // 43026
    [833939656892126, 833939656892127], // 1
    [834029097733978, 834029153213450], // 55479472
    [834175089738575, 834175098167851], // 8429276
    [834191641011772, 834191744050313], // 103038541
    [834196887607380, 834196890892132], // 3284752
    [834261214907319, 834261224423341], // 9516022
    [834308174803552, 834308175766426], // 962874
    [834522470202709, 834522473200000], // 2997291
    [834553362680323, 834553995439748], // 632759425
    [834580441593399, 834580480000000], // 38406601
    [834681297672748, 834681297722748], // 50000
    [834706362852593, 834706363353635], // 501042
    [834797884976526, 834797952756546], // 67780020
    [834858567745741, 834858567795741], // 50000
    [834867506947592, 834867507397591], // 449999
    [834867544747591, 834867549221618], // 4474027
    [834925100707740, 834925104712325], // 4004585
    [834951981757703, 834951984219387], // 2461684
    [834970885830722, 834970910830722], // 25000000
    [835045780000000, 835045840000000], // 60000000
    [835357137121178, 835357137183054], // 61876
    [835410289224132, 835410289851096], // 626964
    [835544048384416, 835544050578903], // 2194487
    [835544665129671, 835544665179671], // 50000
    [835644436797554, 835644436847554], // 50000
    [835720970447010, 835720970547010], // 100000
    [835751023989402, 835751024039402], // 50000
    [835991271230143, 835991280581756], // 9351613
    [836013781099819, 836013781099820], // 1
    [836047298075539, 836047298125539], // 50000
    [836125576539053, 836125578063387], // 1524334
    [836200314550800, 836200315025691], // 474891
    [836399255540606, 836399255590606], // 50000
    [836497569578266, 836497614602936], // 45024670
    [836550183997208, 836550184047208], // 50000
    [836693125000000, 836693241000000], // 116000000
    [836754776050000, 836754795547940], // 19497940
    [836789320352630, 836789320552630], // 200000
    [836789332452706, 836789332692505], // 239799
    [836793508334339, 836793508384339], // 50000
    [836803345186176, 836803345236176], // 50000
    [836863333878730, 836863333928730], // 50000
    [837128371856452, 837128371902386], // 45934
    [837145037769042, 837145038292262], // 523220
    [837191134087187, 837191160293036], // 26205849
    [837225532088217, 837225540842628], // 8754411
    [837243006154353, 837243007519861], // 1365508
    [837643932776432, 837643933820604], // 1044172
    [837675196960764, 837675232621254], // 35660490
    [837754916852462, 837754918667854], // 1815392
    [837864541970251, 837864542244850], // 274599
    [838018433202866, 838018433548624], // 345758
    [838182077382507, 838182077432507], // 50000
    [838217940875930, 838217940913602], // 37672
    [838217989576132, 838217990261318], // 685186
    [838250564446726, 838250564446727], // 1
    [838308126659272, 838308127459271], // 799999
    [838374120388814, 838374120438814], // 50000
    [838479400100000, 838479417100000], // 17000000
    [838525025935616, 838525060885616], // 34950000
    [838682176792661, 838682319962480], // 143169819
    [838741213300000, 838741225300000], // 12000000
    [838768312175671, 838768312225671], // 50000
    [838815193990142, 838815194050282], // 60140
    [838817051285660, 838817051735659], // 449999
    [839264964650000, 839264976650000], // 12000000
    [839464272314722, 839464279214722], // 6900000
    [839479634430527, 839479643430527], // 9000000
    [839483683613475, 839483759338839], // 75725364
    [839953870323162, 839953877504783], // 7181621
    [840143505195795, 840143506824871], // 1629076
    [840147294555983, 840147305006061], // 10450078
    [840785580416296, 840785593958344], // 13542048
    [840787499698488, 840787517186143], // 17487655
    [840826191791345, 840826191843596], // 52251
    [840826192535079, 840826192651024], // 115945
    [840826192651024, 840826195172766], // 2521742
    [840888757935842, 840888758435842], // 500000
    [840934765074508, 840934765074509], // 1
    [840954585428413, 840954636603360], // 51174947
    [841262366934289, 841262374934289], // 8000000
    [841277341924547, 841277341974547], // 50000
    [841277434610176, 841277437760523], // 3150347
    [841353987214882, 841353988214882], // 1000000
    [841365242850000, 841365267850000], // 25000000
    [841382568630250, 841382568680250], // 50000
    [841584195953575, 841584359015784], // 163062209
    [841784042986051, 841784043014176], // 28125
    [841863573952283, 841863575032283], // 1080000
    [842055675963443, 842055676013443], // 50000
    [842055756425633, 842055756475633], // 50000
    [842055756475633, 842055756525633], // 50000
    [842094540750934, 842094541204811], // 453877
    [842109591055822, 842109591105822], // 50000
    [842236884939250, 842236885123805], // 184555
    [842358993050000, 842359159050000], // 166000000
    [842399783059912, 842399783106412], // 46500
    [842425411351957, 842425411361957], // 10000
    [842648819521038, 842648819571038], // 50000
    [842670104682117, 842670104684514], // 2397
    [842829512432265, 842829514335389], // 1903124
    [842829523947226, 842829524021330], // 74104
    [842906357757939, 842906359494869], // 1736930
    [842906359544870, 842906369444869], // 9899999
    [843008080189200, 843008080239200], // 50000
    [843008080329200, 843008080379200], // 50000
    [843008080409200, 843008080459200], // 50000
    [843008080519200, 843008080569200], // 50000
    [843008273653340, 843008273669200], // 15860
    [843179010419642, 843179038724642], // 28305000
    [843184659000000, 843184674000000], // 15000000
    [843439671344036, 843439695038163], // 23694127
    [843474591787426, 843474591837426], // 50000
    [843506170189431, 843506170239431], // 50000
    [843654603725355, 843654637720355], // 33995000
    [843828547868208, 843828547891725], // 23517
    [843931538950754, 843931538981632], // 30878
    [843931538981632, 843931539031632], // 50000
    [843931539117850, 843931539167850], // 50000
    [843931539167850, 843931539217850], // 50000
    [843931539286300, 843931539336300], // 50000
    [843931539336300, 843931539386300], // 50000
    [843931539593471, 843931539643471], // 50000
    [843931539773620, 843931539823620], // 50000
    [843931539823620, 843931539873620], // 50000
    [843941185736939, 843941197727839], // 11990900
    [843985019268229, 843985036868229], // 17600000
    [843985177585679, 843985197585679], // 20000000
    [844033445157131, 844033445207131], // 50000
    [844051073067484, 844051074924128], // 1856644
    [844051130606816, 844051130656816], // 50000
    [844059591824162, 844059596897763], // 5073601
    [844089590056423, 844089590409519], // 353096
    [844095041202541, 844095041252541], // 50000
    [844095053692339, 844095053742339], // 50000
    [844095080742339, 844095080792339], // 50000
    [844095083167139, 844095083217139], // 50000
    [844095090585339, 844095090635339], // 50000
    [844095110635339, 844095110685339], // 50000
    [844095112760711, 844095112793747], // 33036
    [844102106150000, 844102170150000], // 64000000
    [844217492980243, 844217513259958], // 20279715
    [844374120534038, 844374120584038], // 50000
    [844562668340609, 844562682290609], // 13950000
    [844562811350000, 844562836350000], // 25000000
    [844676046079715, 844676046079976], // 261
    [844724657135457, 844724697035457], // 39900000
    [844729144855510, 844729145805510], // 950000
    [844729271910184, 844729271960184], // 50000
    [844729272060184, 844729272110184], // 50000
    [844944650506004, 844944668506004], // 18000000
    [844973143937777, 844973145810681], // 1872904
    [844989095791635, 844989095827486], // 35851
    [844989181149526, 844989181611492], // 461966
    [845059998591907, 845059998750575], // 158668
    [845070249792788, 845070249842788], // 50000
    [845088912470652, 845088912520652], // 50000
    [845088983215403, 845088983265403], // 50000
    [845253166608469, 845253273904376], // 107295907
    [845320705362063, 845320716394222], // 11032159
    [845362251845811, 845362251895811], // 50000
    [845367909790613, 845367909890613], // 100000
    [845554850910241, 845554850960241], // 50000
    [845556662040386, 845556662090386], // 50000
    [845570189255854, 845570190094174], // 838320
    [845614540000000, 845614559000000], // 19000000
    [845775782429136, 845775826429136], // 44000000
    [845803134041285, 845803136511961], // 2470676
    [846004429006401, 846004440283110], // 11276709
    [846016118627522, 846016123844942], // 5217420
    [846083882822883, 846083882874305], // 51422
    [846235134412713, 846235134707711], // 294998
    [846258668465225, 846258668845225], // 380000
    [846302956659308, 846302956709308], // 50000
    [846303590473504, 846303590523504], // 50000
    [846303842292614, 846303842342614], // 50000
    [846304552492608, 846304552542608], // 50000
    [846304983782569, 846304983811937], // 29368
    [846304986428445, 846304986735512], // 307067
    [846360561050000, 846360570921028], // 9871028
    [846444451780970, 846444487780970], // 36000000
    [846445223213916, 846445225137995], // 1924079
    [846595039702874, 846595041532796], // 1829922
    [846647482484879, 846647482974973], // 490094
    [846685610000000, 846685629560281], // 19560281
    [846823311627958, 846823311677958], // 50000
    [846945600963006, 846945601313006], // 350000
    [846991077469018, 846991077519018], // 50000
    [847017921210000, 847017950210000], // 29000000
    [847075800013306, 847075800967154], // 953848
    [847075844016504, 847075844025721], // 9217
    [847361877826148, 847361902325216], // 24499068
    [847439553548808, 847439554553231], // 1004423
    [847458131304541, 847458131396845], // 92304
    [847595560547203, 847595561386356], // 839153
    [847596777606609, 847596777606610], // 1
    [847632275854020, 847632278681020], // 2827000
    [847645749000182, 847645749050182], // 50000
    [847670225500000, 847670241500000], // 16000000
    [847682227949988, 847682264949988], // 37000000
    [847694076000140, 847694084900140], // 8900000
    [847698290829486, 847698379375737], // 88546251
    [847715812468045, 847715854468045], // 42000000
    [847744810700000, 847744811050752], // 350752
    [847756644752607, 847756644850607], // 98000
    [847770653565265, 847770654565265], // 1000000
    [847931800300000, 847931921300000], // 121000000
    [847980698911353, 847980698961353], // 50000
    [847980699296768, 847980699332803], // 36035
    [848120283570346, 848120292720813], // 9150467
    [848360804992829, 848360805379400], // 386571
    [848463601980716, 848463626980716], // 25000000
    [848470728874478, 848470774574478], // 45700000
    [848481022559735, 848481022609735], // 50000
    [848481473015735, 848481473065735], // 50000
    [848483022408935, 848483022458935], // 50000
    [848507555372608, 848507649915832], // 94543224
    [848544153111266, 848544213111266], // 60000000
    [848549327853263, 848549328217320], // 364057
    [848566666449106, 848566952092512], // 285643406
    [848591567207369, 848591567737465], // 530096
    [848600008716074, 848600021555434], // 12839360
    [848601740549326, 848601740599326], // 50000
    [848601740607326, 848601740657326], // 50000
    [848601740665326, 848601740715326], // 50000
    [848601740779326, 848601740829326], // 50000
    [848601740845326, 848601740895326], // 50000
    [848601740943326, 848601740993326], // 50000
    [848601741017326, 848601741067326], // 50000
    [848601741075326, 848601741125326], // 50000
    [848601741141326, 848601741191326], // 50000
    [848601741199326, 848601741249326], // 50000
    [848601741257326, 848601741307326], // 50000
    [848601741331326, 848601741381326], // 50000
    [848601741413326, 848601741463326], // 50000
    [848601741471326, 848601741521326], // 50000
    [848601741537326, 848601741587326], // 50000
    [848601741611326, 848601741661326], // 50000
    [848601741685326, 848601741735326], // 50000
    [848601741743326, 848601741793326], // 50000
    [848601741801326, 848601741851326], // 50000
    [848601741859326, 848601741909326], // 50000
    [848601741949326, 848601741999326], // 50000
    [848625393292702, 848625394440973], // 1148271
    [848674373678675, 848674373728675], // 50000
    [848764817285947, 848764817454777], // 168830
    [848814609552281, 848814638170187], // 28617906
    [848875610181717, 848875611008090], // 826373
    [849002109100000, 849002158100000], // 49000000
    [849228894199474, 849228899857118], // 5657644
    [849245046235678, 849245046810808], // 575130
    [849286675774105, 849286675824106], // 50001
    [849286675824106, 849286676029106], // 205000
    [849441742074459, 849441815412861], // 73338402
    [849551644155074, 849551644255074], // 100000
    [849552255682860, 849552303682860], // 48000000
    [849590739506174, 849590739626174], // 120000
    [849658736475531, 849658736804937], // 329406
    [849658738825164, 849658739011649], // 186485
    [849722170078825, 849722170128825], // 50000
    [849857868656305, 849857903335914], // 34679609
    [850064501151933, 850064501651933], // 500000
    [850200648347241, 850200648502429], // 155188
    [850249336248071, 850249336469299], // 221228
    [850280317338758, 850280371338758], // 54000000
    [850325681941844, 850325684028589], // 2086745
    [850326942885845, 850326942935845], // 50000
    [850500749255000, 850500797255000], // 48000000
    [850557445367428, 850557610899178], // 165531750
    [850732639405301, 850732639465301], // 60000
    [850750917215561, 850750917216324], // 763
    [850883615106533, 850883675106533], // 60000000
    [850883676165657, 850883705156533], // 28990876
    [851014645579994, 851014645629994], // 50000
    [851297841066485, 851297841116485], // 50000
    [851349249887374, 851349252056346], // 2168972
    [851396096042259, 851396098103144], // 2060885
    [851396207277251, 851396207377251], // 100000
    [851427442933149, 851427442983149], // 50000
    [851427442983149, 851427443033149], // 50000
    [851548038885741, 851548038985741], // 100000
    [851561624123543, 851561624137508], // 13965
    [851561624361492, 851561624411492], // 50000
    [851561624411492, 851561624461492], // 50000
    [851561624649739, 851561624699739], // 50000
    [851561624699739, 851561624749739], // 50000
    [851568365178911, 851568365228911], // 50000
    [851626867402448, 851626877302448], // 9900000
    [851626877402448, 851626887395431], // 9992983
    [851647512994589, 851647513044589], // 50000
    [851746519160497, 851746519660497], // 500000
    [851766435248791, 851766485819514], // 50570723
    [851793303150000, 851793341300000], // 38150000
    [851948541177959, 851948541325726], // 147767
    [852286840000000, 852286900000000], // 60000000
    [852347703898743, 852347706682677], // 2783934
    [852347837588275, 852347838128275], // 540000
    [852410127993134, 852410128032614], // 39480
    [852410153055555, 852410153105555], // 50000
    [852422474381570, 852422476098210], // 1716640
    [852422511873703, 852422512340031], // 466328
    [852422685826190, 852422686091644], // 265454
    [852560217192452, 852560220192452], // 3000000
    [852660005230777, 852660005680776], // 449999
    [852708686184243, 852708686420267], // 236024
    [852736929157003, 852736929207003], // 50000
    [852739442050000, 852739469050000], // 27000000
    [852876136660259, 852876136688421], // 28162
    [853106867837220, 853107013675396], // 145838176
    [853463425008905, 853463476345105], // 51336200
    [853616316010018, 853616341639758], // 25629740
    [853616341689758, 853616349147595], // 7457837
    [853639714387646, 853639723754460], // 9366814
    [853711899058923, 853711965158923], // 66100000
    [853777635262014, 853777680375200], // 45113186
    [853950780000000, 853950907000000], // 127000000
    [854040375811147, 854040375861147], // 50000
    [854081040480820, 854081997291187], // 956810367
    [854112742826739, 854112742876739], // 50000
    [854112742876739, 854112742926739], // 50000
    [854202951947097, 854202951997097], // 50000
    [854232725319325, 854232725418381], // 99056
    [854285032066707, 854285033091746], // 1025039
    [854362714434404, 854362714605228], // 170824
    [854392632556122, 854392632556123], // 1
    [854604734639204, 854604984639204], // 250000000
    [854608835144784, 854608836283631], // 1138847
    [854782706211326, 854782706754535], // 543209
    [854783363906072, 854783380022321], // 16116249
    [854825630000000, 854825690000000], // 60000000
    [854934110659631, 854934114389565], // 3729934
    [854934114493443, 854934116097707], // 1604264
    [854937348101790, 854937348151790], // 50000
    [854937348151790, 854937348201790], // 50000
    [854937444923520, 854937444973520], // 50000
    [855055381417634, 855055381467634], // 50000
    [855066795440531, 855066798334277], // 2893746
    [855161226659747, 855161226739747], // 80000
    [855219041605202, 855219041900867], // 295665
    [855219042000868, 855219043403965], // 1403097
    [855225000016865, 855225000400000], // 383135
    [855366780076992, 855366780167065], // 90073
    [855370936050000, 855371064050000], // 128000000
    [855467332735786, 855467336904058], // 4168272
    [855471269650000, 855471497150000], // 227500000
    [855563773612258, 855563773662258], // 50000
    [855563773662258, 855563773701630], // 39372
    [855563774118326, 855563774168326], // 50000
    [855570770530916, 855570775905234], // 5374318
    [855591314931231, 855591321185318], // 6254087
    [855771118320576, 855771118325864], // 5288
    [855844825969194, 855844826859249], // 890055
    [856007739766372, 856007841561153], // 101794781
    [856033026274258, 856033028034226], // 1759968
    [856176249869990, 856176249919990], // 50000
    [856295921420216, 856295921470216], // 50000
    [856318774068657, 856318774118657], // 50000
    [856354973549609, 856354974503457], // 953848
    [856414584082674, 856414953132603], // 369049929
    [856470387061218, 856470389512802], // 2451584
    [856717493448804, 856717514074486], // 20625682
    [856759800781595, 856759800790195], // 8600
    [856786353257767, 856786357872767], // 4615000
    [856786871378720, 856786871445640], // 66920
    [856875513201897, 856875524615925], // 11414028
    [856927518753789, 856927535023118], // 16269329
    [857032114902009, 857032115852009], // 950000
    [857101616845375, 857101616866307], // 20932
    [857104600676647, 857104600701647], // 25000
    [857193831332216, 857193834109196], // 2776980
    [857426150423459, 857426151781288], // 1357829
    [857445008434217, 857445008574560], // 140343
    [857473249911791, 857473250077535], // 165744
    [857572309494092, 857572310494983], // 1000891
    [857584901724826, 857584903724826], // 2000000
    [857584905618036, 857584907521161], // 1903125
    [857584907621161, 857584908164371], // 543210
    [857650010101518, 857650010461175], // 359657
    [857673378250000, 857674194250000], // 816000000
    [857742278369008, 857742290369008], // 12000000
    [857770796619341, 857770796669341], // 50000
    [857852635022149, 857852635072149], // 50000
    [858047356915893, 858047357339126], // 423233
    [858062094371159, 858062094421159], // 50000
    [858481559796405, 858482255139933], // 695343528
    [858997506991393, 858997550727637], // 43736244
    [859160005050000, 859160007696208], // 2646208
    [859160007746208, 859160018000000], // 10253792
    [859189272075550, 859189272975549], // 899999
    [859525527168943, 859525538450819], // 11281876
    [859626106400501, 859626106450501], // 50000
    [859682132827965, 859682132897965], // 70000
    [859769427460000, 859769441460000], // 14000000
    [859934538284282, 859934538328743], // 44461
    [859985675061222, 859985675111222], // 50000
    [859992660270251, 859992660320251], // 50000
    [860122991940694, 860122991990694], // 50000
    [860123036069750, 860123036709694], // 639944
    [860180351022091, 860180351072091], // 50000
    [860180422066396, 860180422337895], // 271499
    [860181584443070, 860181584454180], // 11110
    [860418467202502, 860418467446001], // 243499
    [860441303382665, 860441303432665], // 50000
    [860459711492031, 860459711580155], // 88124
    [860520837481191, 860520839250695], // 1769504
    [860544807534205, 860544821434546], // 13900341
    [860685250482041, 860685279113703], // 28631662
    [860687311497494, 860687334309401], // 22811907
    [860840966000000, 860840977000000], // 11000000
    [861159264115834, 861159269770454], // 5654620
    [861159270421464, 861159272533252], // 2111788
    [861228400222480, 861228400402480], // 180000
    [861316551544976, 861316784069947], // 232524971
    [861337527187010, 861338214881579], // 687694569
    [861353499151004, 861353500151004], // 1000000
    [861391690115546, 861391690165546], // 50000
    [861570863350000, 861570877350000], // 14000000
    [861584467964478, 861584485166365], // 17201887
    [861671452040607, 861671505971619], // 53931012
    [861673965246314, 861673994837987], // 29591673
    [861800149374386, 861800149509626], // 135240
    [861890108642512, 861890108646126], // 3614
    [861984406814309, 861984407833900], // 1019591
    [862059804867372, 862059804917372], // 50000
    [862063881127445, 862063881977445], // 850000
    [862223296730028, 862223356730028], // 60000000
    [862341472379978, 862341472379979], // 1
    [862345724196749, 862345724246749], // 50000
    [862345882311072, 862345882361072], // 50000
    [862350750802996, 862350750852996], // 50000
    [862385899218405, 862385899988405], // 770000
    [862385899988405, 862385900608405], // 620000
    [862404738585882, 862404739158356], // 572474
    [862420159358584, 862420159374702], // 16118
    [862420212455758, 862420214455758], // 2000000
    [862543154008259, 862543154133656], // 125397
    [862562530477587, 862562530527587], // 50000
    [862590378607790, 862590378657790], // 50000
    [862843937542514, 862843937673345], // 130831
    [862845693866002, 862845713137651], // 19271649
    [863010464779000, 863010472780000], // 8001000
    [863138348300000, 863138357218962], // 8918962
    [863182944392718, 863182944442718], // 50000
    [863205297136663, 863205297586663], // 450000
    [863266043315728, 863266358334305], // 315018577
    [863316286909782, 863316326367356], // 39457574
    [863340381704303, 863340382558151], // 853848
    [863391515096939, 863391520626941], // 5530002
    [863400853697828, 863400853747828], // 50000
    [863400853747828, 863400853797828], // 50000
    [863403256383677, 863403266537114], // 10153437
    [863480123558521, 863480176347429], // 52788908
    [863521038013360, 863521040135439], // 2122079
    [863607132599648, 863607137798579], // 5198931
    [863672290615809, 863672290699009], // 83200
    [863738557359487, 863738558765349], // 1405862
    [863755422139661, 863755480407415], // 58267754
    [863756685191253, 863756685241253], // 50000
    [864136543567380, 864136546765952], // 3198572
    [864187253629862, 864187256079862], // 2450000
    [864245050004061, 864245050054061], // 50000
    [864653129311531, 864653129500944], // 189413
    [864653156412103, 864653157496119], // 1084016
    [864653157646477, 864653159496476], // 1849999
    [864780659600709, 864780659650709], // 50000
    [864936565338265, 864936565348265], // 10000
    [864984719692480, 864984719742480], // 50000
    [865012058108638, 865012061039285], // 2930647
    [865087374793200, 865087374843200], // 50000
    [865098596155290, 865098596655290], // 500000
    [865144453887295, 865144454387334], // 500039
    [865205188776932, 865205190371106], // 1594174
    [865244763798976, 865244792974416], // 29175440
    [865265474266181, 865265474316181], // 50000
    [865324985073100, 865324990255723], // 5182623
    [865415474989001, 865415475089001], // 100000
    [865415476996618, 865415478521959], // 1525341
    [865415506571959, 865415524489001], // 17917042
    [865415674639001, 865415675289001], // 650000
    [865447612763852, 865447617988164], // 5224312
    [865614517610027, 865614517617917], // 7890
    [865639969897129, 865639980147001], // 10249872
    [865719280685497, 865719283135496], // 2449999
    [865728539554202, 865728539604202], // 50000
    [866000379763843, 866000379863843], // 100000
    [866218878387791, 866218921510000], // 43122209
    [866250948966487, 866250952916486], // 3949999
    [866307388326258, 866307388376258], // 50000
    [866330412298883, 866330412348883], // 50000
    [866333529950938, 866333530000938], // 50000
    [866333843446711, 866333843496711], // 50000
    [866352789465862, 866352789515862], // 50000
    [866405005123505, 866405028009196], // 22885691
    [866420982213014, 866420983213014], // 1000000
    [866492915050000, 866492915100000], // 50000
    [866530657520641, 866530657620641], // 100000
    [866597285211504, 866597285261504], // 50000
    [866598541050000, 866598541100000], // 50000
    [866599271050000, 866599271100000], // 50000
    [866628247053256, 866628257713285], // 10660029
    [866664167842276, 866664167892276], // 50000
    [866697000564917, 866697000614917], // 50000
    [866755001000000, 866755001495415], // 495415
    [866880290207543, 866880290257543], // 50000
    [866941754082000, 866941754132000], // 50000
    [867015140648273, 867015140736111], // 87838
    [867023334236266, 867023335145469], // 909203
    [867076018850000, 867076019850000], // 1000000
    [867349996703883, 867350000000000], // 3296117
    [867400483663189, 867400507301189], // 23638000
    [867401331885964, 867401331897114], // 11150
    [867671347153704, 867671348155212], // 1001508
    [867761693012370, 867761695821130], // 2808760
    [867765810952533, 867765817748934], // 6796401
    [867768828594451, 867768828644451], // 50000
    [867900031150000, 867900045150000], // 14000000
    [868031550442837, 868031550884910], // 442073
    [868065420122329, 868065420726177], // 603848
    [868071321476033, 868071321536378], // 60345
    [868071330609827, 868071330609828], // 1
    [868083052606269, 868083052767886], // 161617
    [868120410330930, 868120416300730], // 5969800
    [868167726935419, 868167730265685], // 3330266
    [868223472700642, 868223475475312], // 2774670
    [868295168019250, 868295266177008], // 98157758
    [868374848050000, 868374963050000], // 115000000
    [868386422052287, 868386423128819], // 1076532
    [868428735368478, 868428736152558], // 784080
    [868508234616554, 868508234666554], // 50000
    [868508234666554, 868508234716554], // 50000
    [868650935524321, 868650940149321], // 4625000
    [868753553836558, 868753574427614], // 20591056
    [868768001560373, 868768002560373], // 1000000
    [868928109598425, 868928109648425], // 50000
    [868978097186935, 868978097236935], // 50000
    [868978097340935, 868978097390935], // 50000
    [868978097414935, 868978097464935], // 50000
    [868978113926935, 868978113950935], // 24000
    [868978154930935, 868978154954935], // 24000
    [868978155076935, 868978155100935], // 24000
    [868978227056935, 868978227096935], // 40000
    [868978273562935, 868978273570935], // 8000
    [869059035839274, 869059036689274], // 850000
    [869221485682760, 869221507866999], // 22184239
    [869252707129753, 869252707179753], // 50000
    [869351819000315, 869351819507797], // 507482
    [869480853476183, 869481133657868], // 280181685
    [869546915154440, 869546916105461], // 951021
    [869697692544693, 869697697990434], // 5445741
    [869705371517914, 869705372655470], // 1137556
    [869749719875921, 869749758358121], // 38482200
    [869783713098182, 869783757088997], // 43990815
    [869791090360000, 869791100360000], // 10000000
    [869864155993969, 869864161252417], // 5258448
    [869995290066883, 869995327498162], // 37431279
    [870037490007751, 870037490057751], // 50000
    [870037551619390, 870037551669390], // 50000
    [870256306218090, 870256307218090], // 1000000
    [870299196033342, 870299196482644], // 449302
    [870357758237841, 870357759251945], // 1014104
    [870498597520362, 870498597570362], // 50000
    [870498597570362, 870498597620362], // 50000
    [870498598707291, 870498598757291], // 50000
    [870504228976985, 870504542252786], // 313275801
    [870519886733492, 870519983093367], // 96359875
    [870535006221459, 870535022426822], // 16205363
    [870613347426699, 870613362397733], // 14971034
    [870664277537905, 870664277587905], // 50000
    [870755000000000, 870755031597229], // 31597229
    [870777457991999, 870777458041999], // 50000
    [870830481704056, 870830818627574], // 336923518
    [870982455475318, 870982456349890], // 874572
    [871038251992505, 871038252040185], // 47680
    [871041510000000, 871041570000000], // 60000000
    [871090067133800, 871090067183800], // 50000
    [871090068183800, 871090068233800], // 50000
    [871172708945298, 871172709551813], // 606515
    [871290015626641, 871290025753080], // 10126439
    [871336745973509, 871336745983509], // 10000
    [871509080501725, 871509080551725], // 50000
    [871619583619178, 871619583669178], // 50000
    [871771658469038, 871771658619038], // 150000
    [871771682869038, 871771683069038], // 200000
    [871844593639335, 871844793639335], // 200000000
    [871915081325022, 871915081375022], // 50000
    [871915124375022, 871915124425022], // 50000
    [871959626292815, 871959626342815], // 50000
    [872057802400905, 872057802450905], // 50000
    [872058868979124, 872058869029124], // 50000
    [872143396496022, 872143396546022], // 50000
    [872259075675947, 872259075677885], // 1938
    [872286405226635, 872286428704870], // 23478235
    [872393297352380, 872393314291708], // 16939328
    [872393372027071, 872393398819239], // 26792168
    [872564042575437, 872564043125437], // 550000
    [872582671118828, 872582671363878], // 245050
    [872939587594411, 872939588707140], // 1112729
    [872939647343338, 872939649293337], // 1949999
    [873054025026896, 873054148577828], // 123550932
    [873187365425749, 873187365474498], // 48749
    [873207465223211, 873207596233850], // 131010639
    [873294944536024, 873294944586024], // 50000
    [873367468338530, 873367536942697], // 68604167
    [873655866720341, 873655866770341], // 50000
    [873662428376246, 873662428676507], // 300261
    [873686017435237, 873686237634634], // 220199397
    [873715886468407, 873715897288407], // 10820000
    [873771664941775, 873771665129256], // 187481
    [873821390992579, 873821391190600], // 198021
    [873825222090157, 873825222097408], // 7251
    [873941844270126, 873941849002142], // 4732016
    [874044060392370, 874044166100000], // 105707630
    [874310059150788, 874310070019356], // 10868568
    [874322105884411, 874322106765067], // 880656
    [874322698382185, 874322698432185], // 50000
    [874322979733049, 874322981911736], // 2178687
    [874323684960217, 874323688056325], // 3096108
    [874544819322098, 874544828186648], // 8864550
    [874546677069573, 874546677104425], // 34852
    [874546702074575, 874546702085762], // 11187
    [874559236264460, 874559236267531], // 3071
    [874578830444853, 874578830494853], // 50000
    [874579728559495, 874579892350000], // 163790505
    [874709460716635, 874709460726635], // 10000
    [874782298900563, 874782298907136], // 6573
    [874782298907136, 874782298957136], // 50000
    [874782409878496, 874782410328496], // 450000
    [874873830961621, 874873937200000], // 106238379
    [875052635020580, 875052635070580], // 50000
    [875145322500000, 875145370500000], // 48000000
    [875329073731996, 875329251413773], // 177681777
    [875396998508710, 875397012453055], // 13944345
    [875470181171055, 875470181540297], // 369242
    [875470209159830, 875470209209830], // 50000
    [875554373638964, 875554373710477], // 71513
    [875575214972060, 875575215068212], // 96152
    [875592192237556, 875592195317144], // 3079588
    [875699482991938, 875699486681938], // 3690000
    [875707555099956, 875707555138610], // 38654
    [875722070912478, 875722071247085], // 334607
    [875785071254770, 875785071304770], // 50000
    [875809399183004, 875809399233004], // 50000
    [875809399233004, 875809399283004], // 50000
    [875854699039107, 875854700859107], // 1820000
    [875854702851382, 875854702901382], // 50000
    [875871428771014, 875871428871014], // 100000
    [875899767352127, 875899767363165], // 11038
    [875955107457754, 875955122151908], // 14694154
    [876010418961371, 876010672580000], // 253618629
    [876053443407751, 876053443457751], // 50000
    [876053443907751, 876053443957751], // 50000
    [876189515951594, 876189648200000], // 132248406
    [876261652597976, 876261652942617], // 344641
    [876386944237831, 876386944359344], // 121513
    [876474716661185, 876474716939522], // 278337
    [876493104580765, 876493104630765], // 50000
    [876520810460658, 876521010460658], // 200000000
    [876532448073274, 876532448456215], // 382941
    [876551098568875, 876551236300418], // 137731543
    [876569856750612, 876569856800612], // 50000
    [876570529858632, 876570982538827], // 452680195
    [876580048508453, 876580073508453], // 25000000
    [876637137982454, 876637140217357], // 2234903
    [876780720000000, 876780730000000], // 10000000
    [876799535285293, 876799546016787], // 10731494
    [876903330570000, 876903524570000], // 194000000
    [876956742041715, 876956810831757], // 68790042
    [876993566448110, 876993566498110], // 50000
    [876993566498110, 876993566548110], // 50000
    [876993566634328, 876993566684328], // 50000
    [876993566684328, 876993566734328], // 50000
    [876993566802778, 876993566852778], // 50000
    [876993566852778, 876993566902778], // 50000
    [876993566955778, 876993567005778], // 50000
    [876993567005778, 876993567055778], // 50000
    [876993567212429, 876993567236534], // 24105
    [877014532987163, 877014540529046], // 7541883
    [877014559907380, 877014560216556], // 309176
    [877014922874056, 877014923030846], // 156790
    [877082252000000, 877082262000000], // 10000000
    [877229694322530, 877229754322530], // 60000000
    [877244907435747, 877244912020747], // 4585000
    [877409074593358, 877409094313869], // 19720511
    [877473538435685, 877473538945736], // 510051
    [877521550493336, 877521556255853], // 5762517
    [877544615289771, 877544628370718], // 13080947
    [877551406532375, 877551417241653], // 10709278
    [877587512119695, 877587512127211], // 7516
    [877768949673419, 877768952450302], // 2776883
    [877768953155104, 877768953205104], // 50000
    [877812247309715, 877812247359715], // 50000
    [877950307401309, 877950307451309], // 50000
    [877977857727629, 877977857853740], // 126111
    [877993497654133, 877993508519607], // 10865474
    [878037769966707, 878037770016707], // 50000
    [878074754576425, 878074806177567], // 51601142
    [878135762270189, 878135762320189], // 50000
    [878137771458972, 878137829287864], // 57828892
    [878227206645607, 878227207635684], // 990077
    [878342180000000, 878342229000000], // 49000000
    [878371319619819, 878371322488898], // 2869079
    [878446322036910, 878446322274043], // 237133
    [878607812296504, 878607841827175], // 29530671
    [878680773602742, 878680774802742], // 1200000
    [878712525740679, 878712529226758], // 3486079
    [878721049974280, 878721050024280], // 50000
    [878730187747803, 878730188197803], // 450000
    [878745891307809, 878745929256858], // 37949049
    [878838172983052, 878838173243510], // 260458
    [878940189600009, 878940189853591], // 253582
    [878975640236646, 878975640286646], // 50000
    [879108099238247, 879108099238248], // 1
    [879171095976805, 879171096512638], // 535833
    [879199768297282, 879199768341482], // 44200
    [879433739049474, 879433739405099], // 355625
    [879506175977801, 879506175999676], // 21875
    [879633573100958, 879633675100958], // 102000000
    [879696977172604, 879696982854989], // 5682385
    [879696986620733, 879696987172604], // 551871
    [879697648315658, 879697648852094], // 536436
    [879700149561327, 879700149611327], // 50000
    [879773291310556, 879773291360556], // 50000
    [879805950187275, 879805950237275], // 50000
    [879880800389178, 879880800439178], // 50000
    [880047442761078, 880047442761079], // 1
    [880092920690744, 880092920740744], // 50000
    [880339810548103, 880339951427385], // 140879282
    [880377759507268, 880377759617643], // 110375
    [880516549371727, 880516549392791], // 21064
    [880569701510600, 880569732868150], // 31357550
    [880669550064394, 880669562015805], // 11951411
    [880700973925097, 880700973975097], // 50000
    [880705478269368, 880705483719368], // 5450000
    [880721171869051, 880721171919051], // 50000
    [880721171919051, 880721171969051], // 50000
    [880832544937830, 880832545663231], // 725401
    [880841356581038, 880841356631038], // 50000
    [880901568691237, 880901568741237], // 50000
    [881035080027209, 881035080077209], // 50000
    [881125935468860, 881126016247317], // 80778457
    [881129785280000, 881129785350000], // 70000
    [881345830541737, 881345830591737], // 50000
    [881355070487328, 881355072849728], // 2362400
    [881355072899728, 881355073299728], // 400000
    [881419303958725, 881419307233725], // 3275000
    [881580850631106, 881580850681106], // 50000
    [881624129858375, 881624129908375], // 50000
    [881624129908375, 881624130008375], // 100000
    [881639196758881, 881639196808881], // 50000
    [881897389769535, 881897389857775], // 88240
    [882004662764280, 882004662814280], // 50000
    [882007023099766, 882007023142254], // 42488
    [882029705100000, 882029730100000], // 25000000
    [882045462668767, 882045498472922], // 35804155
    [882045568332922, 882045569724816], // 1391894
    [882113133207213, 882113133207214], // 1
    [882136328522118, 882136661909799], // 333387681
    [882170250000000, 882170310000000], // 60000000
    [882212686229449, 882212790057725], // 103828276
    [882227542500841, 882227542510841], // 10000
    [882384556116894, 882384556822220], // 705326
    [882402745266788, 882402745316788], // 50000
    [882424055100010, 882424060667010], // 5567000
    [882433296565076, 882433296615076], // 50000
    [882442442789486, 882442447789486], // 5000000
    [882504382160000, 882504386650000], // 4490000
    [882534337538268, 882534337538269], // 1
    [882600819642901, 882600825283539], // 5640638
    [882654483575691, 882654484118901], // 543210
    [882654484118901, 882654488118901], // 4000000
    [882654490315855, 882654490329864], // 14009
    [882658682729788, 882658682779788], // 50000
    [882664711150000, 882664716000000], // 4850000
    [882676698573634, 882676718550902], // 19977268
    [882705003184016, 882705184521843], // 181337827
    [882720000858598, 882720002118598], // 1260000
    [882720002418598, 882720003808598], // 1390000
    [882844688994558, 882844691317098], // 2322540
    [882860272860742, 882860272910742], // 50000
    [882873780858659, 882873808545785], // 27687126
    [882918440744352, 882918440794352], // 50000
    [883083577359043, 883083654417727], // 77058684
    [883146711872473, 883146711922473], // 50000
    [883158430559008, 883158571634784], // 141075776
    [883171263019772, 883171273894431], // 10874659
    [883212917332749, 883212927232749], // 9900000
    [883260001550000, 883260002535550], // 985550
    [883271738779812, 883271738828162], // 48350
    [883280136166102, 883280156166102], // 20000000
    [883442586000000, 883442595783200], // 9783200
    [883517808618351, 883517844580468], // 35962117
    [883519533260983, 883519539491143], // 6230160
    [883552856484797, 883552859853523], // 3368726
    [883712279940992, 883712280002580], // 61588
    [883946059998978, 883946061342978], // 1344000
    [883977848678003, 883977848728003], // 50000
    [884000819170956, 884000819220956], // 50000
    [884022967930711, 884022972977311], // 5046600
    [884070798728054, 884070801128053], // 2399999
    [884070861472606, 884070861922606], // 450000
    [884210620329282, 884210620525682], // 196400
    [884297042243752, 884297071636844], // 29393092
    [884456138834980, 884456138884980], // 50000
    [884714951602200, 884714951652200], // 50000
    [884729670589668, 884729670649278], // 59610
    [884751434142055, 884751434845047], // 702992
    [884758713697369, 884758798401893], // 84704524
    [884850644085213, 884850644517690], // 432477
    [884910703371223, 884910703381223], // 10000
    [885019238641681, 885019241334998], // 2693317
    [885051815513974, 885051816446384], // 932410
    [885215216789188, 885215216839188], // 50000
    [885288051456584, 885288051506584], // 50000
    [885429214630707, 885429219874763], // 5244056
    [885429223713565, 885429229680574], // 5967009
    [885429242381840, 885429244284965], // 1903125
    [885429244734965, 885429245278175], // 543210
    [885464216295805, 885464216345805], // 50000
    [885718154829537, 885718154879537], // 50000
    [885718163253795, 885718163957045], // 703250
    [885779059745558, 885779059957939], // 212381
    [885779061562198, 885779061949857], // 387659
    [885951798021908, 885951798521908], // 500000
    [885981543237724, 885981580582664], // 37344940
    [886041868738701, 886041976738701], // 108000000
    [886110037601264, 886110037668962], // 67698
    [886122717913579, 886122724559775], // 6646196
    [886128432786393, 886128432840009], // 53616
    [886155167543679, 886155167560376], // 16697
    [886155167628826, 886155167678826], // 50000
    [886155167678826, 886155167728826], // 50000
    [886155168043908, 886155168093908], // 50000
    [886155168317892, 886155168367892], // 50000
    [886155168367892, 886155168417892], // 50000
    [886155168536342, 886155168586342], // 50000
    [886281773573558, 886281773623558], // 50000
    [886451544492741, 886451645492741], // 101000000
    [886467457524690, 886467457650839], // 126149
    [886679447795015, 886679447845015], // 50000
    [886689345346296, 886689345442447], // 96151
    [886966554578666, 886966555935635], // 1356969
    [887093152895019, 887093361306240], // 208411221
    [887250436404982, 887250437086506], // 681524
    [887372514140875, 887372548064723], // 33923848
    [887475240000000, 887475241165770], // 1165770
    [887530779588801, 887530787939819], // 8351018
    [887725000000000, 887725176092381], // 176092381
    [887808981963388, 887808981963389], // 1
    [887886023436166, 887886023486166], // 50000
    [887972095447762, 887972096451148], // 1003386
    [887972737151700, 887972738066108], // 914408
    [888049173297138, 888049174281139], // 984001
    [888059546924807, 888059611484107], // 64559300
    [888213376222423, 888213387983423], // 11761000
    [888283252030665, 888283254530665], // 2500000
    [888352407054684, 888352407104684], // 50000
    [888388823942509, 888388824089898], // 147389
    [888392420492256, 888392420636022], // 143766
    [888436639300665, 888436640565101], // 1264436
    [888509182568642, 888509182618642], // 50000
    [888518380259987, 888518386836122], // 6576135
    [888539164786574, 888539165822825], // 1036251
    [888575496631102, 888575496681102], // 50000
    [888616568498564, 888616978497940], // 409999376
    [888665064391510, 888665064428913], // 37403
    [888738645010019, 888738645773424], // 763405
    [888773599666323, 888773599666324], // 1
    [888773905681981, 888773905877063], // 195082
    [888794505904759, 888794505954759], // 50000
    [888794723194642, 888794723244642], // 50000
    [888829355148231, 888829363241332], // 8093101
    [888955219469359, 888955219519359], // 50000
    [888980440477537, 888980441228232], // 750695
    [889031220167834, 889031220414526], // 246692
    [889032946069229, 889032946215182], // 145953
    [889073010432374, 889073010482373], // 49999
    [889139487996817, 889139488046817], // 50000
    [889149531254633, 889149531304633], // 50000
    [889153661254871, 889153661264871], // 10000
    [889153845982124, 889153846210180], // 228056
    [889194657085746, 889194657135746], // 50000
    [889206583306712, 889206633928351], // 50621639
    [889279654579273, 889279654629273], // 50000
    [889294145219578, 889294145269578], // 50000
    [889299543834561, 889299543884561], // 50000
    [889340376250796, 889340381250796], // 5000000
    [889340381300796, 889340386150796], // 4850000
    [889614600334429, 889614600384911], // 50482
    [889679059278530, 889679059328530], // 50000
    [889722775936878, 889722775986878], // 50000
    [889760731224005, 889760788691005], // 57467000
    [889820486409112, 889820486459110], // 49998
    [889820489609111, 889820489659110], // 49999
    [889875521870550, 889875521920550], // 50000
    [889875571666894, 889875571716894], // 50000
    [889875575409807, 889875576409807], // 1000000
    [889875767958630, 889875768008630], // 50000
    [889974975600000, 889975000000000], // 24400000
    [890079654483935, 890079654512637], // 28702
    [890287673750622, 890287674652225], // 901603
    [890287718438543, 890287718488543], // 50000
    [890601612152473, 890601612284702], // 132229
    [890651119295639, 890651122538338], // 3242699
    [890651138735239, 890651143790246], // 5055007
    [890652539803273, 890652539890829], // 87556
    [890652541890829, 890652541967399], // 76570
    [890837813156703, 890837816975105], // 3818402
    [890845412376780, 890845412706178], // 329398
    [890882842047902, 890882842097902], // 50000
    [890882842097902, 890882842347902], // 250000
    [890938966753863, 890938966754854], // 991
    [890943572402327, 890943572452327], // 50000
    [891145081543299, 891145081593299], // 50000
    [891191264080198, 891191264130198], // 50000
    [891346135878043, 891346135948169], // 70126
    [891395221090557, 891395324729809], // 103639252
    [891495801318803, 891495801368803], // 50000
    [891543629428362, 891543629483140], // 54778
    [891653678793529, 891653678843529], // 50000
    [891793789423392, 891793789473392], // 50000
    [891795948634193, 891795948854126], // 219933
    [891795948854126, 891795949033375], // 179249
    [892093389909936, 892093389929255], // 19319
    [892125790850110, 892125790900110], // 50000
    [892126056523323, 892126056573323], // 50000
    [892258291490386, 892258330336378], // 38845992
    [892326832618700, 892326832674941], // 56241
    [892326837171660, 892326837264352], // 92692
    [892326838309900, 892326838448526], // 138626
    [892326838594460, 892326838627322], // 32862
    [892326839383198, 892326839398140], // 14942
    [892326845139340, 892326845143407], // 4067
    [892326849407740, 892326849431119], // 23379
    [892327407479617, 892327407514372], // 34755
    [892327408663791, 892327408779038], // 115247
    [892327414804799, 892327414989358], // 184559
    [892327418733698, 892327418738638], // 4940
    [892391334279680, 892391335279680], // 1000000
    [892409867169861, 892409953009116], // 85839255
    [892410637643900, 892410637783869], // 139969
    [892438454130884, 892438454180884], // 50000
    [892528917827802, 892528922527802], // 4700000
    [892631564736771, 892631564786771], // 50000
    [892670464486586, 892670464496586], // 10000
    [892794666861320, 892794667885589], // 1024269
    [892818374549332, 892818374599332], // 50000
    [892850019111200, 892850023961199], // 4849999
    [892945798102897, 892945798155900], // 53003
    [892960315453812, 892960315503812], // 50000
    [892981255317644, 892981255409947], // 92303
    [893060046599417, 893060046649417], // 50000
    [893060046649417, 893060046699417], // 50000
    [893130808914111, 893130808964111], // 50000
    [893177835834470, 893177859994494], // 24160024
    [893177860044494, 893177908246494], // 48202000
    [893205414381210, 893205414431210], // 50000
    [893205414431210, 893205414481210], // 50000
    [893205414549660, 893205414599660], // 50000
    [893205414599660, 893205414649660], // 50000
    [893205415150740, 893205415200740], // 50000
    [893205415200740, 893205415250740], // 50000
    [893241357605485, 893241357812469], // 206984
    [893410909742045, 893410910470922], // 728877
    [893492757787960, 893492757837960], // 50000
    [893709458985761, 893709487554316], // 28568555
    [893709606134933, 893709610078537], // 3943604
    [893709610153538, 893709619404316], // 9250778
    [893714287926988, 893714288002909], // 75921
    [893785260559582, 893785364114874], // 103555292
    [894184779695135, 894184779745135], // 50000
    [894275906941431, 894275908124924], // 1183493
    [894399772841559, 894399774159559], // 1318000
    [894535469738706, 894535470740194], // 1001488
    [894535471896705, 894535472950704], // 1053999
    [894535472950704, 894535473400704], // 450000
    [894608845850792, 894608850632696], // 4781904
    [894626743050000, 894627107995218], // 364945218
    [894629925153396, 894629926983983], // 1830587
    [894670829410893, 894670829604016], // 193123
    [894892167696476, 894892168824060], // 1127584
    [894935884854487, 894935887481824], // 2627337
    [894935888120024, 894935888667009], // 546985
    [894955497167129, 894955497217129], // 50000
    [894971584684764, 894971584884764], // 200000
    [894976147450228, 894976147838640], // 388412
    [894976268186841, 894976268247418], // 60577
    [894976268603818, 894976268839683], // 235865
    [894983397877549, 894983398204578], // 327029
    [895041650689377, 895041651937121], // 1247744
    [895111521888018, 895111521935278], // 47260
    [895114750904288, 895114752141733], // 1237445
    [895114752191734, 895114752541337], // 349603
    [895152715884821, 895152715984821], // 100000
    [895152715984821, 895152716034821], // 50000
    [895196926703381, 895196926940188], // 236807
    [895322124419858, 895322124469858], // 50000
    [895388006329396, 895388006379396], // 50000
    [895500651027665, 895500651077665], // 50000
    [895583681984158, 895583682382620], // 398462
    [895655438924593, 895655438974593], // 50000
    [895772674253298, 895772681362398], // 7109100
    [895799937883032, 895799937933032], // 50000
    [895810158244756, 895810158294756], // 50000
    [895828731388053, 895828733775683], // 2387630
    [895828806576053, 895828807529323], // 953270
    [895842524110967, 895842542757204], // 18646237
    [895865570294811, 895865571331061], // 1036250
    [895865571331061, 895865572281061], // 950000
    [895928932490023, 895929036490023], // 104000000
    [895958080478204, 895958080528204], // 50000
    [896114077794463, 896114077844463], // 50000
    [896114091926318, 896114091976318], // 50000
    [896114209962530, 896114210012530], // 50000
    [896273940074102, 896273940124102], // 50000
    [896274182759463, 896274182759464], // 1
    [896274183447290, 896274183709462], // 262172
    [896308828507340, 896308828600317], // 92977
    [896325026403795, 896325027523327], // 1119532
    [896374717430489, 896374717975539], // 545050
    [896374936084226, 896374936184226], // 100000
    [896377919346116, 896377919816283], // 470167
    [896425328908380, 896425328958380], // 50000
    [896621066730112, 896621068354958], // 1624846
    [896743475100000, 896743567739350], // 92639350
    [896756997535939, 896756999500634], // 1964695
    [896765266988032, 896765267014515], // 26483
    [896788502963399, 896788503963399], // 1000000
    [896792480712696, 896792499709190], // 18996494
    [896868391115437, 896868451115437], // 60000000
    [896983201592651, 896983201642651], // 50000
    [897112605981359, 897112607333434], // 1352075
    [897194765750000, 897194826711109], // 60961109
    [897202403835173, 897202403845173], // 10000
    [897275093642847, 897275094642847], // 1000000
    [897436256862898, 897436256912898], // 50000
    [897458267710496, 897458268173518], // 463022
    [897458823331342, 897458838636085], // 15304743
    [897460142426257, 897460143248257], // 822000
    [897460202433800, 897460215048450], // 12614650
    [897474663940876, 897474664040876], // 100000
    [897553583554059, 897553583559059], // 5000
    [897554070910000, 897554127910000], // 57000000
    [897590373909704, 897590377391816], // 3482112
    [897633426184688, 897633426299097], // 114409
    [897685940775678, 897685941225678], // 450000
    [897733486178914, 897733486228914], // 50000
    [897828172615198, 897828174490148], // 1874950
    [898104344339176, 898104344389176], // 50000
    [898116509466929, 898116509516929], // 50000
    [898123212596059, 898123213546058], // 949999
    [898134330996553, 898134331074199], // 77646
    [898134516686739, 898134516736739], // 50000
    [898191941739651, 898191942619651], // 880000
    [898227290520258, 898227290570258], // 50000
    [898227292420414, 898227292470414], // 50000
    [898241641374577, 898241641424577], // 50000
    [898349487669492, 898349488319492], // 650000
    [898425738644100, 898425738778942], // 134842
    [898425738778942, 898425739285714], // 506772
    [898463302887273, 898463302894092], // 6819
    [898487013050000, 898487175043429], // 161993429
    [898492354295516, 898492354332870], // 37354
    [898499104308298, 898499125023048], // 20714750
    [898778771235276, 898778771243341], // 8065
    [898788141974585, 898788142024585], // 50000
    [898868966935704, 898869045670872], // 78735168
    [898956884284960, 898956884334960], // 50000
    [899089041571709, 899089042521708], // 949999
    [899220155778889, 899220155828889], // 50000
    [899244746192358, 899244746294290], // 101932
    [899244746494290, 899244746531793], // 37503
    [899271341095573, 899271341145573], // 50000
    [899285286847589, 899285286897589], // 50000
    [899285294710089, 899285294760089], // 50000
    [899391077404046, 899391077454046], // 50000
    [899396086501523, 899396087502513], // 1000990
    [899404646934333, 899404647116624], // 182291
    [899493736887984, 899493736937984], // 50000
    [899519922140200, 899519922168325], // 28125
    [899693258859695, 899693259320151], // 460456
    [899739353006550, 899739353056550], // 50000
    [899906769845632, 899906770893969], // 1048337
    [899906812699583, 899906812884643], // 185060
    [899907190596939, 899907190646939], // 50000
    [899907821695150, 899907822589259], // 894109
    [899941897803718, 899941897853718], // 50000
    [900002152991460, 900002153618023], // 626563
    [900002320767730, 900002321767730], // 1000000
    [900002323767730, 900002324330932], // 563202
    [900002799871946, 900002807634444], // 7762498
    [900041205161944, 900041205569159], // 407215
    [900041206074999, 900041206223431], // 148432
    [900284426020732, 900284426060108], // 39376
    [900351531840442, 900351531890442], // 50000
    [900393724450000, 900393730450000], // 6000000
    [900403826421961, 900403826479084], // 57123
    [900458953563920, 900458954107320], // 543400
    [900501332548385, 900501333998385], // 1450000
    [900576961217114, 900576965651867], // 4434753
    [900577464593856, 900577466593856], // 2000000
    [900614733434312, 900614739508849], // 6074537
    [900618386316035, 900618415716035], // 29400000
    [900670994835533, 900671011535533], // 16700000
    [900734266532297, 900734266582297], // 50000
    [900778709072449, 900778710009210], // 936761
    [900780838976194, 900780839026194], // 50000
    [900876287473891, 900876289923891], // 2450000
    [900997643729739, 900997644117664], // 387925
    [901190108306582, 901190108356582], // 50000
    [901586682460848, 901586682510848], // 50000
    [901646260216442, 901646260232442], // 16000
    [901646267928442, 901646267936442], // 8000
    [901666010767556, 901666010817556], // 50000
    [901666031683234, 901666036044207], // 4360973
    [901753903939263, 901753903989263], // 50000
    [901754138911888, 901754138919888], // 8000
    [901754172600133, 901754172607888], // 7755
    [901871852150000, 901871947150000], // 95000000
    [901907755177492, 901907801187492], // 46010000
    [901945129288007, 901945129560553], // 272546
    [901992445038338, 901992445058025], // 19687
    [902015613239890, 902015613289890], // 50000
    [902137692233331, 902137692283331], // 50000
    [902222894928161, 902222898468161], // 3540000
    [902320329243381, 902320339193380], // 9949999
    [902462560634337, 902462561084337], // 450000
    [902495684725392, 902495827622787], // 142897395
    [902530051878569, 902530051921781], // 43212
    [902551277981788, 902551278031788], // 50000
    [902594498017771, 902594498258348], // 240577
    [902625555613587, 902625556268175], // 654588
    [902679574816309, 902679574866309], // 50000
    [902687813869492, 902687813919492], // 50000
    [902804066312374, 902804066438598], // 126224
    [902827682207791, 902827682257791], // 50000
    [903067407313424, 903067407630299], // 316875
    [903116389913775, 903116389963775], // 50000
    [903124887708584, 903124887758584], // 50000
    [903159641453821, 903159646967154], // 5513333
    [903346766673384, 903346767232360], // 558976
    [903419497402812, 903419514102812], // 16700000
    [903536204337218, 903536352141597], // 147804379
    [903590577816336, 903590577916336], // 100000
    [903617522847619, 903617522897619], // 50000
    [903617522897619, 903617522947619], // 50000
    [903686967626624, 903686968230406], // 603782
    [903760075379297, 903760075441967], // 62670
    [903776735628109, 903776736121791], // 493682
    [903811682460695, 903811682510695], // 50000
    [903832490493404, 903832490543404], // 50000
    [903858331734649, 903858410407649], // 78673000
    [904023860754558, 904023863385592], // 2631034
    [904062124432320, 904062125044771], // 612451
    [904062890292373, 904062890792373], // 500000
    [904096151462380, 904096151484484], // 22104
    [904292777360000, 904292802360000], // 25000000
    [904311205800296, 904311205907649], // 107353
    [904331337088288, 904331337540287], // 451999
    [904331337540287, 904331337740287], // 200000
    [904331394813778, 904331394889698], // 75920
    [904331706465175, 904331706515175], // 50000
    [904331724676078, 904331727584012], // 2907934
    [904343871961764, 904343872011764], // 50000
    [904379198355667, 904379198424747], // 69080
    [904453519624330, 904453519824330], // 200000
    [904616332875837, 904616334004157], // 1128320
    [904649141950335, 904649142000335], // 50000
    [904649161600335, 904649161650335], // 50000
    [904665168155549, 904665168205549], // 50000
    [904681472266537, 904681510514429], // 38247892
    [904695393452665, 904695438610347], // 45157682
    [904764500673389, 904764500723389], // 50000
    [904790003404309, 904790003879018], // 474709
    [904939528607621, 904939528657621], // 50000
    [905028836272130, 905028837315130], // 1043000
    [905050010586766, 905050033507513], // 22920747
    [905071797161776, 905071797666261], // 504485
    [905082916674519, 905082916917545], // 243026
    [905114300135851, 905114300185851], // 50000
    [905124886464538, 905124891337805], // 4873267
    [905319999957494, 905320000000000], // 42506
    [905345356576554, 905345356626554], // 50000
    [905345356626554, 905345356676554], // 50000
    [905345357626554, 905345357676554], // 50000
    [905345357676554, 905345357726554], // 50000
    [905361391700000, 905361583305060], // 191605060
    [905406774381927, 905406774842012], // 460085
    [905434936752643, 905434978380825], // 41628182
    [905473482437185, 905473482487185], // 50000
    [905481400990153, 905481409038502], // 8048349
    [905481656865814, 905481656915814], // 50000
    [905522763110071, 905522763160071], // 50000
    [905522763418881, 905522763428881], // 10000
    [905523914094913, 905523925154913], // 11060000
    [905625908322783, 905625908679213], // 356430
    [905631890380917, 905631890380918], // 1
    [905701811265610, 905701842788519], // 31522909
    [905701885092130, 905701886023449], // 931319
    [905761858278249, 905761868876686], // 10598437
    [905800725689662, 905800725689663], // 1
    [905906022547389, 905906023736366], // 1188977
    [905986967634322, 905986968256686], // 622364
    [905987177861728, 905987178711727], // 849999
    [905987753449388, 905987753549388], // 100000
    [905989404510295, 905989404510296], // 1
    [905989405510295, 905989405510296], // 1
    [905989406510295, 905989407086698], // 576403
    [906017355369987, 906017355419987], // 50000
    [906017355419987, 906017355469987], // 50000
    [906030447557514, 906030447607514], // 50000
    [906031093026464, 906031093076464], // 50000
    [906106309602361, 906106344602361], // 35000000
    [906106344840243, 906106344890243], // 50000
    [906133079565658, 906133180565658], // 101000000
    [906139993423799, 906139999935362], // 6511563
    [906143567093853, 906143567143853], // 50000
    [906215030305807, 906215035255806], // 4949999
    [906278905639170, 906278905639171], // 1
    [906330020836696, 906330037877386], // 17040690
    [906425749966556, 906425944603800], // 194637244
    [906431245315755, 906431696608615], // 451292860
    [906704795763742, 906704797294120], // 1530378
    [906730912413388, 906730912463388], // 50000
    [906730912463388, 906730912513388], // 50000
    [906767384488236, 906767682322236], // 297834000
    [906876242739197, 906876243424293], // 685096
    [906923351323572, 906923351373572], // 50000
    [906929240569677, 906929240619677], // 50000
    [906929313675532, 906929315675532], // 2000000
    [906929516724971, 906929516774971], // 50000
    [907000620067508, 907000646128185], // 26060677
    [907078647462512, 907078743751403], // 96288891
    [907106952310568, 907106952360568], // 50000
    [907124858763827, 907124859763827], // 1000000
    [907142210637871, 907142210637872], // 1
    [907195161336943, 907195161386943], // 50000
    [907227926285882, 907227926335882], // 50000
    [907227926335882, 907227926385882], // 50000
    [907227926385882, 907227926435882], // 50000
    [907227926435882, 907227926485882], // 50000
    [907254714998015, 907254715048015], // 50000
    [907329943711149, 907329943761149], // 50000
    [907460428033315, 907460443659469], // 15626154
    [907489877800010, 907489928800010], // 51000000
    [907511155202519, 907511155665160], // 462641
    [907515199888888, 907515199938888], // 50000
    [907518532762603, 907518532812603], // 50000
    [907518817452831, 907518817508633], // 55802
    [907528075521280, 907528076071280], // 550000
    [907540529430000, 907540530475000], // 1045000
    [907572520376888, 907572572376888], // 52000000
    [907639065370322, 907639065370323], // 1
    [907644317252702, 907644317925240], // 672538
    [907644317925240, 907644318468450], // 543210
    [907646117851215, 907646117852371], // 1156
    [907646117852371, 907646117902370], // 49999
    [907647512549858, 907647512599858], // 50000
    [907678315364345, 907678317107076], // 1742731
    [907705818358107, 907705824378957], // 6020850
    [907723459975784, 907723460023106], // 47322
    [907824196924782, 907824199236075], // 2311293
    [907841892423489, 907841892473489], // 50000
    [907899673462500, 907899698462500], // 25000000
    [907975613041094, 907975613214063], // 172969
    [907977256022154, 907977256072154], // 50000
    [907978510581493, 907978510709173], // 127680
    [907979145312962, 907979145362962], // 50000
    [907997843052150, 907998077850231], // 234798081
    [907998431930557, 907998453720557], // 21790000
    [908014644678083, 908014644728083], // 50000
    [908097093237874, 908097093287874], // 50000
    [908105515430199, 908105515477232], // 47033
    [908185802826751, 908185803206751], // 380000
    [908185822576751, 908185823076751], // 500000
    [908189342587142, 908189343587142], // 1000000
    [908212563443818, 908212564393816], // 949998
    [908212787186078, 908212787243758], // 57680
    [908285864000670, 908285864050670], // 50000
    [908589036171818, 908589052940381], // 16768563
    [908672311950000, 908672517403691], // 205453691
    [908721440901868, 908721448366200], // 7464332
    [909028537403673, 909028685898027], // 148494354
    [909091301766424, 909091301816424], // 50000
    [909202883029253, 909202943029253], // 60000000
    [909258848975285, 909258849468495], // 493210
    [909258877744615, 909258879694614], // 1949999
    [909438103495662, 909438103595662], // 100000
    [909445680161453, 909445786021498], // 105860045
    [909461332464730, 909461332514730], // 50000
    [909461332514730, 909461332564730], // 50000
    [909479709082362, 909479709790005], // 707643
    [909691456474207, 909691456944207], // 470000
    [909697801419979, 909697803906454], // 2486475
    [909727496278769, 909727496328769], // 50000
    [909727807191244, 909727807770843], // 579599
    [909816951522909, 909816960000000], // 8477091
    [909880015943815, 909880015980971], // 37156
    [909967342981175, 909967343031175], // 50000
    [909967514759091, 909967514809091], // 50000
    [910048563841948, 910048563892448], // 50500
    [910061082379499, 910061351379499], // 269000000
    [910148347660658, 910148347795458], // 134800
    [910200140053245, 910200140103245], // 50000
    [910206338396555, 910206376990000], // 38593445
    [910226132940241, 910226177692378], // 44752137
    [910279416303194, 910279417487194], // 1184000
    [910351658470556, 910351661261474], // 2790918
    [910352879330004, 910352880415315], // 1085311
    [910421794624458, 910422018382870], // 223758412
    [910615325850000, 910615361850000], // 36000000
    [910737097268232, 910737098452808], // 1184576
    [910797233811787, 910797233861787], // 50000
    [910820861007350, 910820861057350], // 50000
    [910900078905979, 910900079105979], // 200000
    [910900085393007, 910900087341166], // 1948159
    [911021428107955, 911021428157955], // 50000
    [911045664633457, 911045664683457], // 50000
    [911317946350000, 911317954250000], // 7900000
    [911370291170733, 911370335142383], // 43971650
    [911370533274470, 911370533324470], // 50000
    [911444028328068, 911444028396081], // 68013
    [911475993465835, 911475995848335], // 2382500
    [911535891800001, 911535891977096], // 177095
    [911567935311075, 911567935361075], // 50000
    [911603674401792, 911603675681232], // 1279440
    [911698101589447, 911698116161780], // 14572333
    [911810702456593, 911810744999420], // 42542827
    [911815314382447, 911815314426782], // 44335
    [911891958676359, 911892010864517], // 52188158
    [911902612464655, 911902667572834], // 55108179
    [911917735510567, 911917736460566], // 949999
    [911947610657112, 911947614087834], // 3430722
    [911948081163252, 911948081213251], // 49999
    [911948081463252, 911948081513251], // 49999
    [912012292124918, 912012293561478], // 1436560
    [912131094617598, 912131100465913], // 5848315
    [912157873096742, 912157873146742], // 50000
    [912157941897846, 912157941947846], // 50000
    [912157941947846, 912157941997846], // 50000
    [912157941997846, 912157942047846], // 50000
    [912158706197331, 912158706268844], // 71513
    [912216923901616, 912216923932950], // 31334
    [912230019794190, 912230019825596], // 31406
    [912230027768852, 912230027818852], // 50000
    [912240243468435, 912240244678435], // 1210000
    [912262729807746, 912262739211639], // 9403893
    [912275822035723, 912275822085723], // 50000
    [912358096496881, 912358096546881], // 50000
    [912358143794524, 912358143844524], // 50000
    [912358145721164, 912358145771164], // 50000
    [912489041750002, 912489056250002], // 14500000
    [912514645319365, 912514655700000], // 10380635
    [912522915433278, 912522916440666], // 1007388
    [912595788348894, 912595788398894], // 50000
    [912599415026939, 912599416026939], // 1000000
    [912610043463957, 912610043513957], // 50000
    [912632790181675, 912632790231675], // 50000
    [912633942127495, 912633942127879], // 384
    [912650009982036, 912650021466889], // 11484853
    [912690150704295, 912690150754295], // 50000
    [912785086905653, 912785086955653], // 50000
    [912815102184558, 912815102203224], // 18666
    [912867658968126, 912867670707064], // 11738938
    [912941362264488, 912941372629369], // 10364881
    [912972825133393, 912972845083393], // 19950000
    [912999220257901, 912999220852994], // 595093
    [913040144251003, 913040145201001], // 949998
    [913081558521538, 913081562860012], // 4338474
    [913109381365061, 913109381817060], // 451999
    [913109381817060, 913109382017060], // 200000
    [913148358297260, 913148358374844], // 77584
    [913148514062470, 913148517141030], // 3078560
    [913235005991049, 913235015675047], // 9683998
    [913246357117365, 913246357317365], // 200000
    [913246653152514, 913246653202514], // 50000
    [913246653202514, 913246653252514], // 50000
    [913246779939576, 913246780121101], // 181525
    [913246812098590, 913246812181143], // 82553
    [913306965932837, 913306965982837], // 50000
    [913307746369908, 913307746747223], // 377315
    [913364750596517, 913364750603917], // 7400
    [913370368971720, 913370370436561], // 1464841
    [913372417040921, 913372417040922], // 1
    [913372442393227, 913372442443227], // 50000
    [913372442443227, 913372442493227], // 50000
    [913373287559846, 913373287655998], // 96152
    [913374887144178, 913374887194178], // 50000
    [913518362696512, 913518362746512], // 50000
    [913535851520092, 913535852543389], // 1023297
    [913645864876376, 913645864886375], // 9999
    [913756403754631, 913756403804631], // 50000
    [913875055000000, 913875060000000], // 5000000
    [913904357641046, 913904357691046], // 50000
    [913905793875224, 913905805071021], // 11195797
    [913925233964149, 913925234192539], // 228390
    [913970512692267, 913970512742266], // 49999
    [913970600730078, 913970600780078], // 50000
    [914120174816291, 914120174866291], // 50000
    [914120181134194, 914120181184194], // 50000
    [914120265619880, 914120265619881], // 1
    [914120488792118, 914120488792119], // 1
    [914123500121139, 914123500133983], // 12844
    [914124186018743, 914124186068743], // 50000
    [914124551904314, 914124551954314], // 50000
    [914180494362500, 914180495955135], // 1592635
    [914180553326948, 914180553924540], // 597592
    [914181154712500, 914181156636579], // 1924079
    [914181158710659, 914181159797769], // 1087110
    [914181165376883, 914181166786579], // 1409696
    [914181212119770, 914181219112500], // 6992730
    [914181239262500, 914181240273451], // 1010951
    [914181273141320, 914181273141321], // 1
    [914181281686579, 914181281762500], // 75921
    [914181966986580, 914181967062500], // 75920
    [914182010471677, 914182010521677], // 50000
    [914182078564742, 914182078614742], // 50000
    [914182110412501, 914182114262500], // 3849999
    [914182359124568, 914182359174568], // 50000
    [914182576020421, 914182576612500], // 592079
    [914182719998196, 914182720410660], // 412464
    [914183443603072, 914183443653072], // 50000
    [914195077696600, 914195077806147], // 109547
    [914196049528053, 914196050528053], // 1000000
    [914196316944164, 914196316994164], // 50000
    [914281637012646, 914281637054350], // 41704
    [914290227403574, 914290241608574], // 14205000
    [914305780541741, 914305780591740], // 49999
    [914472189754812, 914472189804812], // 50000
    [914473954426021, 914473954475579], // 49558
    [914474548786993, 914474548992198], // 205205
    [914500661212118, 914501003212118], // 342000000
    [914517902019322, 914517902034322], // 15000
    [914520333181310, 914520435376931], // 102195621
    [914527358958731, 914527403362592], // 44403861
    [914570712739946, 914570712789946], // 50000
    [914570849275647, 914570849555648], // 280001
    [914571315927876, 914571315977876], // 50000
    [914576832879309, 914576853795309], // 20916000
    [914580787173148, 914580787446532], // 273384
    [914623467173225, 914623467223225], // 50000
    [914649213398372, 914649213411480], // 13108
    [914692928620516, 914692928670516], // 50000
    [914802144020142, 914802167590238], // 23570096
    [914917112962922, 914917368688692], // 255725770
    [914919839264443, 914919839291786], // 27343
    [914919840241786, 914919840291786], // 50000
    [914919840291786, 914919840341786], // 50000
    [914919841341786, 914919841391786], // 50000
    [915362602466276, 915362602666276], // 200000
    [915389379802700, 915389379852700], // 50000
    [915476540198222, 915476540271025], // 72803
    [915476609910815, 915476611112422], // 1201607
    [915476706976950, 915476707358227], // 381277
    [915601765210005, 915601766310004], // 1099999
    [915603054099349, 915603054404990], // 305641
    [915730328406489, 915730328719439], // 312950
    [915730496561278, 915730500000000], // 3438722
    [915736708323235, 915736708373235], // 50000
    [915739888949155, 915739932949155], // 44000000
    [915886683270421, 915886684489029], // 1218608
    [915887179016562, 915887179066562], // 50000
    [916193820411316, 916193820991069], // 579753
    [916222791904611, 916222791954611], // 50000
    [916395256143157, 916395256193157], // 50000
    [916438974464304, 916438983464304], // 9000000
    [916536349868575, 916536349918575], // 50000
    [916575852875774, 916575852889176], // 13402
    [916625014363753, 916625014413753], // 50000
    [916647347730072, 916647347849385], // 119313
    [916654947907274, 916654947957274], // 50000
    [916654947957274, 916654948007274], // 50000
    [916775659858541, 916775662101831], // 2243290
    [916860251082254, 916860251100000], // 17746
    [916860284600003, 916860284720189], // 120186
    [916877196247745, 916877196257745], // 10000
    [916904600601862, 916904600651862], // 50000
    [916924867326587, 916924867376587], // 50000
    [916981509549045, 916981509599045], // 50000
    [916981837585506, 916981837878343], // 292837
    [917073919076381, 917073919126381], // 50000
    [917161891581853, 917161891631853], // 50000
    [917190896657247, 917190896707247], // 50000
    [917243978556929, 917243978749230], // 192301
    [917265377515703, 917265377565703], // 50000
    [917269831982244, 917269832082243], // 99999
    [917286867678441, 917286942411231], // 74732790
    [917302750132909, 917302750185409], // 52500
    [917345630777254, 917345630827254], // 50000
    [917365190299572, 917365190349572], // 50000
    [917420610029721, 917420610534721], // 505000
    [917470597016735, 917470597066735], // 50000
    [917473969982171, 917473970032171], // 50000
    [917501860523613, 917501860662467], // 138854
    [917564640030800, 917564640080800], // 50000
    [917738278223434, 917738278638154], // 414720
    [917738309338155, 917738319188154], // 9849999
    [917743260367556, 917743260399556], // 32000
    [917762060572325, 917762060972325], // 400000
    [917825954610893, 917826001188418], // 46577525
    [917866324425649, 917866325932292], // 1506643
    [917866404662858, 917866404712858], // 50000
    [917918809317211, 917918809367211], // 50000
    [918108076714368, 918108077993282], // 1278914
    [918142214294265, 918142214344265], // 50000
    [918289896835375, 918289897035375], // 200000
    [918306940525235, 918306940575235], // 50000
    [918357870282622, 918357870307622], // 25000
    [918408820755107, 918408820805107], // 50000
    [918519736608747, 918519736658747], // 50000
    [918519782229679, 918519782323659], // 93980
    [918591746027550, 918591746211576], // 184026
    [918650496030039, 918650496080039], // 50000
    [918734968130157, 918734968180157], // 50000
    [918734968180157, 918734968230157], // 50000
    [918734968298607, 918734968348607], // 50000
    [918734968348607, 918734968398607], // 50000
    [918734968451607, 918734968501607], // 50000
    [918734968501607, 918734968551607], // 50000
    [918734968825591, 918734968875591], // 50000
    [918734969011809, 918734969827198], // 815389
    [918851544166956, 918851544172648], // 5692
    [918851973472564, 918851974122564], // 650000
    [918893617837370, 918893617887370], // 50000
    [918893617887370, 918893617987370], // 100000
    [918945808328556, 918945808473356], // 144800
    [919022449592712, 919022449779196], // 186484
    [919034476329486, 919034476379486], // 50000
    [919170228605108, 919170229911525], // 1306417
    [919280833787096, 919280833837096], // 50000
    [919362044641973, 919362047218046], // 2576073
    [919486283433087, 919486283483087], // 50000
    [919522256503992, 919522256553992], // 50000
    [919522335794518, 919522335844518], // 50000
    [919737029176934, 919737540176934], // 511000000
    [919767954467141, 919767954495693], // 28552
    [919790131586578, 919790131636578], // 50000
    [919827007803802, 919827007919842], // 116040
    [919996081144939, 919996081194939], // 50000
    [920102977169365, 920102977219365], // 50000
    [920103013815086, 920103013865086], // 50000
    [920319777301773, 920319777528794], // 227021
    [920329630551207, 920329631727751], // 1176544
    [920435200936647, 920435201152602], // 215955
    [920437230727348, 920437230777348], // 50000
    [920613118821867, 920613180901174], // 62079307
    [920710118713100, 920710118763100], // 50000
    [920799347927762, 920799347977762], // 50000
    [920856427983273, 920856586922335], // 158939062
    [921068840000000, 921068841542158], // 1542158
    [921104295395156, 921104295445156], // 50000
    [921104339671308, 921104339721308], // 50000
    [921149935140423, 921149936090422], // 949999
    [921214605132431, 921214629355088], // 24222657
    [921293980281089, 921293980331089], // 50000
    [921294392481089, 921294392531089], // 50000
    [921294405631097, 921294406831097], // 1200000
    [921384805891062, 921384805893756], // 2694
    [921424909404588, 921424936096075], // 26691487
    [921446148713918, 921446148763918], // 50000
    [921564859222056, 921564859272056], // 50000
    [921564859272056, 921564859322056], // 50000
    [921566121498744, 921566122429457], // 930713
    [921675138771114, 921675139378388], // 607274
    [921675701201967, 921675702262368], // 1060401
    [921676072048078, 921676087771114], // 15723036
    [921782224117855, 921782224167855], // 50000
    [921808611357850, 921808671357850], // 60000000
    [921856235609563, 921856235682942], // 73379
    [921952906008391, 921952929901433], // 23893042
    [921952929901434, 921952931101433], // 1199999
    [921983026899831, 921983028770889], // 1871058
    [922099337223022, 922099338223022], // 1000000
    [922313584801646, 922313606663716], // 21862070
    [922455477073546, 922455477648546], // 575000
    [922469009006486, 922469040889595], // 31883109
    [922539324095699, 922539324145699], // 50000
    [922562977755440, 922562979567953], // 1812513
    [922656391086845, 922656433476845], // 42390000
    [922743926957500, 922743928409513], // 1452013
    [922850000000000, 922850011473096], // 11473096
    [922868718724350, 922868718774349], // 49999
    [922909513445799, 922909550445799], // 37000000
    [923105801154755, 923105801204755], // 50000
    [923185305795425, 923185306726189], // 930764
    [923221596431016, 923221706270150], // 109839134
    [923302641346799, 923302643332444], // 1985645
    [923348775651184, 923348776468466], // 817282
    [923582268712603, 923582300847016], // 32134413
    [923680951337726, 923680954514907], // 3177181
    [923788342514222, 923788343521052], // 1006830
    [923789739286113, 923789786531237], // 47245124
    [924034585384913, 924034585459913], // 75000
    [924125887916484, 924125888450959], // 534475
    [924193886711856, 924193887727540], // 1015684
    [924392452764874, 924392452814874], // 50000
    [924416400495931, 924416402274007], // 1778076
    [924418718902046, 924418722192298], // 3290252
    [924420279289286, 924420279339286], // 50000
    [924578313371780, 924578313640460], // 268680
    [924588409515338, 924588410311584], // 796246
    [924590838815745, 924590843183493], // 4367748
    [924812827616164, 924812839896973], // 12280809
    [924933177880421, 924933177901890], // 21469
    [925203714070365, 925203714663934], // 593569
    [925203901343839, 925203901581833], // 237994
    [925226884474310, 925226885474310], // 1000000
    [925228817844714, 925228818154940], // 310226
    [925228818154941, 925228818365188], // 210247
    [925228837535874, 925228838396198], // 860324
    [925229144728436, 925229144728437], // 1
    [925303302446862, 925303397293739], // 94846877
    [925351867178583, 925351879304766], // 12126183
    [925415645527966, 925415651176508], // 5648542
    [925440515833124, 925440517277650], // 1444526
    [925640757472804, 925640760048770], // 2575966
    [925661750000000, 925661768923425], // 18923425
    [925735571977554, 925735771977554], // 200000000
    [925785271104788, 925785271986108], // 881320
    [925786672438245, 925786672742527], // 304282
    [925804136814574, 925804136864572], // 49998
    [925809572919414, 925809597461985], // 24542571
    [925828843109794, 925828843120422], // 10628
    [925859924062860, 925859925965984], // 1903124
    [925977515312661, 925977515362661], // 50000
    [925977534225551, 925977534818034], // 592483
    [926212815958897, 926212816104403], // 145506
    [926296309534579, 926296310744579], // 1210000
    [926324039333063, 926324068601916], // 29268853
    [926416858933010, 926416859220575], // 287565
    [926451888996983, 926451889046983], // 50000
    [926452810571900, 926452811907612], // 1335712
    [926759204416156, 926759204720277], // 304121
    [926826484732065, 926826485053864], // 321799
    [927014142645839, 927014143095839], // 450000
    [927021010887507, 927021046399033], // 35511526
    [927049065228673, 927049065312428], // 83755
    [927196603619181, 927196606749432], // 3130251
    [927206412816665, 927206412866665], // 50000
    [927211534811882, 927211537219997], // 2408115
    [927213202893034, 927213203482584], // 589550
    [927213416462917, 927213416512917], // 50000
    [927424889076731, 927424891720000], // 2643269
    [927460123432529, 927460123475304], // 42775
    [927489493907050, 927489494023941], // 116891
    [927697238314439, 927697241172034], // 2857595
    [927697241272034, 927697245983939], // 4711905
    [927697392157304, 927697392207304], // 50000
    [927705155769180, 927705272080099], // 116310919
    [927945485502221, 927945485565369], // 63148
    [927954916714043, 927954949972233], // 33258190
    [928005158575246, 928005181053918], // 22478672
    [928077565120016, 928077565250332], // 130316
    [928098220900752, 928098222531912], // 1631160
    [928131315568126, 928131315618126], // 50000
    [928134067493941, 928134120663941], // 53170000
    [928167726085168, 928167727677558], // 1592390
    [928170598728487, 928170599589493], // 861006
    [928280390389904, 928280390487299], // 97395
    [928280448138464, 928280448274949], // 136485
    [928350916581394, 928350917622697], // 1041303
    [928573119428155, 928573119478155], // 50000
    [928854658109877, 928854658238195], // 128318
    [928921082073759, 928921082079176], // 5417
    [929121733510964, 929121734274705], // 763741
    [929137846268719, 929138163313117], // 317044398
    [929260523398648, 929260523528647], // 129999
    [929262190971831, 929262193285078], // 2313247
    [929345566515372, 929345566626188], // 110816
    [929449705950000, 929449905950000], // 200000000
    [929493278173074, 929493278283074], // 110000
    [929554928291061, 929554929149381], // 858320
    [929786927712925, 929786927762925], // 50000
    [929787119600725, 929787119650725], // 50000
    [929822432471490, 929822432471491], // 1
    [929995458449822, 929995458499822], // 50000
    [930069579348683, 930069579599183], // 250500
    [930090338764593, 930090343729925], // 4965332
    [930108550140839, 930108551207602], // 1066763
    [930112071099856, 930112071149856], // 50000
    [930146758037300, 930146807029705], // 48992405
    [930156568610400, 930156707650000], // 139039600
    [930316595872380, 930316612457500], // 16585120
    [930381369441994, 930381372391993], // 2949999
    [930429098582440, 930429098632439], // 49999
    [930429332189640, 930429332239640], // 50000
    [930469926735288, 930469940110982], // 13375694
    [930582261161835, 930582261831651], // 669816
    [930584378846155, 930584380796155], // 1950000
    [930747065477659, 930747066950266], // 1472607
    [930753698556254, 930753699475589], // 919335
    [930802199353283, 930802199938150], // 584867
    [930860843701262, 930860925971393], // 82270131
    [930980606782280, 930980606832280], // 50000
    [930980779376504, 930980779426504], // 50000
    [930980840829539, 930980840998852], // 169313
    [931075642339094, 931075642472095], // 133001
    [931102528720862, 931102529570862], // 850000
    [931220312070590, 931220312736690], // 666100
    [931333064820992, 931333064870992], // 50000
    [931394430665000, 931394430665001], // 1
    [931467868570891, 931467869333367], // 762476
    [931468532105296, 931468536777434], // 4672138
    [931484474439176, 931484475474471], // 1035295
    [931604395286944, 931604395639109], // 352165
    [931685698736893, 931685745786893], // 47050000
    [931689326762247, 931689327769842], // 1007595
    [931698304324102, 931698338952285], // 34628183
    [931744360934123, 931744383109577], // 22175454
    [931804209065452, 931804209265452], // 200000
    [931816312586104, 931816312919613], // 333509
    [931992666212411, 931992666612410], // 399999
    [932135275362145, 932135275584003], // 221858
    [932183501481679, 932183506353754], // 4872075
    [932183506353754, 932183506928754], // 575000
    [932239450217178, 932239458443292], // 8226114
    [932249592667683, 932249596415066], // 3747383
    [932341713917354, 932341714329954], // 412600
    [932373592180707, 932373593119076], // 938369
    [932557170920685, 932557170970685], // 50000
    [932557171420685, 932557171470685], // 50000
    [932557171920685, 932557171970685], // 50000
    [932680923605012, 932680925405012], // 1800000
    [932887160116729, 932887161025321], // 908592
    [933020114933842, 933020315933842], // 201000000
    [933224842309687, 933224842458185], // 148498
    [933314906096971, 933314910083535], // 3986564
    [933324752760399, 933324753075396], // 314997
    [933414817063082, 933414818634659], // 1571577
    [933432672360546, 933432672369460], // 8914
    [933469883119285, 933469883141325], // 22040
    [933469883153941, 933469883169285], // 15344
    [933474982203340, 933474982303340], // 100000
    [933860061562476, 933860061634525], // 72049
    [933872518791625, 933872518841624], // 49999
    [933966489972565, 933966490797403], // 824838
    [934308918543228, 934308919191662], // 648434
    [934325029555258, 934325029605258], // 50000
    [934325029613258, 934325029663258], // 50000
    [934325029679258, 934325029729258], // 50000
    [934325029745258, 934325029795258], // 50000
    [934325029803258, 934325029853258], // 50000
    [934325029869258, 934325029919258], // 50000
    [934325029927258, 934325029977258], // 50000
    [934325029985258, 934325030035258], // 50000
    [934325030043258, 934325030093258], // 50000
    [934325030109258, 934325030159258], // 50000
    [934325030167258, 934325030217258], // 50000
    [934325030225258, 934325030275258], // 50000
    [934325030283258, 934325030333258], // 50000
    [934325030349258, 934325030399258], // 50000
    [934325030407258, 934325030457258], // 50000
    [934325030473258, 934325030523258], // 50000
    [934325030531258, 934325030581258], // 50000
    [934325030589258, 934325030639258], // 50000
    [934325030647258, 934325030697258], // 50000
    [934325030729258, 934325030779258], // 50000
    [934325030787258, 934325030837258], // 50000
    [934325030845258, 934325030895258], // 50000
    [934325030903258, 934325030953258], // 50000
    [934334574992796, 934334575269030], // 276234
    [934334594194007, 934334594691613], // 497606
    [934391977402656, 934391977430156], // 27500
    [934435592690257, 934435597081357], // 4391100
    [934524645689335, 934524671038035], // 25348700
    [934551284947003, 934551285111856], // 164853
    [934613573575136, 934613573625136], // 50000
    [934717489048288, 934717490048288], // 1000000
    [934746052213488, 934746055163486], // 2949998
    [934746474163486, 934746474426219], // 262733
    [935069728898002, 935069728948002], // 50000
    [935100418090720, 935100418123468], // 32748
    [935178352742869, 935178458987791], // 106244922
    [935180714021677, 935180715020399], // 998722
    [935181122930115, 935181123036303], // 106188
    [935269397479558, 935269400995630], // 3516072
    [935285119170174, 935285119219783], // 49609
    [935397433461158, 935397433540158], // 79000
    [935397446495061, 935397446795061], // 300000
    [935483854386960, 935483854886960], // 500000
    [935607201030120, 935607202280120], // 1250000
    [935609869248949, 935609914191349], // 44942400
    [935627235327322, 935627237437775], // 2110453
    [935640856941000, 935640873555000], // 16614000
    [935901776789185, 935902589686759], // 812897574
    [935920591888099, 935920591958037], // 69938
    [936001812090000, 936002016090000], // 204000000
    [936112306016767, 936112306113248], // 96481
    [936130819830517, 936130819980517], // 150000
    [936130957661224, 936130957664167], // 2943
    [936130958307377, 936130958750587], // 443210
    [936131622871317, 936131622921317], // 50000
    [936132564899748, 936132564926708], // 26960
    [936254115266314, 936254129141314], // 13875000
    [936254169033345, 936254171195972], // 2162627
    [936254255318407, 936254263130906], // 7812499
    [936254263180907, 936254267180906], // 3999999
    [936331046646882, 936331046738162], // 91280
    [936363778164075, 936363895182036], // 117017961
    [936465061067271, 936465061517271], // 450000
    [936655579113144, 936655579113145], // 1
    [936655584422658, 936655584442168], // 19510
    [936655598751402, 936655598951401], // 199999
    [936720458735002, 936720459800000], // 1064998
    [936720467700001, 936720468900000], // 1199999
    [936729240790753, 936729240790754], // 1
    [936729830350104, 936729830400104], // 50000
    [936861095699960, 936861098021555], // 2321595
    [936937787621321, 936937787629321], // 8000
    [936937790493321, 936937790501321], // 8000
    [936940175763214, 936940175813214], // 50000
    [936960120166291, 936960120216291], // 50000
    [936960120216291, 936960120266291], // 50000
    [936960120423462, 936960120473462], // 50000
    [936960120473462, 936960120523462], // 50000
    [936960120653611, 936960120703611], // 50000
    [936960120703611, 936960120753611], // 50000
    [936960120860262, 936960120910262], // 50000
    [936960120910262, 936960120960262], // 50000
    [936960121063262, 936960121113262], // 50000
    [936964244149246, 936964244199246], // 50000
    [936964244649246, 936964244699246], // 50000
    [936964245149246, 936964245199246], // 50000
    [936964245649246, 936964245699246], // 50000
    [936964246149246, 936964246199246], // 50000
    [936964246649246, 936964246699246], // 50000
    [936964251349186, 936964251399186], // 50000
    [937068745463163, 937068747400015], // 1936852
    [937145746897234, 937145746924818], // 27584
    [937211349793423, 937211354207979], // 4414556
    [937220957307567, 937220958221471], // 913904
    [937293232520981, 937293232570981], // 50000
    [937308801031345, 937308806631345], // 5600000
    [937377843860971, 937377853760970], // 9899999
    [937402424719235, 937402424765334], // 46099
    [937514552153698, 937514777105972], // 224952274
    [937526795395811, 937526795484001], // 88190
    [937555479366808, 937555479748087], // 381279
    [937558164073564, 937558164083564], // 10000
    [937558165655568, 937558165695564], // 39996
    [937616096483477, 937616096493477], // 10000
    [937616097978477, 937616097988477], // 10000
    [937619426710830, 937619426720830], // 10000
    [937677559900269, 937677560746826], // 846557
    [937910661228094, 937910661393093], // 164999
    [937954080454890, 937954399249315], // 318794425
    [938090217560049, 938090217839048], // 278999
    [938139136660497, 938139466888740], // 330228243
    [938156044154173, 938156045104172], // 949999
    [938156102831415, 938156102981415], // 150000
    [938156166876783, 938156167263402], // 386619
    [938156182154173, 938156183154172], // 999999
    [938262084908604, 938262084926350], // 17746
    [938286706469643, 938286706657220], // 187577
    [938324070855772, 938324298738933], // 227883161
    [938328609634518, 938328609684518], // 50000
    [938361265970720, 938361266170720], // 200000
    [938364225289164, 938364537105629], // 311816465
    [938405180197115, 938405180247115], // 50000
    [938409503692164, 938409554310899], // 50618735
    [938507554744128, 938507916585597], // 361841469
    [938570147492834, 938570157101484], // 9608650
    [938587986357107, 938588002870959], // 16513852
    [938598428185559, 938598447168192], // 18982633
    [938609563153856, 938609672449975], // 109296119
    [938619236591904, 938619546414970], // 309823066
    [938624344203906, 938624353803050], // 9599144
    [938629248624466, 938629560465028], // 311840562
    [938782451838902, 938782452238901], // 399999
    [938782508713288, 938782508873287], // 159999
    [938782554213074, 938782554313074], // 100000
    [938807941500000, 938808159500000], // 218000000
    [938808344183549, 938808344233549], // 50000
    [938808344383549, 938808344433549], // 50000
    [938808344660509, 938808344710509], // 50000
    [938808344710509, 938808344760509], // 50000
    [938808344760509, 938808344810509], // 50000
    [938808344810509, 938808344860509], // 50000
    [938808344860509, 938808344910509], // 50000
    [938825856463507, 938825856663507], // 200000
    [938861378281306, 938861379368664], // 1087358
    [938884933156959, 938884936006991], // 2850032
    [938959216346995, 938959533395339], // 317048344
    [939126482073955, 939126482123955], // 50000
    [939208912992665, 939209071030930], // 158038265
    [939212310261811, 939212334003163], // 23741352
    [939226565483291, 939226566041654], // 558363
    [939231537654977, 939231537704977], // 50000
    [939296720570015, 939296720670053], // 100038
    [939305226378117, 939305227375317], // 997200
    [939481440561679, 939481440698881], // 137202
    [939615243633796, 939615243683796], // 50000
    [939652281952984, 939652293166224], // 11213240
    [939723599773301, 939723599823301], // 50000
    [939770997560206, 939770997817475], // 257269
    [939771901686178, 939771901687874], // 1696
    [939830473887192, 939830474442191], // 554999
    [939998500742914, 939998500742915], // 1
    [940159274466255, 940159406914966], // 132448711
    [940224991938836, 940224994229803], // 2290967
    [940260505182596, 940260505232596], // 50000
    [940455095141883, 940455095396170], // 254287
    [940493576329129, 940493777329129], // 201000000
    [940590950445000, 940590962605214], // 12160214
    [940590995800000, 940590996185000], // 385000
    [940804788243573, 940804788293573], // 50000
    [940820136656010, 940820142669445], // 6013435
    [940820839107615, 940820845213234], // 6105619
    [940833099134714, 940833099184714], // 50000
    [940833481689392, 940833482799392], // 1110000
    [940861976575462, 940861976625462], // 50000
    [940861977075462, 940861977125462], // 50000
    [940861977575462, 940861977625462], // 50000
    [940861982225402, 940861982275402], // 50000
    [940916838762044, 940917204186771], // 365424727
    [941291468811766, 941291518811766], // 50000000
    [941306121780559, 941306167323531], // 45542972
    [941606257551347, 941606265501347], // 7950000
    [941682036585889, 941682036915957], // 330068
    [941694271219386, 941694385500737], // 114281351
    [941818126127538, 941818151127538], // 25000000
    [941872416019197, 941872418120210], // 2101013
    [941922512151315, 941922541651965], // 29500650
    [941959175054784, 941959271946866], // 96892082
    [942243766157010, 942243779941730], // 13784720
    [942371196572420, 942371698572420], // 502000000
    [942408067301164, 942408269301164], // 202000000
    [942681566623495, 942683550109643], // 1983486148
    [942745843932394, 942745944684595], // 100752201
    [942747043726245, 942747143676245], // 99950000
    [942789411430304, 942789411880448], // 450144
    [942888713492443, 942888713542443], // 50000
    [942888713542443, 942888713592443], // 50000
    [942888713592443, 942888713642443], // 50000
    [942888713642443, 942888713692443], // 50000
    [942888713692443, 942888713742443], // 50000
    [942888713742443, 942888713792443], // 50000
    [942888713792443, 942888713842443], // 50000
    [942911391688812, 942911392580447], // 891635
    [943127859245959, 943128086629286], // 227383327
    [943327761196385, 943327761246385], // 50000
    [943577398948580, 943577398998579], // 49999
    [943577399248579, 943577399248580], // 1
    [943577399348579, 943577399348580], // 1
    [943825000372613, 943825001036978], // 664365
    [944278723314638, 944278741264638], // 17950000
    [944363494358165, 944363494582432], // 224267
    [944480000000000, 944480000403492], // 403492
    [944534175166481, 944534221981230], // 46814749
    [944611199729689, 944611200000000], // 270311
    [944648558484656, 944648558534656], // 50000
    [944863685130860, 944864638550000], // 953419140
    [944970120085612, 944970121268613], // 1183001
    [944990016623453, 944990086122028], // 69498575
    [945034857818584, 945034857868584], // 50000
    [945034857868584, 945034857918584], // 50000
    [945527655990591, 945527963431733], // 307441142
    [945664460813719, 945664460818816], // 5097
    [945693076255215, 945693094735289], // 18480074
    [945902236365960, 945902239959425], // 3593465
    [945902297998341, 945902308120525], // 10122184
    [945908844174047, 945908844184047], // 10000
    [945927104469369, 945927114469369], // 10000000
    [945974354218298, 945974355576925], // 1358627
    [946388698037605, 946388698987605], // 950000
    [946393010794099, 946393012297848], // 1503749
    [946478209092392, 946478209102392], // 10000
    [946505085142815, 946505086142815], // 1000000
    [946547614036937, 946547617398286], // 3361349
    [946622295095252, 946622473012703], // 177917451
    [946966625667656, 946966625698263], // 30607
    [946969237020457, 946969237070457], // 50000
    [947086647487764, 947086651012650], // 3524886
    [947196008835518, 947196834835518], // 826000000
    [947239175277935, 947239175495289], // 217354
    [947250325035793, 947250325085793], // 50000
    [947250325085793, 947250325235793], // 150000
    [947251902748089, 947251912594832], // 9846743
    [947390277953698, 947390278149573], // 195875
    [947455945383835, 947455945433835], // 50000
    [947455945502285, 947455945520780], // 18495
    [947455945552285, 947455945602285], // 50000
    [947455945655285, 947455945705285], // 50000
    [947455945705285, 947455945755285], // 50000
    [947455945808285, 947455945858285], // 50000
    [947455945858285, 947455945908285], // 50000
    [947455998604028, 947455998654028], // 50000
    [947455999104028, 947455999154028], // 50000
    [947456019968811, 947456019982870], // 14059
    [947456020432870, 947456020482870], // 50000
    [947456021455414, 947456021505414], // 50000
    [947456052648919, 947456052698919], // 50000
    [947460213316198, 947460224419706], // 11103508
    [947531207405812, 947531239495493], // 32089681
    [947919888350000, 947919909320000], // 20970000
    [948039862387284, 948039949070123], // 86682839
    [948208560598844, 948208560598845], // 1
    [948208561598844, 948208561898778], // 299934
    [948245657822180, 948245657822181], // 1
    [948246797603530, 948246797914483], // 310953
    [948296176640305, 948296176640306], // 1
    [948348213925576, 948348213975576], // 50000
    [948353031670690, 948353031687290], // 16600
    [948396956959735, 948396956972690], // 12955
    [948477719300714, 948477766333161], // 47032447
    [948477811978108, 948477811978109], // 1
    [948479023867840, 948479071588842], // 47721002
    [948693415733873, 948693415783873], // 50000
    [948739379688295, 948739389588295], // 9900000
    [948791760061683, 948791761148792], // 1087109
    [948808349688434, 948808351544792], // 1856358
    [948970698343257, 948970698393256], // 49999
    [949013428461564, 949013977025746], // 548564182
    [949337528262122, 949337533888261], // 5626139
    [949638411458719, 949638412458719], // 1000000
    [949724769584125, 949724770584125], // 1000000
    [949805000000000, 949805418268354], // 418268354
    [949829104986495, 949829105486495], // 500000
    [949973455843794, 949973467117606], // 11273812
    [949985492145238, 949985492145239], // 1
    [949985497053032, 949985497825504], // 772472
    [950023210201481, 950023456405341], // 246203860
    [950029083353080, 950029083403080], // 50000
    [950045938834708, 950045959451412], // 20616704
    [950055002071242, 950055002121242], // 50000
    [950160079384150, 950160079434150], // 50000
    [950160079434150, 950160079467453], // 33303
    [950206423725233, 950206423776243], // 51010
    [950208697648407, 950208697692468], // 44061
    [950221251164562, 950221252118410], // 953848
    [950322321746645, 950322321796645], // 50000
    [950624381203918, 950624384164971], // 2961053
    [950751393721741, 950751427925552], // 34203811
    [950797186684506, 950797186734506], // 50000
    [950875838838640, 950875838959670], // 121030
    [950876226893952, 950876227893952], // 1000000
    [950876228129488, 950876228494474], // 364986
    [951015102171797, 951015102221797], // 50000
    [951110979228435, 951110979278435], // 50000
    [951288589299427, 951288589530487], // 231060
    [951367516970928, 951367528272306], // 11301378
    [951420586502838, 951420586515474], // 12636
    [951420592715475, 951420593665474], // 949999
    [951590764397511, 951590815706405], // 51308894
    [951592165963674, 951592166013674], // 50000
    [951592166013674, 951592166063674], // 50000
    [951777371460467, 951777371510467], // 50000
    [951777998484381, 951777998534381], // 50000
    [951777998534381, 951777998681800], // 147419
    [951865174689290, 951865174739290], // 50000
    [951865176689290, 951865176739290], // 50000
    [951865187659290, 951865187709290], // 50000
    [951865187709290, 951865187759290], // 50000
    [951865187759290, 951865187809290], // 50000
    [951865187809290, 951865187859290], // 50000
    [951865187859290, 951865187909290], // 50000
    [951924073084505, 951924073146025], // 61520
    [951990876261650, 951990876461650], // 200000
    [952078709380492, 952078709430487], // 49995
    [952151542485312, 952151543485311], // 999999
    [952491577819285, 952491579676981], // 1857696
    [952507846698614, 952508004505000], // 157806386
    [952531983433385, 952531983483385], // 50000
    [952580161045561, 952580161095561], // 50000
    [952580161225710, 952580161275710], // 50000
    [952580161275710, 952580161325710], // 50000
    [952580161432361, 952580161437840], // 5479
    [952635728584061, 952635729584061], // 1000000
    [952795422590174, 952795422640174], // 50000
    [952925871708913, 952925980742114], // 109033201
    [952978879389548, 952978879439548], // 50000
    [953103478284844, 953103478334844], // 50000
    [953186240687234, 953186240737234], // 50000
    [953211722163868, 953211722302324], // 138456
    [953239795081350, 953239805081350], // 10000000
    [953305500328820, 953305501024000], // 695180
    [953551402708780, 953551425404182], // 22695402
    [953609260661785, 953609281747826], // 21086041
    [953751420184641, 953751420234641], // 50000
    [954115605429120, 954115606342219], // 913099
    [954300272533222, 954300272601086], // 67864
    [954691894345621, 954692030822281], // 136476660
    [954743943885247, 954743943935247], // 50000
    [954743944385247, 954743944435247], // 50000
    [954744266246509, 954744266296509], // 50000
    [954744267246509, 954744267296509], // 50000
    [954744267746509, 954744267796509], // 50000
    [954744288959349, 954744289009349], // 50000
    [954744289459349, 954744289509349], // 50000
    [954744289959349, 954744290009349], // 50000
    [954744290459349, 954744290509349], // 50000
    [954744636614766, 954744636664766], // 50000
    [954744637114766, 954744637164766], // 50000
    [954744672703072, 954744672753072], // 50000
    [954744878308255, 954744878358255], // 50000
    [954744906449425, 954744906499425], // 50000
    [954896812266244, 954896812266245], // 1
    [954896824000362, 954896827312444], // 3312082
    [954919432430857, 954919432480857], // 50000
    [954919432930857, 954919432980857], // 50000
    [954919433930857, 954919433980857], // 50000
    [954919434430857, 954919434480857], // 50000
    [954919434930857, 954919434980857], // 50000
    [955042339240354, 955042362391180], // 23150826
    [955080000000000, 955080001000000], // 1000000
    [955088542212635, 955088542365834], // 153199
    [955091779184340, 955091779234340], // 50000
    [955131581536869, 955131581798029], // 261160
    [955350507171785, 955350507371785], // 200000
    [955743233147879, 955743243147879], // 10000000
    [956110106513540, 956110106563540], // 50000
    [956124529789738, 956124529839738], // 50000
    [956124530104820, 956124530154820], // 50000
    [956124530154820, 956124530204820], // 50000
    [956301523288382, 956301523338382], // 50000
    [956321733137786, 956321733187786], // 50000
    [956323598487786, 956323598537786], // 50000
    [956323784438416, 956323784488416], // 50000
    [956556818497097, 956557257121519], // 438624422
    [956901371517495, 956901371567495], // 50000
    [956901371567495, 956901371617495], // 50000
    [956902861015404, 956902861195553], // 180149
    [956903971101817, 956903971151817], // 50000
    [956903971201817, 956903971251817], // 50000
    [956903971302586, 956903971352586], // 50000
    [956903971352586, 956903971402586], // 50000
    [957209588718944, 957209588768944], // 50000
    [957377467543294, 957377467593294], // 50000
    [957377810418624, 957377811318892], // 900268
    [957531967450611, 957531967904121], // 453510
    [957605974824304, 957605974874304], // 50000
    [958185646371196, 958185647371196], // 1000000
    [958345331021160, 958346151444032], // 820422872
    [958539751001672, 958539754706992], // 3705320
    [958575850972192, 958575938703897], // 87731705
    [958869689020246, 958869705970246], // 16950000
    [958894103639785, 958894103656916], // 17131
    [958980791679603, 958980791685603], // 6000
    [959264316102926, 959264316152926], // 50000
    [959707660201391, 959707660251391], // 50000
    [959850521700806, 959850522784337], // 1083531
    [959850946915718, 959850948060331], // 1144613
    [959852850401998, 959852851124563], // 722565
    [959852854445052, 959852857325180], // 2880128
    [959863968183552, 959863969744935], // 1561383
    [959908018742846, 959908046445145], // 27702299
    [959963442990212, 959963443040212], // 50000
    [959963443040212, 959963443090212], // 50000
    [959963443456908, 959963443506908], // 50000
    [959963443506908, 959963443556908], // 50000
    [959985032484971, 959985039484971], // 7000000
    [960095322326210, 960095322426210], // 100000
    [960287793402222, 960287804012813], // 10610591
    [960342954407863, 960342954457863], // 50000
    [960391687575121, 960391687725121], // 150000
    [960415085696737, 960415085746737], // 50000
    [960452157555031, 960452157555032], // 1
    [960559411686697, 960559411736697], // 50000
    [960615415912947, 960615415918482], // 5535
    [960618296579667, 960618296779667], // 200000
    [960799653164528, 960799653214528], // 50000
    [960806411351790, 960806421726083], // 10374293
    [960822783149137, 960822783199137], // 50000
    [960957713533651, 960957728047514], // 14513863
    [961009771480594, 961009773163090], // 1682496
    [961076974927263, 961076975721923], // 794660
    [961278691641757, 961278695230127], // 3588370
    [961357037225859, 961357037298899], // 73040
    [961392660680580, 961392687837487], // 27156907
    [961419616300805, 961419616350805], // 50000
    [961419649801475, 961419649851475], // 50000
    [961475322222554, 961475322272554], // 50000
    [961525851103614, 961525851153614], // 50000
    [961525861822562, 961525861872562], // 50000
    [961525872752744, 961525872802744], // 50000
    [961525926683056, 961525926733056], // 50000
    [961526211040719, 961526211090719], // 50000
    [961526224264926, 961526224314926], // 50000
    [961526324658812, 961526324708812], // 50000
    [961526428295333, 961526428345333], // 50000
    [961526935861398, 961526935911398], // 50000
    [961527057447846, 961527057497846], // 50000
    [961527173889386, 961527173939386], // 50000
    [961527237405052, 961527237455052], // 50000
    [961540009438094, 961540034438094], // 25000000
    [961598385015727, 961598385065727], // 50000
    [961756913335385, 961756914239233], // 903848
    [961776683106483, 961776683156483], // 50000
    [961776753954151, 961776754004151], // 50000
    [961776764934504, 961776764984504], // 50000
    [961804277396067, 961804296737651], // 19341584
    [961827532376166, 961827550948290], // 18572124
    [961848294603585, 961848294653585], // 50000
    [961924039452756, 961924039502756], // 50000
    [961924389233452, 961924389267944], // 34492
    [961924389267944, 961924390267944], // 1000000
    [962215904696133, 962215915256898], // 10560765
    [962327184935056, 962327184985056], // 50000
    [962392212850865, 962392212900865], // 50000
    [962801704927577, 962801719927577], // 15000000
    [963117387787290, 963117387837290], // 50000
    [963215055205791, 963215055255791], // 50000
    [963241806205985, 963241807205985], // 1000000
    [963433918085788, 963433927091567], // 9005779
    [963504261642771, 963504261692771], // 50000
    [963504261692771, 963504261742771], // 50000
    [963504435757511, 963504435827511], // 70000
    [963606348842706, 963606348937762], // 95056
    [963700512191602, 963700545421602], // 33230000
    [963725197269021, 963725295899021], // 98630000
    [963887712266650, 963887742705343], // 30438693
    [964017495282054, 964017495332054], // 50000
    [964017495332054, 964017495382054], // 50000
    [964357211909275, 964357234403299], // 22494024
    [964681662126067, 964681675744443], // 13618376
    [964923586293326, 964923586293327], // 1
    [965017665061248, 965017665065373], // 4125
    [965248960251712, 965248960251713], // 1
    [965450331233522, 965450332314098], // 1080576
    [965892103407309, 965892118757309], // 15350000
    [966006519900003, 966006520900003], // 1000000
    [966018896323014, 966018896324310], // 1296
    [966058342587554, 966058342617183], // 29629
    [966183948992014, 966183949042014], // 50000
    [966243016582018, 966243016632018], // 50000
    [966300000448318, 966300000639409], // 191091
    [966491842312284, 966491851212283], // 8899999
    [966499301487887, 966499301742803], // 254916
    [966577345446264, 966577345496264], // 50000
    [966712146853175, 966712146903175], // 50000
    [966737328341579, 966737332345169], // 4003590
    [966737505509414, 966737505559414], // 50000
    [966767931273336, 966767995089336], // 63816000
    [966855785910228, 966855785960228], // 50000
    [966855785960228, 966855786010228], // 50000
    [966977149710781, 966977149760781], // 50000
    [967206156754504, 967206157204500], // 449996
    [967551954596514, 967551954821514], // 225000
    [967608144009564, 967608172308892], // 28299328
    [967739170348031, 967739170358888], // 10857
    [967739170764276, 967739170803418], // 39142
    [968051734781141, 968051734831141], // 50000
    [968051734831141, 968051734881141], // 50000
    [968051736831141, 968051736881141], // 50000
    [968051736881141, 968051736931141], // 50000
    [968051738881141, 968051738931141], // 50000
    [968051738931141, 968051738981141], // 50000
    [968051740931141, 968051740981141], // 50000
    [968051740981141, 968051741031141], // 50000
    [968191409426230, 968191409476230], // 50000
    [968431039598302, 968431039798302], // 200000
    [968684840338100, 968684841254497], // 916397
    [968797162018417, 968797168918423], // 6900006
    [968807481585572, 968807482943883], // 1358311
    [968946105005000, 968946106005000], // 1000000
    [969069870395830, 969069870445830], // 50000
    [969478259060032, 969478259079508], // 19476
    [969534321882164, 969534325292493], // 3410329
    [969676529377456, 969676529427456], // 50000
    [969966283332557, 969966289024868], // 5692311
    [970002294189807, 970002294190385], // 578
    [970087102731937, 970087102781937], // 50000
    [970087102781937, 970087102831937], // 50000
    [970087106781937, 970087106831937], // 50000
    [970087106831937, 970087106881937], // 50000
    [970087119881937, 970087119931937], // 50000
    [970087119956937, 970087120257198], // 300261
    [970087136390762, 970087136440762], // 50000
    [970087146423880, 970087146473880], // 50000
    [970087171847485, 970087171897485], // 50000
    [970087188452058, 970087188502058], // 50000
    [970222752941942, 970222752941943], // 1
    [970441064514812, 970441064582067], // 67255
    [970441074286724, 970441074364812], // 78088
    [970441083414812, 970441083464809], // 49997
    [970948596165094, 970948598151320], // 1986226
    [971062861486170, 971062861496170], // 10000
    [971075119694497, 971075219694497], // 100000000
    [971082714068173, 971082714704920], // 636747
    [971426943884764, 971426946934861], // 3050097
    [972180542400481, 972180543500481], // 1100000
    [972245139870000, 972245140870000], // 1000000
    [972725439897047, 972725446259047], // 6362000
    [972918578678027, 972919405487027], // 826809000
    [973064696158460, 973064696208460], // 50000
    [973111429182031, 973111429232031], // 50000
    [973111429379088, 973111429429088], // 50000
    [973426109557929, 973426109607929], // 50000
    [973426411031271, 973426411081271], // 50000
    [973428056955471, 973428057002528], // 47057
    [973428201221968, 973428202821363], // 1599395
    [973476946848277, 973476947112785], // 264508
    [973478078107773, 973478083018165], // 4910392
    [973488743766318, 973488744435018], // 668700
    [973602017347951, 973602017397951], // 50000
    [973602081218638, 973602081268638], // 50000
    [973602171268638, 973602171318638], // 50000
    [973602539118394, 973602539168394], // 50000
    [973632061020225, 973632061070225], // 50000
    [973638428600000, 973638525550000], // 96950000
    [973702173865825, 973702173915825], // 50000
    [973796485261152, 973796485261153], // 1
    [973843646291790, 973843786291790], // 140000000
    [973863904630580, 973863904680580], // 50000
    [973864201673602, 973864217167330], // 15493728
    [973916046826021, 973916046876021], // 50000
    [974102919675175, 974102919715175], // 40000
    [974310141366026, 974310142371144], // 1005118
    [974690135552500, 974690634492500], // 498940000
    [974746096557404, 974746148399875], // 51842471
    [974804093461985, 974804218412937], // 124950952
    [975076514998407, 975076535119478], // 20121071
    [975082934643483, 975082934693483], // 50000
    [975252300191197, 975252300218625], // 27428
    [975373923079603, 975373923129603], // 50000
    [975390483995082, 975390510438076], // 26442994
    [975524048362504, 975524048974048], // 611544
    [975680140362972, 975680140412972], // 50000
    [975680140412972, 975680140462972], // 50000
    [975680140462972, 975680140512972], // 50000
    [975680140512972, 975680140562972], // 50000
    [975885250980216, 975885251020216], // 40000
    [976113402870945, 976113402920945], // 50000
    [976142827816632, 976142828612866], // 796234
    [976194825017708, 976194825097708], // 80000
    [976201844682500, 976201845418564], // 736064
    [976221117122500, 976221117409087], // 286587
    [976250001390644, 976250002390644], // 1000000
    [976311809161943, 976311820151857], // 10989914
    [976358811707180, 976358811997207], // 290027
    [976453016520967, 976453017421800], // 900833
    [976463773941296, 976464181286508], // 407345212
    [976483119458238, 976483119508238], // 50000
    [976504131756929, 976504233168970], // 101412041
    [976550104543452, 976550104593452], // 50000
    [976550104593452, 976550104643452], // 50000
    [976756246210962, 976756246260962], // 50000
    [976801310174191, 976801310184191], // 10000
    [976804888946502, 976804888996502], // 50000
    [976920236274238, 976920236274239], // 1
    [976971199000765, 976971204035565], // 5034800
    [977128366890023, 977128366940023], // 50000
    [977128431508517, 977128431508518], // 1
    [977128504127730, 977128505196767], // 1069037
    [977256071494774, 977256071494775], // 1
    [977286527241269, 977286528701341], // 1460072
    [977342816267129, 977342825012828], // 8745699
    [977568249595369, 977568249772737], // 177368
    [977578449473135, 977578449523135], // 50000
    [977602489883437, 977602663087364], // 173203927
    [977611370000000, 977611371237224], // 1237224
    [977625380348908, 977625380395964], // 47056
    [977705066194372, 977705115377817], // 49183445
    [977782112769389, 977782112769390], // 1
    [977782160328615, 977782160378615], // 50000
    [977839707055215, 977839707167565], // 112350
    [978080251112430, 978080283559025], // 32446595
    [978220540056106, 978220540785160], // 729054
    [978576107337733, 978576107387733], // 50000
    [978634898350000, 978634953044329], // 54694329
    [978754651067320, 978754775066375], // 123999055
    [978802216223084, 978802225022030], // 8798946
    [978842869817983, 978842889769300], // 19951317
    [978844894405000, 978844895680000], // 1275000
    [979029603651634, 979029605171176], // 1519542
    [979054689970358, 979054690020358], // 50000
    [979203006282108, 979203006689817], // 407709
    [979203265741661, 979203266691660], // 949999
    [979307771847389, 979307771897389], // 50000
    [979307771897389, 979307771947389], // 50000
    [979327150185454, 979327153276508], // 3091054
    [979408173847698, 979408174192510], // 344812
    [979484391426772, 979484391436772], // 10000
    [979569436114141, 979569753070197], // 316956056
    [979780067325000, 979780165805000], // 98480000
    [979785012799208, 979785013799208], // 1000000
    [979797066536957, 979797141536957], // 75000000
    [979891901835051, 979891901935051], // 100000
    [980024129893477, 980024812511848], // 682618371
    [980042844868970, 980042844918970], // 50000
    [980203080000000, 980203091442508], // 11442508
    [980297741042406, 980297746185493], // 5143087
    [980298126250369, 980298126300369], // 50000
    [980298126300369, 980298126350369], // 50000
    [980387206169640, 980387206219640], // 50000
    [980467086978967, 980467167775001], // 80796034
    [980518843626370, 980518893626370], // 50000000
    [980731538765258, 980731538765259], // 1
    [980731544765258, 980731545765258], // 1000000
    [980731733865258, 980731733865259], // 1
    [980731744865258, 980731745865258], // 1000000
    [980830431629902, 980830435145294], // 3515392
    [980830439079424, 980830441079424], // 2000000
    [980830441079424, 980830442944816], // 1865392
    [980834859901135, 980834860851134], // 949999
    [980906792344000, 980906792394000], // 50000
    [980906792394000, 980906792444000], // 50000
    [980910267105825, 980910268009673], // 903848
    [981199496484652, 981199500364652], // 3880000
    [981416507218641, 981416507268641], // 50000
    [981448805114755, 981448810064754], // 4949999
    [981541207469245, 981541307319245], // 99850000
    [981544472326140, 981544485141401], // 12815261
    [981545952012910, 981545952029155], // 16245
    [981545954429155, 981545954479155], // 50000
    [981564807193271, 981564807243271], // 50000
    [981846177827410, 981846177877410], // 50000
    [981854349213018, 981854350208635], // 995617
    [982140000000000, 982140050000000], // 50000000
    [982157992836647, 982157994744419], // 1907772
    [982389766921437, 982389871341437], // 104420000
    [982446865106282, 982447101649965], // 236543683
    [982513150534999, 982513150535268], // 269
    [982554271543155, 982554514739963], // 243196808
    [982650170000000, 982650190000000], // 20000000
    [982657876338745, 982658180588725], // 304249980
    [982673205674306, 982673333354599], // 127680293
    [982719388231579, 982719401419894], // 13188315
    [982719401419894, 982719404419894], // 3000000
    [982818458131945, 982818458131946], // 1
    [982818460995636, 982818460995637], // 1
    [982818460995637, 982818460995638], // 1
    [982818464273417, 982818464273418], // 1
    [982818468024138, 982818468024139], // 1
    [982818472315013, 982818472315014], // 1
    [982851257666266, 982851257716266], // 50000
    [982851257716266, 982851257766266], // 50000
    [982851259716266, 982851259766266], // 50000
    [982851259766266, 982851259816266], // 50000
    [982851261766266, 982851261816266], // 50000
    [982851261816266, 982851261866266], // 50000
    [982851263816266, 982851263866266], // 50000
    [982851263866266, 982851263916266], // 50000
    [982851265866266, 982851265916266], // 50000
    [982851265916266, 982851265966266], // 50000
    [982854065406677, 982854169434031], // 104027354
    [982891805502536, 982891805552536], // 50000
    [982932245684676, 982932245734676], // 50000
    [982945602218309, 982945824797525], // 222579216
    [982980114085606, 982980114226343], // 140737
    [983110402871834, 983110459701797], // 56829963
    [983155367298703, 983155367348703], // 50000
    [983200632226453, 983200632276453], // 50000
    [983243821877998, 983243821927998], // 50000
    [983243821977998, 983243822027998], // 50000
    [983243822077998, 983243822127998], // 50000
    [983243822177998, 983243822227998], // 50000
    [983266956112644, 983266956112645], // 1
    [983266958262647, 983266960027649], // 1765002
    [983267290465863, 983267290515863], // 50000
    [983267290515863, 983267290565863], // 50000
    [983267290565863, 983267290615863], // 50000
    [983345143011669, 983345143011670], // 1
    [983345898603875, 983345899573790], // 969915
    [983497723763346, 983497782116873], // 58353527
    [983508428869273, 983508428919273], // 50000
    [983549125512950, 983549125562950], // 50000
    [983561112810792, 983561169702081], // 56891289
    [983600408425139, 983600408475139], // 50000
    [983720738305636, 983720738322857], // 17221
    [983736439694993, 983736441694993], // 2000000
    [983778460364911, 983778460864911], // 500000
    [983829924924318, 983829924924319], // 1
    [983922533273176, 983922533573437], // 300261
    [983922537473437, 983922537522859], // 49422
    [983965177848338, 983965177898338], // 50000
    [984030009777424, 984030010777424], // 1000000
    [984059934987624, 984059935037624], // 50000
    [984107515279697, 984107515379697], // 100000
    [984140838185740, 984140938893810], // 100708070
    [984155797202667, 984155797252667], // 50000
    [984219240725129, 984219341670901], // 100945772
    [984333570901959, 984333574241295], // 3339336
    [984370575550786, 984370575550787], // 1
    [984521776889275, 984521796889275], // 20000000
    [984600004974277, 984600005024277], // 50000
    [984654271449463, 984654272367498], // 918035
    [984675127530771, 984675156325675], // 28794904
    [984675156325675, 984675157327024], // 1001349
    [984721554631582, 984721554681582], // 50000
    [984856322086693, 984856322136693], // 50000
    [984856322136693, 984856322186693], // 50000
    [984869838983666, 984870000000000], // 161016334
    [984952174123856, 984952179444003], // 5320147
    [985027101773865, 985027203762930], // 101989065
    [985039956932275, 985039956982275], // 50000
    [985146764400458, 985146764450458], // 50000
    [985215080865090, 985215081044059], // 178969
    [985433997104654, 985433998104654], // 1000000
    [985510515404741, 985510616355032], // 100950291
    [985532312651137, 985532346104780], // 33453643
    [985534300209908, 985534300259908], // 50000
    [985556558785938, 985556658987477], // 100201539
    [985584000297238, 985584218079286], // 217782048
    [985598789576771, 985598894161479], // 104584708
    [985613995898936, 985614067426869], // 71527933
    [985768820564773, 985768820614773], // 50000
    [985768820664773, 985768820714773], // 50000
    [985768820764773, 985768820814773], // 50000
    [985768820964773, 985768821014773], // 50000
    [985790000000000, 985794188346667], // 4188346667
    [985818859703977, 985819725220545], // 865516568
    [985845736756593, 985845736806593], // 50000
    [986060202820885, 986060205671602], // 2850717
    [986084550978211, 986084551024359], // 46148
    [986132342923863, 986132342973863], // 50000
    [986203714008752, 986203714018752], // 10000
    [986336167991469, 986337080501792], // 912510323
    [986362420934144, 986362440934144], // 20000000
    [986494749413020, 986494750263019], // 849999
    [986573422379332, 986573422629331], // 249999
    [986689175845758, 986689184795758], // 8950000
    [986796647542201, 986796751022219], // 103480018
    [987013194406655, 987013194491655], // 85000
    [987055184326249, 987055190326249], // 6000000
    [987072859086290, 987072859136290], // 50000
    [987072869156656, 987072869206656], // 50000
    [987072974727373, 987072974777373], // 50000
    [987073026970939, 987073027020939], // 50000
    [987073044636953, 987073044686953], // 50000
    [987073068814419, 987073068864419], // 50000
    [987073079027502, 987073079077502], // 50000
    [987073090335225, 987073090385225], // 50000
    [987073201611203, 987073201661203], // 50000
    [987073212091599, 987073212141599], // 50000
    [987073265864550, 987073265914550], // 50000
    [987073311806367, 987073311856367], // 50000
    [987073321902358, 987073321952358], // 50000
    [987073321952358, 987073322002358], // 50000
    [987073374357095, 987073374407095], // 50000
    [987073411261216, 987073411311216], // 50000
    [987073513913854, 987073513963854], // 50000
    [987074070302013, 987074070352013], // 50000
    [987074166913418, 987074166963418], // 50000
    [987074382960111, 987074383010111], // 50000
    [987074407990993, 987074408040993], // 50000
    [987074418075272, 987074418125272], // 50000
    [987074430337800, 987074430387800], // 50000
    [987074606286985, 987074606336985], // 50000
    [987074708117321, 987074708167321], // 50000
    [987074735390216, 987074735440216], // 50000
    [987074760730920, 987074760780920], // 50000
    [987074797065608, 987074797115608], // 50000
    [987168297903240, 987168336903240], // 39000000
    [987171671302322, 987171702378532], // 31076210
    [987399905776712, 987399905826712], // 50000
    [987399945000367, 987399945450367], // 450000
    [987624330345550, 987624431540599], // 101195049
    [987641090335451, 987641091039759], // 704308
    [987660209767593, 987660209817593], // 50000
    [987741244173294, 987741244187998], // 14704
    [987966057687217, 987966061815366], // 4128149
    [987968980746506, 987968980796506], // 50000
    [988021003679262, 988021003729262], // 50000
    [988107667564064, 988107667614064], // 50000
    [988109963204686, 988109963258510], // 53824
    [988175716183863, 988175716222753], // 38890
    [988199371093178, 988199372043177], // 949999
    [988199428721538, 988199428800038], // 78500
    [988277672517818, 988277672567818], // 50000
    [988287291598269, 988287393082785], // 101484516
    [988332452384397, 988332452434397], // 50000
    [988332467330697, 988332467380697], // 50000
    [988346981786367, 988347082554094], // 100767727
    [988416962829336, 988416962879336], // 50000
    [988416962879336, 988416962929336], // 50000
    [988436957996992, 988437059745918], // 101748926
    [988476420097255, 988476420147255], // 50000
    [988555494683460, 988555494733460], // 50000
    [988568708682783, 988568708732783], // 50000
    [988630002000000, 988630003000000], // 1000000
    [988655792614049, 988655792664049], // 50000
    [988695000677392, 988695000727392], // 50000
    [988797685848851, 988797685898851], // 50000
    [988804317619647, 988804317669647], // 50000
    [988813802019034, 988813802069034], // 50000
    [988839073308790, 988839073408790], // 100000
    [988885293751227, 988885312801227], // 19050000
    [988938323655054, 988938323705054], // 50000
    [989010383000000, 989010627271922], // 244271922
    [989017198111046, 989017198150751], // 39705
    [989111647040039, 989111749017607], // 101977568
    [989129121976542, 989129122026542], // 50000
    [989214944125803, 989214944491779], // 365976
    [989272233514058, 989272233564058], // 50000
    [989283723378489, 989283724739909], // 1361420
    [989300149579873, 989301185066463], // 1035486590
    [989364071638180, 989364071688180], // 50000
    [989364072688180, 989364072738180], // 50000
    [989364075552180, 989364075602180], // 50000
    [989364076602180, 989364076652180], // 50000
    [989364078279183, 989364078329183], // 50000
    [989364945976650, 989364950546250], // 4569600
    [989488519921320, 989488651890719], // 131969399
    [989537584288112, 989537647819912], // 63531800
    [989551685445688, 989551685495688], // 50000
    [989560210000000, 989560230000000], // 20000000
    [989639782121331, 989639853489931], // 71368600
    [989692667159626, 989692726966730], // 59807104
    [989713916018314, 989713916068314], // 50000
    [989722476687656, 989722605879253], // 129191597
    [989726666712746, 989726666751194], // 38448
    [989729816354381, 989729916254381], // 99900000
    [989766435614429, 989766544722462], // 109108033
    [989854269911593, 989854411566493], // 141654900
    [989854854232677, 989854962089452], // 107856775
    [989896333908259, 989896951824315], // 617916056
    [989911701852779, 989911701852780], // 1
    [990045296034896, 990045296126296], // 91400
    [990090430085945, 990090430085946], // 1
    [990090495085945, 990090495085946], // 1
    [990090516085945, 990090516085946], // 1
    [990090517085945, 990090517085946], // 1
    [990090519085945, 990090519085946], // 1
    [990090526285945, 990090530881304], // 4595359
    [990090534881304, 990090535881304], // 1000000
    [990159982747500, 990160000000000], // 17252500
    [990240083340241, 990240188800241], // 105460000
    [990256740924390, 990256741926009], // 1001619
    [990257938497709, 990257938547709], // 50000
    [990277204316246, 990277204366246], // 50000
    [990280302352045, 990280302402045], // 50000
    [990280373152046, 990280373202046], // 50000
    [990339076567421, 990339078199096], // 1631675
    [990384113749895, 990384186226495], // 72476600
    [990401522906129, 990401522906130], // 1
    [990401531906129, 990401532906129], // 1000000
    [990401718006129, 990401718006130], // 1
    [990401723006129, 990401723006130], // 1
    [990401724006129, 990401724006130], // 1
    [990401730006129, 990401730006130], // 1
    [990401731006129, 990401731006130], // 1
    [990401732006129, 990401732006130], // 1
    [990401733006129, 990401733006130], // 1
    [990401735006129, 990401735006130], // 1
    [990401741006129, 990401741876129], // 870000
    [990417357710289, 990417458090289], // 100380000
    [990419725001628, 990419729617628], // 4616000
    [990419988554013, 990419993134513], // 4580500
    [990482477405456, 990482735405456], // 258000000
    [990559499450000, 990559599450000], // 100000000
    [990611754691110, 990611855377021], // 100685911
    [990657647657256, 990657663286015], // 15628759
    [990657663286015, 990657663296015], // 10000
    [990657675286015, 990657690618896], // 15332881
    [990755010190988, 990755010887124], // 696136
    [990766420584599, 990766580240768], // 159656169
    [990777564803133, 990777569720033], // 4916900
    [990868467665383, 990868467715383], // 50000
    [990868469168569, 990868469218569], // 50000
    [990902642039345, 990902642049345], // 10000
    [990924818373700, 990924820100000], // 1726300
    [990959651337685, 990959651387685], // 50000
    [991006931306559, 991007036617579], // 105311020
    [991033885358535, 991034094055154], // 208696619
    [991041364264295, 991041364314295], // 50000
    [991051067581672, 991051068770490], // 1188818
    [991055734942836, 991055734992836], // 50000
    [991065070268777, 991065070268778], // 1
    [991065073268777, 991065073268778], // 1
    [991065076268777, 991065076268778], // 1
    [991065093268777, 991065093268778], // 1
    [991065095268777, 991065095268778], // 1
    [991065101268777, 991065101268778], // 1
    [991065104268777, 991065104268778], // 1
    [991065105268777, 991065105268778], // 1
    [991065106268777, 991065106268778], // 1
    [991065108268777, 991065108468777], // 200000
    [991065356268777, 991065390666709], // 34397932
    [991133684891521, 991133684941521], // 50000
    [991160916938000, 991161016938000], // 100000000
    [991187269553316, 991187269653316], // 100000
    [991195853034033, 991195955723315], // 102689282
    [991266320000000, 991266436800000], // 116800000
    [991284782503442, 991284782619618], // 116176
    [991324956506624, 991324957256623], // 749999
    [991344997210497, 991345000000000], // 2789503
    [991345200000000, 991345220000000], // 20000000
    [991388291125464, 991388342922966], // 51797502
    [991435315088474, 991435331572523], // 16484049
    [991435421988295, 991435439467188], // 17478893
    [991566332927624, 991566332927625], // 1
    [991585170000000, 991585270000000], // 100000000
    [991712522940707, 991712523940726], // 1000019
    [991780991683375, 991781039562201], // 47878826
    [991786416877828, 991786417727857], // 850029
    [991799926340193, 991799934611892], // 8271699
    [991839830162112, 991839830212112], // 50000
    [991841072898519, 991841074197513], // 1298994
    [991864973329888, 991864976198832], // 2868944
    [991870928658447, 991870929108445], // 449998
    [991918647771733, 991918647821733], // 50000
    [991995210000000, 991995310000000], // 100000000
    [992022931781872, 992023025736294], // 93954422
    [992069951886282, 992070000000000], // 48113718
    [992070208623937, 992071038623937], // 830000000
    [992073457796099, 992073488546099], // 30750000
    [992091700000000, 992091800000000], // 100000000
    [992171453723607, 992171503723607], // 50000000
    [992215566157118, 992215586157118], // 20000000
    [992215678964292, 992215750201709], // 71237417
    [992217006285317, 992217026628938], // 20343621
    [992218232045453, 992218233923412], // 1877959
    [992268816777781, 992268816827781], // 50000
    [992354230349070, 992354231410224], // 1061154
    [992359413499397, 992359517989068], // 104489671
    [992381727660866, 992381727710866], // 50000
    [992402738510000, 992402747222414], // 8712414
    [992429617345317, 992429712645317], // 95300000
    [992439446417599, 992439446467599], // 50000
    [992456547497299, 992456547547299], // 50000
    [992456557547299, 992456557597299], // 50000
    [992470668800000, 992470668900000], // 100000
    [992509597111579, 992509597161579], // 50000
    [992623768959252, 992623882959252], // 114000000
    [992677829615510, 992677829690553], // 75043
    [992832768607704, 992832969778549], // 201170845
    [992897090066253, 992897090129832], // 63579
    [992938267739714, 992938267789714], // 50000
    [992938367739714, 992938367789714], // 50000
    [992938467739714, 992938467789714], // 50000
    [993016838566129, 993016838616129], // 50000
    [993030000000000, 993030018600000], // 18600000
    [993220606371880, 993220607222953], // 851073
    [993222498371880, 993222500371880], // 2000000
    [993292430000000, 993292529490000], // 99490000
    [993332525369814, 993332965650715], // 440280901
    [993420000000000, 993420020000000], // 20000000
    [993455258601019, 993455259051017], // 449998
    [993475050000000, 993475056883417], // 6883417
    [993475890000000, 993475990000000], // 100000000
    [993478398659475, 993478410709475], // 12050000
    [993569806157567, 993569926455000], // 120297433
    [993578591360000, 993578591410000], // 50000
    [993580998508418, 993581026226308], // 27717890
    [993590463062500, 993590523602500], // 60540000
    [993619777211338, 993619786541433], // 9330095
    [993643465261552, 993643465311552], // 50000
    [993643664363211, 993643665313211], // 950000
    [993643679991502, 993643681128846], // 1137344
    [993644348882276, 993644348932276], // 50000
    [993644537329195, 993644537399195], // 70000
    [993652829027211, 993652829077211], // 50000
    [993653853820447, 993653853870447], // 50000
    [993654425507632, 993654425557632], // 50000
    [993816120581998, 993816120631998], // 50000
    [993925002675180, 993925003250044], // 574864
    [993931481098384, 993931642127483], // 161029099
    [994099638556107, 994099825386297], // 186830190
    [994107246335719, 994107246385719], // 50000
    [994107246385719, 994107246435719], // 50000
    [994136376723155, 994136376773155], // 50000
    [994182374077847, 994182374927847], // 850000
    [994200000058737, 994200012323847], // 12265110
    [994219708060000, 994219715537107], // 7477107
    [994320901387994, 994320901437994], // 50000
    [994322327863476, 994322327873476], // 10000
    [994498834986917, 994498835036917], // 50000
    [994540025671390, 994540075671390], // 50000000
    [994540603821390, 994540828833815], // 225012425
    [994543092083815, 994543093083815], // 1000000
    [994560099046493, 994560119781052], // 20734559
    [994560909092140, 994560909762140], // 670000
    [994628315519439, 994628344399439], // 28880000
    [994655166969898, 994655167019898], // 50000
    [994655167669897, 994655167669898], // 1
    [994668708085481, 994668708585481], // 500000
    [994697708430722, 994697708480722], // 50000
    [994754521707501, 994754521757501], // 50000
    [994849377338601, 994849379867601], // 2529000
    [994849579867601, 994849581677001], // 1809400
    [994963072192086, 994963153634416], // 81442330
    [995030184459992, 995030290459992], // 106000000
    [995030428781992, 995030870681992], // 441900000
    [995033827849847, 995033979756787], // 151906940
    [995034014670028, 995034015869228], // 1199200
    [995034065378428, 995034070152028], // 4773600
    [995158270034534, 995158372450934], // 102416400
    [995193619585843, 995193717725844], // 98140001
    [995315011303316, 995315054853316], // 43550000
    [995316189979600, 995316627979600], // 438000000
    [995330270000000, 995330365438783], // 95438783
    [995390803567794, 995390803725921], // 158127
    [995425716070000, 995425716120000], // 50000
    [995452557210273, 995452606760273], // 49550000
    [995483460336700, 995483537191700], // 76855000
    [995489948398202, 995490000000000], // 51601798
    [995502652727543, 995502684585213], // 31857670
    [995619927702000, 995619977707800], // 50005800
    [995943519719449, 995943519769449], // 50000
    [995974323847392, 995974603264342], // 279416950
    [995974653321647, 995974690417392], // 37095745
    [996035783197203, 996035794218633], // 11021430
    [996037572871014, 996037582871014], // 10000000
    [996054997669992, 996054997752500], // 82508
    [996073762854862, 996074602910000], // 840055138
    [996092345092132, 996092480245474], // 135153342
    [996112160131084, 996112160159462], // 28378
    [996153137504000, 996153177004000], // 39500000
    [996477951836483, 996477960520000], // 8683517
    [996937323518005, 996937323568005], // 50000
    [996950223870557, 996950223920557], // 50000
    [996979944684606, 996979944884606], // 200000
    [997316061207049, 997316061257049], // 50000
    [997729912364976, 997729912414976], // 50000
    [997760437845983, 997760437855983], // 10000
    [997795263662431, 997795287855911], // 24193480
    [997966482638929, 997966482688929], // 50000
    [997987725265119, 997987725315119], // 50000
    [998075003859013, 998075003909013], // 50000
    [998255029415180, 998255029465180], // 50000
    [998255267797840, 998255267847840], // 50000
    [998255330373390, 998255330423390], // 50000
    [998255330423390, 998255330473390], // 50000
    [998255330473390, 998255330523390], // 50000
    [998275329385464, 998275329535464], // 150000
    [998448360352610, 998448360402610], // 50000
    [998528181358390, 998528181408390], // 50000
    [998535069320846, 998535069370846], // 50000
    [998571201590000, 998571210000000], // 8410000
    [998753248960331, 998753251624046], // 2663715
    [998759491707312, 998759491757312], // 50000
    [998877443483653, 998877445416902], // 1933249
    [998952574242069, 998952577192067], // 2949998
    [999195001000000, 999195001872297], // 872297
    [999834901863905, 999835000000000], // 98136095
    [999956187264857, 999956188936465], // 1671608
    [1000326385227468, 1000326396029312], // 10801844
    [1001745960000000, 1001746059670000], // 99670000
    [1002702018583631, 1002702018583696], // 65
    [1002772035800753, 1002773879389056], // 1843588303
    [1002852570723369, 1002852601065242], // 30341873
    [1002885181245443, 1002885198232422], // 16986979
    [1004242339593000, 1004243898150000] // 1558557000
]

export function isHitman(num) {
    return hitmanRanges.some(([start, end]) => num >= start && num <= end);
}